<script setup>
const props = defineProps({
  name: String,
  color: {
    type: String,
    default: '#000000',
  },
  color1: {
    type: String,
    default: '#0B0E12D9',
  },
  size: {
    type: Number,
    default: 24,
  },
  secColorOne: String,
  radius: String,
  secColorTwo: String,
  secColorThree: String,
  secColorFour: String,
  isBadge: {
    required: false,
    default: false,
    type: Boolean,
  },
  badgeStatus: {
    required: false,
    default: 'error',
    type: String,
  },
  badgeColor: {
    required: false,
    type: String,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <!-- :style="{width: `${size}px`, height: `${size}px`}" -->
  <div :class="[rounded ? 'rounded' : 'icon-component']">
    <div
      v-if="isBadge"
      id="badge"
      :style="{ backgroundColor: badgeColor }"
      :class="`badge_${badgeStatus}`"
    ></div>
    <svg
      v-if="name == 'flight_time'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4615 5.84615V10.4615H14.3077M18.8886 9.6923C18.5 5.37961 14.8754 2 10.4615 2C5.78835 2 2 5.78835 2 10.4615C2 12.1643 2.50296 13.7496 3.36841 15.0769M7.05303 15.4384L8.65547 14.8993C8.76132 14.8674 8.87457 14.8698 8.97897 14.9062C9.08335 14.9426 9.17352 15.0112 9.23651 15.1021L10.3518 16.7621L16.4169 13.6512C16.8909 13.3636 17.4218 13.1827 17.9729 13.1211C18.524 13.0596 19.0818 13.1189 19.6075 13.2949C20.1334 13.4709 20.6145 13.7594 21.0174 14.1403C21.4203 14.5212 21.7354 14.9853 21.9406 15.5004C21.9868 15.6295 22.0065 15.7667 21.9981 15.9035C21.9898 16.0404 21.954 16.1742 21.8926 16.2968C21.8312 16.4195 21.7457 16.5284 21.6411 16.6171C21.5365 16.7057 21.4149 16.7723 21.284 16.8128L17.2908 18.1795L16.9798 18.3514L16.2681 20.9611C16.2419 21.0506 16.1953 21.1328 16.1318 21.2012C16.0684 21.2695 15.9899 21.3221 15.9025 21.3549L14.0869 21.9631C13.9938 21.9989 13.8927 22.0089 13.7943 21.992C13.6959 21.9751 13.604 21.932 13.5281 21.8671C13.4522 21.8023 13.3953 21.718 13.3633 21.6235C13.3314 21.5289 13.3256 21.4275 13.3465 21.3298L13.6514 19.494L13.3914 19.576L9.4834 20.9041C9.22952 20.9957 8.94989 20.984 8.70457 20.8715C8.45923 20.7592 8.26777 20.5551 8.17129 20.3031L6.73098 16.0625C6.69766 15.9371 6.71217 15.8037 6.77168 15.6884C6.8312 15.573 6.93149 15.4839 7.05303 15.4384Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'undo'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M7 19v-2h7.1q1.575 0 2.738-1T18 13.5T16.838 11T14.1 10H7.8l2.6 2.6L9 14L4 9l5-5l1.4 1.4L7.8 8h6.3q2.425 0 4.163 1.575T20 13.5t-1.737 3.925T14.1 19z"
      />
    </svg>
    <svg
      v-else-if="name === 'parachute'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <!-- Icon from Material Design Icons by Pictogrammers - https://github.com/Templarian/MaterialDesign/blob/master/LICENSE -->
      <path
        :fill="color"
        d="M21.2 10.95L12 23L2.78 10.96l.09-.08c.21-.21.46-.38.71-.52l7.15 9.33L8.58 13l.66-1.19L12 20.38l2.73-8.58l.67 1.2l-2.13 6.69l7.14-9.34c.25.15.49.29.69.5zM5 9c1.5 0 2.81.86 3.5 2.1A3.97 3.97 0 0 1 12 9c1.5 0 2.8.85 3.5 2.09A3.93 3.93 0 0 1 19 9c1.09 0 2.09.42 2.81 1.14C20.94 5.5 16.88 2 12 2c-4.91 0-8.97 3.5-9.84 8.17C2.89 9.45 3.89 9 5 9"
      />
    </svg>
    <svg
      v-else-if="name === 'dock-cam'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1 6.5V2C1 1.44772 1.44772 1 2 1H6.5M1 17.5V22C1 22.5523 1.44772 23 2 23H6.5M17.5 23H22C22.5523 23 23 22.5523 23 22V17.5M23 6.5V2C23 1.44772 22.5523 1 22 1H17.5M18.2677 8.57895L15.2308 9.89474V8.05263C15.2308 7.77345 15.1173 7.50572 14.9153 7.30831C14.7134 7.11091 14.4395 7 14.1538 7H6.07692C5.7913 7 5.51739 7.11091 5.31542 7.30831C5.11346 7.50572 5 7.77345 5 8.05263V15.9474C5 16.2265 5.11346 16.4943 5.31542 16.6917C5.51739 16.8891 5.7913 17 6.07692 17H14.1538C14.4395 17 14.7134 16.8891 14.9153 16.6917C15.1173 16.4943 15.2308 16.2265 15.2308 15.9474V14.1053L18.2677 15.4211C18.3495 15.4519 18.4379 15.4628 18.5251 15.4526C18.6122 15.4425 18.6955 15.4118 18.7677 15.3629C18.8398 15.3142 18.8988 15.2489 18.9392 15.1728C18.9797 15.0967 19.0006 15.0121 19 14.9263V9.07368C19.0006 8.98791 18.9797 8.90327 18.9392 8.82717C18.8988 8.75106 18.8398 8.68578 18.7677 8.63701C18.6955 8.58823 18.6122 8.55745 18.5251 8.54733C18.4379 8.53721 18.3495 8.54806 18.2677 8.57895Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'puzzle'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 15.0788C21.9995 14.5391 21.8569 14.0091 21.5867 13.5419C21.3163 13.0747 20.9279 12.6868 20.4602 12.4172C19.9925 12.1476 19.4622 12.0057 18.9224 12.0059C18.3825 12.006 17.8521 12.1482 17.3846 12.418V8.15762C17.3846 7.74971 17.2225 7.35849 16.934 7.07006C16.6455 6.78162 16.2542 6.61958 15.8462 6.61958H11.5846C11.8559 6.15205 11.9992 5.62131 12 5.0808C12.0009 4.54031 11.8592 4.00914 11.5894 3.54077C11.3195 3.0724 10.931 2.68339 10.4629 2.4129C9.99484 2.14242 9.46374 2 8.92309 2C8.38244 2 7.85135 2.14242 7.38326 2.4129C6.91518 2.68339 6.52666 3.0724 6.25681 3.54077C5.98697 4.00914 5.84533 4.54031 5.84616 5.0808C5.84699 5.62131 5.99026 6.15205 6.26155 6.61958H3.53847C3.13043 6.61958 2.73912 6.78162 2.45061 7.07006C2.16209 7.35849 2 7.74971 2 8.15762V11.326C2.2517 11.264 2.51002 11.233 2.76923 11.2337C3.58528 11.2337 4.36791 11.5578 4.94495 12.1347C5.52198 12.7116 5.84616 13.494 5.84616 14.3098C5.84616 15.1256 5.52198 15.908 4.94495 16.4849C4.36791 17.0618 3.58528 17.3858 2.76923 17.3858C2.51002 17.3865 2.2517 17.3555 2 17.2935V20.462C2 20.8698 2.16209 21.2611 2.45061 21.5495C2.73912 21.838 3.13043 22 3.53847 22H7.47693C7.41498 21.7483 7.38397 21.4902 7.38463 21.2309C7.38463 20.4151 7.7088 19.6328 8.28583 19.0558C8.86287 18.4789 9.6455 18.1549 10.4616 18.1549C11.2776 18.1549 12.0602 18.4789 12.6373 19.0558C13.2143 19.6328 13.5385 20.4151 13.5385 21.2309C13.5391 21.4902 13.5081 21.7483 13.4462 22H15.8462C16.2542 22 16.6455 21.838 16.934 21.5495C17.2225 21.2611 17.3846 20.8698 17.3846 20.462V17.7397C17.8521 18.0095 18.3825 18.1515 18.9224 18.1517C19.4622 18.1518 19.9925 18.01 20.4602 17.7405C20.9279 17.4708 21.3163 17.0829 21.5867 16.6157C21.8569 16.1486 21.9995 15.6185 22 15.0788Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'search'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      :fill="color"
      viewBox="0 0 16 16"
    >
      <path
        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
      />
    </svg>
    <svg
      v-else-if="name === 'clouds'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M6.5 20q-2.275 0-3.887-1.575T1 14.575q0-1.95 1.175-3.475T5.25 9.15q.625-2.3 2.5-3.725T12 4q2.925 0 4.963 2.038T19 11q1.725.2 2.863 1.488T23 15.5q0 1.875-1.312 3.188T18.5 20zm0-2h12q1.05 0 1.775-.725T21 15.5t-.725-1.775T18.5 13H17v-2q0-2.075-1.463-3.538T12 6T8.463 7.463T7 11h-.5q-1.45 0-2.475 1.025T3 14.5t1.025 2.475T6.5 18m5.5-6"
      />
    </svg>
    <svg
      v-else-if="name === 'navigation'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.6269 8.42093L4.11675 3.04197C3.8118 2.94261 3.47681 3.02278 3.25 3.24938C3.01475 3.48443 2.93791 3.83478 3.05324 4.14658L9.15938 20.6545C9.23619 20.8621 9.4343 21 9.65584 21C9.88632 21 10.0903 20.8509 10.1602 20.6315L12.4735 13.3675C12.6092 12.9413 12.9271 12.5971 13.3414 12.4278L20.6639 9.43487C20.8672 9.35179 21 9.15414 21 8.9347C21 8.70079 20.8493 8.49344 20.6269 8.42093Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'share'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.5 6L9.14107 7.99999M8.00001 11.8005L13.5 17.25M6.18429 12.3686C7.94293 12.3686 9.36858 10.9429 9.36858 9.18429C9.36858 7.42565 7.94293 6 6.18429 6C4.42566 6 3.00001 7.42565 3.00001 9.18429C3.00001 10.9429 4.42566 12.3686 6.18429 12.3686ZM15.75 21C16.9927 21 18 19.9927 18 18.75C18 17.5074 16.9927 16.5 15.75 16.5C14.5073 16.5 13.5 17.5074 13.5 18.75C13.5 19.9927 14.5073 21 15.75 21ZM18.75 7.5C19.9927 7.5 21 6.49264 21 5.25C21 4.00736 19.9927 3 18.75 3C17.5073 3 16.5 4.00736 16.5 5.25C16.5 6.49264 17.5073 7.5 18.75 7.5Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'support-icon'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 156 156"
      fill="none"
    >
      <path
        d="M8 77C8 53.2517 29.938 34 57 34C84.062 34 106 53.2517 106 77C106 100.748 84.062 120 57 120C47.4839 120 38.6013 117.619 31.0835 113.5C31.0835 113.5 19.8109 118.5 13.5 122C16.5 115 19.8109 105 19.8109 105C12.4488 97.4768 8 87.6943 8 77Z"
        fill="#767575"
        fill-opacity="0.8"
      />
      <path
        d="M148 78C148 101.748 126.062 121 99 121C71.938 121 50 101.748 50 78C50 54.2518 71.938 35 99 35C108.516 35 117.399 37.3806 124.917 41.5C124.917 41.5 136.189 36.5 142.5 33C139.5 39.9999 136.189 50 136.189 50C143.551 57.5232 148 67.3057 148 78Z"
        fill="#3D9ED8"
        fill-opacity="0.8"
      />
    </svg>
    <svg
      v-else-if="name === 'bound-square'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.8333 3.66667H6.16667M3.66667 6.16667V17.8333M6.16667 20.3333H17.8333M20.3334 17.8333V6.16667M5.33333 3.66667C5.33333 4.58714 4.58714 5.33333 3.66667 5.33333C2.74619 5.33333 2 4.58714 2 3.66667C2 2.74619 2.74619 2 3.66667 2C4.58714 2 5.33333 2.74619 5.33333 3.66667ZM5.33333 20.3333C5.33333 21.2538 4.58714 22 3.66667 22C2.74619 22 2 21.2538 2 20.3333C2 19.4129 2.74619 18.6667 3.66667 18.6667C4.58714 18.6667 5.33333 19.4129 5.33333 20.3333ZM22 20.3333C22 21.2538 21.2538 22 20.3333 22C19.4129 22 18.6667 21.2538 18.6667 20.3333C18.6667 19.4129 19.4129 18.6667 20.3333 18.6667C21.2538 18.6667 22 19.4129 22 20.3333ZM22 3.66667C22 4.58714 21.2538 5.33333 20.3333 5.33333C19.4129 5.33333 18.6667 4.58714 18.6667 3.66667C18.6667 2.74619 19.4129 2 20.3333 2C21.2538 2 22 2.74619 22 3.66667Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-else-if="name === 'bound-circle'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.3345 14.0098C19.5957 17.0849 17.1991 19.5148 14.1429 20.3014M9.85718 20.3014C6.80091 19.5148 4.40434 17.0849 3.66549 14.0098M3.66549 9.99025C4.40434 6.91511 6.80091 4.48522 9.85718 3.6986M14.1429 3.6986C17.1991 4.48522 19.5957 6.91511 20.3345 9.99025M4.85714 12C4.85714 12.789 4.21755 13.4286 3.42857 13.4286C2.63959 13.4286 2 12.789 2 12C2 11.211 2.63959 10.5714 3.42857 10.5714C4.21755 10.5714 4.85714 11.211 4.85714 12ZM12 4.85714C11.211 4.85714 10.5714 4.21755 10.5714 3.42857C10.5714 2.63959 11.211 2 12 2C12.789 2 13.4286 2.63959 13.4286 3.42857C13.4286 4.21755 12.789 4.85714 12 4.85714ZM22 12C22 12.789 21.3604 13.4286 20.5714 13.4286C19.7825 13.4286 19.1429 12.789 19.1429 12C19.1429 11.211 19.7825 10.5714 20.5714 10.5714C21.3604 10.5714 22 11.211 22 12ZM12 22C11.211 22 10.5714 21.3604 10.5714 20.5714C10.5714 19.7825 11.211 19.1429 12 19.1429C12.789 19.1429 13.4286 19.7825 13.4286 20.5714C13.4286 21.3604 12.789 22 12 22Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-else-if="name == 'spiral'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.78329 2.80409C5.18535 2.53606 6.39151 2 7.99974 2C9.60796 2 10.8141 2.53606 11.2162 2.80409M6.39125 4.46869C6.65929 4.33468 7.35619 4.06665 7.99947 4.06665C8.64276 4.06665 9.33966 4.33468 9.6077 4.46869M13.1959 5C13.4639 5.40205 14 6.60822 14 8.21645C14 9.82467 13.4639 11.0308 13.1959 11.4329M11.5313 6.60796C11.6653 6.876 11.9334 7.5729 11.9334 8.21618C11.9334 8.85947 11.6653 9.55637 11.5313 9.82441M2.80409 5C2.53606 5.40205 2 6.60822 2 8.21645C2 9.82467 2.53606 11.0308 2.80409 11.4329M4.46869 6.60796C4.33468 6.876 4.06665 7.5729 4.06665 8.21618C4.06665 8.85947 4.33468 9.55637 4.46869 9.82441M4.78355 13.1959C5.1856 13.4639 6.39177 14 8 14C9.60822 14 10.8144 13.4639 11.2165 13.1959M6.39151 11.5313C6.65955 11.6653 7.35645 11.9334 7.99973 11.9334C8.64302 11.9334 9.33992 11.6653 9.60796 11.5313M9.8 8C9.8 8.99411 8.99411 9.8 8 9.8C7.00589 9.8 6.2 8.99411 6.2 8C6.2 7.00589 7.00589 6.2 8 6.2C8.99411 6.2 9.8 7.00589 9.8 8Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'hamburger_menu'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 5H2M22 12H2M22 19H2"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'kebab_menu'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.5 6C12.3284 6 13 5.32843 13 4.5C13 3.67157 12.3284 3 11.5 3C10.6716 3 10 3.67157 10 4.5C10 5.32843 10.6716 6 11.5 6Z"
        :fill="color"
      />
      <path
        d="M11.5 13.5C12.3284 13.5 13 12.8284 13 12C13 11.1716 12.3284 10.5 11.5 10.5C10.6716 10.5 10 11.1716 10 12C10 12.8284 10.6716 13.5 11.5 13.5Z"
        :fill="color"
      />
      <path
        d="M11.5 21C12.3284 21 13 20.3284 13 19.5C13 18.6716 12.3284 18 11.5 18C10.6716 18 10 18.6716 10 19.5C10 20.3284 10.6716 21 11.5 21Z"
        :fill="color"
      />
    </svg>
    <svg
      v-else-if="name == 'joy_stick'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 12.8333L3.66667 12.8332M14.5 16.1667V10.3333M14.5 10.3333C13.9528 10.3333 13.411 10.2256 12.9055 10.0162C12.4 9.80677 11.9406 9.49986 11.5537 9.11294C11.1668 8.72603 10.8599 8.26671 10.6505 7.76118C10.4411 7.25566 10.3333 6.71384 10.3333 6.16667C10.3333 5.61949 10.4411 5.07768 10.6505 4.57215C10.8599 4.06663 11.1668 3.6073 11.5537 3.22039C11.9406 2.83348 12.4 2.52656 12.9055 2.31717C13.411 2.10777 13.9528 2 14.5 2C15.0472 2 15.589 2.10777 16.0945 2.31717C16.6 2.52656 17.0594 2.83348 17.4463 3.22039C17.8332 3.6073 18.1401 4.06663 18.3495 4.57215C18.5589 5.07768 18.6667 5.61949 18.6667 6.16667C18.6667 6.71384 18.5589 7.25566 18.3495 7.76118C18.1401 8.26671 17.8332 8.72603 17.4463 9.11294C17.0594 9.49986 16.6 9.80677 16.0945 10.0162C15.589 10.2256 15.0472 10.3333 14.5 10.3333ZM2 20.3333V17.8333C2 16.9129 2.7462 16.1667 3.66667 16.1667H20.3333C21.2538 16.1667 22 16.9129 22 17.8333V20.3333C22 21.2538 21.2538 22 20.3333 22H3.66667C2.7462 22 2 21.2538 2 20.3333Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'layers'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12.5813L12.6667 17.2655C12.4495 17.3645 12.2136 17.4159 11.975 17.4159C11.7363 17.4159 11.5005 17.3645 11.2833 17.2655L2 12.5813M22 17.1655L12.6667 21.8496C12.4495 21.9487 12.2136 22 11.975 22C11.7363 22 11.5005 21.9487 11.2833 21.8496L2 17.1655M12.7255 12.6646C12.4966 12.772 12.2496 12.8274 12 12.8274C11.7504 12.8274 11.5034 12.772 11.2744 12.6646L2.47518 8.26384C2.33228 8.18603 2.21222 8.0669 2.12832 7.91975C2.04442 7.77259 2 7.60317 2 7.43036C2 7.25755 2.04442 7.08813 2.12832 6.94097C2.21222 6.79383 2.33228 6.67471 2.47518 6.59688L11.2744 2.16276C11.5034 2.05539 11.7504 2 12 2C12.2496 2 12.4966 2.05539 12.7255 2.16276L21.5248 6.56354C21.6677 6.64137 21.7878 6.76049 21.8717 6.90763C21.9555 7.05479 22 7.22421 22 7.39702C22 7.56983 21.9555 7.73925 21.8717 7.88641C21.7878 8.03357 21.6677 8.15269 21.5248 8.2305L12.7255 12.6646Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'copy'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      :fill="color"
      class="bi bi-copy"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
      />
    </svg>
    <svg
      v-else-if="name == 'cog_wheel'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.97922 2.98462L9.33076 4.69231L7.09882 5.98462L5.31931 5.70769C5.02299 5.66666 4.72142 5.71642 4.4529 5.85065C4.18437 5.98488 3.96103 6.19751 3.81125 6.46154L3.20802 7.53846C3.05344 7.80669 2.98222 8.11643 3.00377 8.4268C3.0253 8.73717 3.13859 9.03358 3.32867 9.27692L4.45971 10.7077V13.2923L3.35883 14.7231C3.16875 14.9664 3.05547 15.2628 3.03393 15.5732C3.01238 15.8836 3.08361 16.1933 3.23818 16.4615L3.84141 17.5385C3.99119 17.8025 4.21453 18.0151 4.48306 18.1494C4.75158 18.2835 5.05315 18.3334 5.34947 18.2923L7.12898 18.0154L9.33076 19.3077L9.97922 21.0154C10.0886 21.3045 10.281 21.5532 10.5312 21.7289C10.7815 21.9046 11.0779 21.9991 11.3817 22H12.6485C12.9523 21.9991 13.2487 21.9046 13.499 21.7289C13.7492 21.5532 13.9416 21.3045 14.051 21.0154L14.6995 19.3077L16.9012 18.0154L18.6807 18.2923C18.9771 18.3334 19.2787 18.2835 19.5471 18.1494C19.8157 18.0151 20.0391 17.8025 20.1888 17.5385L20.792 16.4615C20.9466 16.1933 21.0178 15.8836 20.9962 15.5732C20.9748 15.2628 20.8614 14.9664 20.6714 14.7231L19.5403 13.2923V10.7077L20.6412 9.27692C20.8312 9.03358 20.9446 8.73717 20.9661 8.4268C20.9876 8.11643 20.9164 7.80669 20.7619 7.53846L20.1586 6.46154C20.0089 6.19751 19.7856 5.98488 19.517 5.85065C19.2485 5.71642 18.9469 5.66666 18.6506 5.70769L16.8711 5.98462L14.6693 4.69231L14.0208 2.98462C13.9115 2.69548 13.7191 2.44679 13.4688 2.2711C13.2185 2.09541 12.9221 2.00092 12.6183 2H11.3817C11.0779 2.00092 10.7815 2.09541 10.5312 2.2711C10.281 2.44679 10.0886 2.69548 9.97922 2.98462Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.49221 13.7094C9.1608 13.2034 8.9839 12.6086 8.9839 12C8.9839 11.184 9.30166 10.4013 9.86731 9.82429C10.4329 9.24725 11.2001 8.92308 12 8.92308C12.5966 8.92308 13.1797 9.10354 13.6757 9.44163C14.1717 9.77972 14.5583 10.2603 14.7866 10.8225C15.0148 11.3848 15.0746 12.0034 14.9582 12.6003C14.8418 13.1971 14.5546 13.7454 14.1327 14.1757C13.7109 14.606 13.1735 14.8991 12.5884 15.0178C12.0034 15.1365 11.3969 15.0756 10.8458 14.8427C10.2947 14.6098 9.82362 14.2154 9.49221 13.7094Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'user'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5.43074 19.5385C6.11726 18.4115 7.08214 17.4802 8.2326 16.834C9.38306 16.1877 10.6804 15.8482 12 15.8482C13.3195 15.8482 14.6169 16.1877 15.7673 16.834C16.9178 17.4802 17.8826 18.4115 18.5692 19.5385M12 13.5385C14.1242 13.5385 15.8462 11.8165 15.8462 9.69231C15.8462 7.56814 14.1242 5.84615 12 5.84615C9.87583 5.84615 8.15385 7.56814 8.15385 9.69231C8.15385 11.8165 9.87583 13.5385 12 13.5385ZM12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'rc_controller'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8.5L12.0484 7.50117L12 7.49883L11.9516 7.50117L12 8.5ZM2.42568 18.3068L3.42254 18.2277L2.42568 18.3068ZM21.5743 18.3068L20.5775 18.2277V18.2277L21.5743 18.3068ZM21.9876 13.0966L22.9845 13.1757L21.9876 13.0966ZM18.0807 8.79482L18.1292 7.79599L18.0807 8.79482ZM2.01237 13.0966L1.0155 13.1757L2.01237 13.0966ZM5.91926 8.79482L5.87084 7.79599L5.91926 8.79482ZM13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13H13ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16H11ZM5.81243 17.5C5.26015 17.5 4.81243 17.9477 4.81243 18.5C4.81243 19.0523 5.26015 19.5 5.81243 19.5V17.5ZM7.87496 19.5C8.42724 19.5 8.87496 19.0523 8.87496 18.5C8.87496 17.9477 8.42724 17.5 7.87496 17.5V19.5ZM16.125 17.5C15.5728 17.5 15.125 17.9477 15.125 18.5C15.125 19.0523 15.5728 19.5 16.125 19.5V17.5ZM18.1876 19.5C18.7398 19.5 19.1876 19.0523 19.1876 18.5C19.1876 17.9477 18.7398 17.5 18.1876 17.5V19.5ZM6.30079 2.44043C5.83699 2.74026 5.70406 3.35932 6.0039 3.82313C6.30373 4.28693 6.92279 4.41986 7.38659 4.12002L6.30079 2.44043ZM16.8628 4.12004C17.3266 4.41986 17.9456 4.28692 18.2455 3.82311C18.5453 3.35929 18.4124 2.74024 17.9485 2.44042L16.8628 4.12004ZM9.04746 5.03069C8.55051 5.27163 8.34296 5.86981 8.5839 6.36677C8.82484 6.86373 9.42302 7.07127 9.91998 6.83033L9.04746 5.03069ZM14.3284 6.83033C14.8254 7.07127 15.4236 6.86373 15.6645 6.36677C15.9055 5.86981 15.6979 5.27163 15.2009 5.03069L14.3284 6.83033ZM20.9908 13.0175L20.5775 18.2277L22.5712 18.3859L22.9845 13.1757L20.9908 13.0175ZM17.4614 21H6.53857V23H17.4614V21ZM3.42254 18.2277L3.00923 13.0175L1.0155 13.1757L1.42881 18.3859L3.42254 18.2277ZM5.96769 9.79365L12.0484 9.49883L11.9516 7.50117L5.87084 7.79599L5.96769 9.79365ZM11.9516 9.49883L18.0323 9.79365L18.1292 7.79599L12.0484 7.50117L11.9516 9.49883ZM6.53857 21C4.87886 21 3.5446 19.7663 3.42254 18.2277L1.42881 18.3859C1.63739 21.0152 3.88731 23 6.53857 23V21ZM20.5775 18.2277C20.4554 19.7663 19.1211 21 17.4614 21V23C20.1127 23 22.3626 21.0152 22.5712 18.3859L20.5775 18.2277ZM22.9845 13.1757C23.2095 10.3388 20.9811 7.93427 18.1292 7.79599L18.0323 9.79365C19.8176 9.88021 21.1218 11.3654 20.9908 13.0175L22.9845 13.1757ZM3.00923 13.0175C2.87817 11.3654 4.1824 9.88021 5.96769 9.79365L5.87084 7.79599C3.01889 7.93427 0.790455 10.3388 1.0155 13.1757L3.00923 13.0175ZM7.90622 14C7.90622 14.5235 7.45975 15 6.84369 15V17C8.50584 17 9.90622 15.6856 9.90622 14H7.90622ZM6.84369 15C6.22764 15 5.78117 14.5235 5.78117 14H3.78117C3.78117 15.6856 5.18155 17 6.84369 17V15ZM5.78117 14C5.78117 13.4765 6.22764 13 6.84369 13V11C5.18155 11 3.78117 12.3144 3.78117 14H5.78117ZM6.84369 13C7.45975 13 7.90622 13.4765 7.90622 14H9.90622C9.90622 12.3144 8.50584 11 6.84369 11V13ZM18.2188 14C18.2188 14.5235 17.7724 15 17.1563 15V17C18.8184 17 20.2188 15.6856 20.2188 14H18.2188ZM17.1563 15C16.5402 15 16.0938 14.5235 16.0938 14H14.0938C14.0938 15.6856 15.4942 17 17.1563 17V15ZM16.0938 14C16.0938 13.4765 16.5402 13 17.1563 13V11C15.4942 11 14.0938 12.3144 14.0938 14H16.0938ZM17.1563 13C17.7724 13 18.2188 13.4765 18.2188 14H20.2188C20.2188 12.3144 18.8184 11 17.1563 11V13ZM11 13V16H13V13H11ZM5.81243 19.5H7.87496V17.5H5.81243V19.5ZM16.125 19.5H18.1876V17.5H16.125V19.5ZM7.38659 4.12002C7.88362 3.79871 9.6752 3 12.1247 3V1C9.29315 1 7.124 1.90825 6.30079 2.44043L7.38659 4.12002ZM12.1247 3C14.5741 3 16.3657 3.79871 16.8628 4.12004L17.9485 2.44042C17.1253 1.90826 14.9562 1 12.1247 1V3ZM9.91998 6.83033C10.2909 6.65052 11.279 6.29041 12.1242 6.29041V4.29041C10.857 4.29041 9.55674 4.78378 9.04746 5.03069L9.91998 6.83033ZM12.1242 6.29041C12.9694 6.29041 13.9576 6.65052 14.3284 6.83033L15.2009 5.03069C14.6917 4.78378 13.3914 4.29041 12.1242 4.29041V6.29041Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'wireless_controller'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.63882 3.34015C7.3089 2.89343 9.31918 2 11.9996 2C14.6799 2 16.6902 2.89343 17.3603 3.34015M9.31875 6.11448C9.76548 5.89113 10.927 5.44442 11.9991 5.44442C13.0713 5.44442 14.2328 5.89113 14.6795 6.11448M8.08336 12.4167V16.2682M10.0089 14.3425H6.15727M2.62216 13.5486L2.02489 18.0702C1.77174 20.1633 3.48179 22 5.68382 22C7.08956 22 8.37273 21.2343 8.99135 20.0265L9.58835 18.8608H14.4116L15.0086 20.0265C15.6272 21.2343 16.9104 22 18.3162 22C20.5183 22 22.2281 20.1633 21.9751 18.0702L21.3778 13.5486C21.0728 11.0264 18.8407 9.12342 16.1873 9.12342H7.8127C5.1593 9.12342 2.9272 11.0264 2.62216 13.5486ZM16.9436 13.242C16.7156 13.242 16.5309 13.0572 16.5309 12.8293C16.5309 12.6014 16.7156 12.4167 16.9436 12.4167C17.1715 12.4167 17.3562 12.6014 17.3562 12.8293C17.3562 13.0572 17.1715 13.242 16.9436 13.242ZM14.0551 15.3053C14.0551 15.0774 14.2399 14.8927 14.4678 14.8927C14.6957 14.8927 14.8804 15.0774 14.8804 15.3053C14.8804 15.5332 14.6957 15.7178 14.4678 15.7178C14.2399 15.7178 14.0551 15.5332 14.0551 15.3053Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'battery'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.84615 8.88889V15.1111M10.4615 8.88889V15.1111M15.0769 8.88889V15.1111M22 9.27778C22 9.0715 21.9189 8.87366 21.7748 8.72781C21.6305 8.58195 21.4348 8.5 21.2308 8.5H18.9231V6.55556C18.9231 6.14299 18.7609 5.74734 18.4725 5.45561C18.184 5.16389 17.7926 5 17.3846 5H3.53846C3.13043 5 2.73912 5.16389 2.4506 5.45561C2.16209 5.74734 2 6.14299 2 6.55556V17.4444C2 17.857 2.16209 18.2527 2.4506 18.5444C2.73912 18.836 3.13043 19 3.53846 19H17.3846C17.7926 19 18.184 18.836 18.4725 18.5444C18.7609 18.2527 18.9231 17.857 18.9231 17.4444V15.5H21.2308C21.4348 15.5 21.6305 15.4181 21.7748 15.2722C21.9189 15.1263 22 14.9285 22 14.7222V9.27778Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'battery_alt'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.89809 5.92609V10.0742M6.97501 5.92609V10.0742M10.0519 5.92609V10.0742M14.6673 6.18535C14.6673 6.04783 14.6133 5.91594 14.5172 5.8187C14.421 5.72146 14.2905 5.66683 14.1545 5.66683H12.616V4.37053C12.616 4.09549 12.5079 3.83172 12.3156 3.63723C12.1233 3.44276 11.8624 3.3335 11.5904 3.3335H2.35963C2.0876 3.3335 1.82673 3.44276 1.63439 3.63723C1.44204 3.83172 1.33398 4.09549 1.33398 4.37053V11.6298C1.33398 11.9048 1.44204 12.1686 1.63439 12.3631C1.82673 12.5575 2.0876 12.6668 2.35963 12.6668H11.5904C11.8624 12.6668 12.1233 12.5575 12.3156 12.3631C12.5079 12.1686 12.616 11.9048 12.616 11.6298V10.3335H14.1545C14.2905 10.3335 14.421 10.2789 14.5172 10.1816C14.6133 10.0844 14.6673 9.9525 14.6673 9.81498V6.18535Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'signal_bad'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="17.3333" width="3.78947" height="2.66667" fill="#606366" />
      <rect x="7.73682" y="12.8889" width="3.78947" height="7.11111" fill="#606366" />
      <rect x="12.4737" y="8.44446" width="3.78947" height="11.5556" fill="#606366" />
      <rect x="17.2105" y="4" width="3.78947" height="16" fill="#606366" />
      <g clip-path="url(#clip0_4984_8009)">
        <path
          d="M18.5 21C20.433 21 22 19.433 22 17.5C22 15.567 20.433 14 18.5 14C16.567 14 15 15.567 15 17.5C15 19.433 16.567 21 18.5 21Z"
          fill="#F6A60C"
        />
        <path
          d="M18.5 19.5C18.2239 19.5 18 19.2761 18 19C18 18.7239 18.2239 18.5 18.5 18.5"
          fill="#0B0E12"
        />
        <path
          d="M18.5 19.5C18.7761 19.5 19 19.2761 19 19C19 18.7239 18.7761 18.5 18.5 18.5"
          fill="#0B0E12"
        />
        <path d="M18.5 16L18.5 17.5L18.5 16Z" fill="#0B0E12" />
        <path
          d="M18.5 16L18.5 17.5"
          stroke="#0B0E12"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4984_8009">
          <rect width="7" height="7" fill="white" transform="translate(15 14)" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name == 'signal_good'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="17.3333" width="3.78947" height="2.66667" fill="#C2C3C4" />
      <rect x="7.73682" y="12.8889" width="3.78947" height="7.11111" fill="#C2C3C4" />
      <rect x="12.4736" y="8.44446" width="3.78947" height="11.5556" fill="#C2C3C4" />
      <rect x="17.2104" y="4" width="3.78947" height="16" fill="#C2C3C4" />
      <g clip-path="url(#clip0_3053_60268)">
        <path
          d="M18.5 21C20.433 21 22 19.433 22 17.5C22 15.567 20.433 14 18.5 14C16.567 14 15 15.567 15 17.5C15 19.433 16.567 21 18.5 21Z"
          fill="#087A00"
        />
        <g clip-path="url(#clip1_3053_60268)">
          <path
            d="M16.625 18.1555L17.5544 18.9893C17.6772 19.0994 17.8644 19.0834 17.9677 18.954L20.375 15.9375"
            stroke="white"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3053_60268">
          <rect width="7" height="7" fill="white" transform="translate(15 14)" />
        </clipPath>
        <clipPath id="clip1_3053_60268">
          <rect width="5" height="5" fill="white" transform="translate(16 15)" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name == 'signal_worst'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="17.3334" width="3.78947" height="2.66667" fill="#606366" />
      <rect x="7.73682" y="12.8889" width="3.78947" height="7.11111" fill="#606366" />
      <rect x="12.4737" y="8.44446" width="3.78947" height="11.5556" fill="#606366" />
      <rect x="17.2105" y="4" width="3.78947" height="16" fill="#606366" />
      <g clip-path="url(#clip0_3042_5960)">
        <path
          d="M18.5 21C20.433 21 22 19.433 22 17.5C22 15.567 20.433 14 18.5 14C16.567 14 15 15.567 15 17.5C15 19.433 16.567 21 18.5 21Z"
          fill="#AA2222"
        />
        <g clip-path="url(#clip1_3042_5960)">
          <path
            d="M20.0625 15.9375L16.9375 19.0625M16.9375 15.9375L20.0625 19.0625"
            stroke="white"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3042_5960">
          <rect width="7" height="7" fill="white" transform="translate(15 14)" />
        </clipPath>
        <clipPath id="clip1_3042_5960">
          <rect width="5" height="5" fill="white" transform="translate(16 15)" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="name == 'signal'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37635 13.2936C9.92978 10.8794 14.0697 10.8794 16.6231 13.2936M4.657 10.6171C8.71245 6.78292 15.2876 6.78292 19.3431 10.6172M2 7.8818C7.54142 2.70603 16.4586 2.70607 22 7.88191M12 20C13.2745 20 14.3077 19.0231 14.3077 17.8182C14.3077 16.6132 13.2745 15.6364 12 15.6364C10.7255 15.6364 9.69231 16.6132 9.69231 17.8182C9.69231 19.0231 10.7255 20 12 20Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'signal_alt'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.91822 8.86222C6.62051 7.25278 9.38046 7.25278 11.0827 8.86222M3.10532 7.07794C5.80895 4.52179 10.1924 4.52179 12.896 7.07795M1.33398 5.25437C5.02826 1.80386 10.9731 1.80388 14.6673 5.25444M8.00065 13.3332C8.85032 13.3332 9.53911 12.6819 9.53911 11.8786C9.53911 11.0753 8.85032 10.4241 8.00065 10.4241C7.15098 10.4241 6.46219 11.0753 6.46219 11.8786C6.46219 12.6819 7.15098 13.3332 8.00065 13.3332Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'wind_flow'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6.4C3.9272 5.44243 6.02008 4.89827 8.15385 4.8C11.2308 4.8 12.7692 7.2 15.8462 7.2C17.9798 7.10173 20.0728 6.55757 22 5.6L18.9231 4M2 12.8C3.9272 11.8424 6.02008 11.2983 8.15385 11.2C11.2308 11.2 12.7692 13.6 15.8462 13.6C17.9798 13.5017 20.0728 12.9576 22 12L18.9231 10.4M2 19.2C3.9272 18.2424 6.02008 17.6982 8.15385 17.6C11.2308 17.6 12.7692 20 15.8462 20C17.9798 19.9018 20.0728 19.3576 22 18.4L18.9231 16.8"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'double-circle'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      >
        <path d="M4 9.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0" />
        <path d="M9 14.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0" />
      </g>
    </svg>
    <svg
      v-else-if="name === 'zig-zag'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 14 14"
    >
      <path
        fill="none"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M11 .5L13.5 3h-12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H.5L3 13.5"
      />
    </svg>
    <svg
      v-else-if="name === 'vertical-split'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M11 22v-4.2l-1.6 1.6L8 18l4-4l4 4l-1.4 1.4l-1.6-1.6V22zm-7-9v-2h16v2zm8-3L8 6l1.4-1.4L11 6.2V2h2v4.2l1.6-1.6L16 6z"
      />
    </svg>
    <svg
      v-else-if="name === 'corridor'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 48 48"
    >
      <path
        :fill="color"
        fill-rule="evenodd"
        d="M6.056 40.001c-.062 1.103.84 2 1.944 2h14c1.105 0 1.989-.899 2.111-1.997a18 18 0 0 1 15.893-15.893C41.102 23.99 42 23.105 42 22.001V8c0-1.105-.896-2.007-1.999-1.945A36 36 0 0 0 6.056 40m30.957-24.363a27 27 0 0 1 2.213-.394l-.269-1.982a29 29 0 0 0-2.377.423zm-8.299 3.357a27 27 0 0 1 4.01-2.025l-.75-1.854a29 29 0 0 0-4.307 2.175zm-5.248 4.209a27 27 0 0 1 1.63-1.547l-1.315-1.507a29 29 0 0 0-3.358 3.463l1.547 1.268a27 27 0 0 1 1.496-1.677m-5.946 9.445a27 27 0 0 1 1.9-4.07l-1.735-.994a29 29 0 0 0-2.041 4.372zm-1.525 6.553q.118-1.122.325-2.224l-1.965-.372q-.224 1.183-.35 2.388z"
        clip-rule="evenodd"
      />
    </svg>
    <svg
      v-else-if="name == 'wind_speed'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.25H13.1538C14.6408 8.25 15.8462 7.07475 15.8462 5.625C15.8462 4.17525 14.6408 3 13.1538 3H12.7692M3.53846 15.75H12.3846C13.8715 15.75 15.0769 16.9253 15.0769 18.375C15.0769 19.8248 13.8715 21 12.3846 21H12M4.30769 12H19.3077C20.7946 12 22 13.1753 22 14.625C22 16.0748 20.7946 17.25 19.3077 17.25H18.9231"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'wind_speed_alt'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M2.66602 5.91667H9.35832C10.2505 5.91667 10.9737 5.26375 10.9737 4.45833C10.9737 3.65292 10.2505 3 9.35832 3H9.12755M3.58909 10.0833H8.89678C9.78894 10.0833 10.5122 10.7363 10.5122 11.5417C10.5122 12.3471 9.78894 13 8.89678 13H8.66602M4.05063 8H13.0506C13.9428 8 14.666 8.65292 14.666 9.45833C14.666 10.2638 13.9428 10.9167 13.0506 10.9167H12.8199"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'wind_angle'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M2.33398 4.5C3.4903 3.90152 4.74603 3.56142 6.02629 3.5C7.87245 3.5 8.79552 5 10.6417 5C11.9219 4.93858 13.1776 4.59848 14.334 4L12.4878 3M2.33398 8.5C3.4903 7.90152 4.74603 7.56142 6.02629 7.5C7.87245 7.5 8.79552 9 10.6417 9C11.9219 8.93858 13.1776 8.59848 14.334 8L12.4878 7M2.33398 12.5C3.4903 11.9015 4.74603 11.5614 6.02629 11.5C7.87245 11.5 8.79552 13 10.6417 13C11.9219 12.9386 13.1776 12.5985 14.334 12L12.4878 11"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'rain_level'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.75 12L6.25 11M10.25 12L10.75 11M7.5 14L8 13M3 14L3.5 13M12 14L12.5 13M2 5.5C2 7.433 3.567 9 5.5 9H11.5C12.8807 9 14 7.88071 14 6.5C14 5.11929 12.8807 4 11.5 4C10.8828 4 10.3178 4.22367 9.88171 4.59438C9 2.5 7 2 5.5 2C3.567 2 2 3.567 2 5.5Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'compass'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect width="32" height="32" rx="16" fill="#00040A" fill-opacity="0.75" />
      <path
        d="M20.5194 6.43253C20.6038 5.61282 19.8638 5.28334 19.3112 5.89461L12.3124 13.6367C12.1963 13.7475 12.0967 13.8881 12.0261 14.0486L19.3345 17.3024C19.4064 17.1426 19.4443 16.9745 19.449 16.8141L20.5194 6.43253Z"
        fill="#E71919"
      />
      <path
        d="M20.5194 6.43253C20.6038 5.61282 19.8638 5.28334 19.3112 5.89461L12.3124 13.6367C12.1963 13.7475 12.0967 13.8881 12.0261 14.0486L19.3345 17.3024C19.4064 17.1426 19.4443 16.9745 19.449 16.8141L20.5194 6.43253Z"
        fill="#E71919"
      />
      <path
        d="M12.0492 25.4568C11.4966 26.0681 10.7565 25.7386 10.841 24.9189L11.9114 14.5373C11.9161 14.3769 11.9541 14.2084 12.0261 14.0486L19.3345 17.3024C19.2638 17.4629 19.164 17.6039 19.048 17.7147L12.0492 25.4568Z"
        fill="white"
      />
      <path
        d="M16.5936 16.0827C16.369 16.5872 15.7779 16.8141 15.2733 16.5895C14.7688 16.3649 14.5419 15.7737 14.7665 15.2692C14.9912 14.7647 15.5823 14.5378 16.0868 14.7624C16.5914 14.987 16.8183 15.5781 16.5936 16.0827Z"
        :fill="'black'"
      />
    </svg>

    <svg
      v-else-if="name == 'unpin'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.68924 7.65984L11.7111 6.76412L14.354 2.41756C14.477 2.21477 14.6438 2.04202 14.8421 1.91193C15.0404 1.78185 15.2652 1.69771 15.5002 1.66566C15.7352 1.63362 15.9744 1.65448 16.2003 1.72672C16.4262 1.79896 16.6331 1.92076 16.8059 2.08321L21.9167 7.194C22.0792 7.36679 22.201 7.57369 22.2731 7.7996C22.3454 8.02549 22.3663 8.26468 22.3343 8.49968C22.3023 8.73466 22.2181 8.95954 22.088 9.15784C21.9579 9.35616 21.7852 9.5229 21.5823 9.6459L17.1721 12.2092L16.2213 16.1919M4.12738 8.59435C4.00584 8.71064 3.91715 8.85697 3.8703 9.01853C3.82344 9.1801 3.82008 9.35117 3.86055 9.51445C3.90102 9.67772 3.98391 9.82742 4.10079 9.9484L13.8925 19.756C14.0164 19.8682 14.1672 19.9464 14.3303 19.9833C14.4933 20.0201 14.6631 20.0142 14.8232 19.9661C14.9833 19.918 15.1284 19.8295 15.2442 19.7091M1.65107 22.3489L9.07164 14.9281M22.3489 22.3489L1.65107 1.65106"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'pin'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1.65107 22.3489L9.07163 14.9281M17.1722 12.2092L21.5825 9.6459C21.7853 9.5229 21.9581 9.35616 22.0881 9.15784C22.2182 8.95954 22.3024 8.73466 22.3344 8.49968C22.3664 8.26468 22.3456 8.02549 22.2733 7.7996C22.2012 7.57369 22.0794 7.36679 21.9168 7.194L16.806 2.08321C16.6333 1.92076 16.4264 1.79896 16.2005 1.72672C15.9746 1.65448 15.7354 1.63362 15.5004 1.66566C15.2654 1.69771 15.0405 1.78185 14.8422 1.91193C14.6439 2.04202 14.4772 2.21477 14.3542 2.41756L11.7112 6.76412L4.56251 8.35626C4.39904 8.39592 4.24894 8.47806 4.12738 8.59435C4.00583 8.71064 3.91715 8.85697 3.87029 9.01853C3.82344 9.1801 3.82008 9.35117 3.86055 9.51445C3.90102 9.67772 3.98391 9.82742 4.10079 9.9484L13.8925 19.756C14.0164 19.8682 14.1672 19.9464 14.3303 19.9833C14.4933 20.0201 14.6631 20.0142 14.8232 19.9661C14.9833 19.918 15.1284 19.8295 15.2442 19.7091C15.3601 19.5886 15.4429 19.4402 15.4846 19.2783L17.1722 12.2092Z"
        :stroke="color"
        stroke-width="1.71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'bell'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.5 22H13.5M18.6641 8.83385C18.6641 7.0214 17.9619 5.28319 16.7121 4.00158C15.4624 2.71999 13.7674 2 12 2C10.2326 2 8.53755 2.71999 7.28781 4.00158C6.03805 5.28319 5.33595 7.0214 5.33595 8.83385V15.6222C5.33595 16.3019 5.07267 16.9537 4.60401 17.4342C4.13537 17.9149 3.66278 18.1849 3 18.1849H21C20.3372 18.1849 19.8647 17.9149 19.3959 17.4342C18.9273 16.9537 18.6641 16.3019 18.6641 15.6222V8.83385Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'rc_charge'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.42587 2.22677C4.8726 1.92896 6.21278 1.33333 7.9997 1.33333C9.78661 1.33333 11.1268 1.92896 11.5735 2.22677M6.21249 4.07632C6.51031 3.92742 7.28465 3.62961 7.9994 3.62961C8.71417 3.62961 9.4885 3.92742 9.78632 4.07632M5.3889 8.27778V10.8454M6.67257 9.56169H4.10484M10.7915 6.08228H5.20846C3.43953 6.08228 1.95146 7.35092 1.7481 9.03239L1.34992 12.0468C1.18115 13.4422 2.32119 14.6667 3.78921 14.6667C4.72637 14.6667 5.58182 14.1562 5.99423 13.351L6.39223 12.5739H7.99998M14.6667 13.3333V14C14.6667 14.1768 14.5964 14.3464 14.4714 14.4714C14.3464 14.5964 14.1768 14.6667 14 14.6667H11.3333C11.1565 14.6667 10.9869 14.5964 10.8619 14.4714C10.7369 14.3464 10.6667 14.1768 10.6667 14V12.9367M10.6667 10V9.33333C10.6667 9.15652 10.7369 8.98695 10.8619 8.86193C10.9869 8.7369 11.1565 8.66667 11.3333 8.66667H14C14.1768 8.66667 14.3464 8.7369 14.4714 8.86193C14.5964 8.98695 14.6667 9.15652 14.6667 9.33333V10.3967M13 7.33333H12.3333M10.6667 11.3333L12.6667 12.6667V10.6667L14.6667 12"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_charge'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 1.33333H6M10 1.33333H14M4 1.33333V4.66667M12 1.33333V4.66667M4.5 8H4C3.46957 8 2.96086 7.76588 2.58579 7.34912C2.21071 6.93238 2 6.36714 2 5.77778V4.66667H14V5.77778M4.5 8C4.5 8.88406 4.81607 9.7319 5.37868 10.357C5.94129 10.9821 6.70435 11.3333 7.5 11.3333M4.5 8H8M5 9.83336C4.52762 10.3009 4.14971 10.8744 3.89117 11.516C3.63263 12.1576 3.49932 12.8527 3.5 13.5556V14.6667H4.5M14 13.3333V14C14 14.1768 13.9298 14.3464 13.8047 14.4714C13.6797 14.5964 13.5101 14.6667 13.3333 14.6667H10.6667C10.4899 14.6667 10.3203 14.5964 10.1953 14.4714C10.0702 14.3464 10 14.1768 10 14V12.9367M10 10V9.33333C10 9.15652 10.0702 8.98695 10.1953 8.86193C10.3203 8.7369 10.4899 8.66667 10.6667 8.66667H13.3333C13.5101 8.66667 13.6797 8.7369 13.8047 8.86193C13.9298 8.98695 14 9.15652 14 9.33333V10.3967M12.3333 7.33333H11.6667M10 11.3333L12 12.6667V10.6667L14 12"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'air_plane'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.063 2.3547L13.9902 6.42749L7.4322 3.30465C6.33078 2.78016 5.02655 2.93103 4.07395 3.6931L2.56568 4.89972C2.12685 5.25079 2.18009 5.93372 2.66801 6.21254L10.0098 10.4078L6.82553 13.5921L4.53658 13.24C3.01937 13.0066 1.65106 14.1805 1.65106 15.7155C1.65106 16.3277 2.09365 16.8501 2.69751 16.9508L6.42749 17.5725L7.04916 21.3024C7.1498 21.9063 7.67226 22.3489 8.28445 22.3489C9.81952 22.3489 10.9934 20.9806 10.76 19.4633L10.4078 17.1745L13.5921 13.9902L17.7874 21.332C18.0662 21.8198 18.7492 21.8732 19.1003 21.4342L20.3068 19.926C21.069 18.9734 21.2198 17.6691 20.6953 16.5678L17.5725 10.0098L21.6454 5.93702C22.0958 5.48649 22.3489 4.87544 22.3489 4.23829C22.3489 3.60115 22.0958 2.9901 21.6454 2.53957L21.4603 2.3547C21.0099 1.90417 20.3989 1.65106 19.7617 1.65106C19.1245 1.65106 18.5134 1.90417 18.063 2.3547Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'ariel_view_sensor'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.63882 3.34015C7.30891 2.89343 9.31919 2 11.9996 2C14.6799 2 16.6902 2.89343 17.3603 3.34015M9.31876 6.11448C9.76549 5.89113 10.927 5.44442 11.9991 5.44442C13.0713 5.44442 14.2328 5.89113 14.6795 6.11448M20.6599 7C21.1066 7.67009 22 9.68037 22 12.3607C22 15.0411 21.1066 17.0514 20.6599 17.7215M17.8855 9.67993C18.1089 10.1267 18.5556 11.2882 18.5556 12.3603C18.5556 13.4324 18.1089 14.5939 17.8855 15.0407M3.34015 7C2.89343 7.67009 2 9.68037 2 12.3607C2 15.0411 2.89343 17.0514 3.34015 17.7215M6.11448 9.67993C5.89113 10.1267 5.44442 11.2882 5.44442 12.3603C5.44442 13.4324 5.89113 14.5939 6.11448 15.0407M6.63925 20.6599C7.30934 21.1066 9.31962 22 12 22C14.6804 22 16.6906 21.1066 17.3608 20.6599M9.31918 17.8855C9.76591 18.1089 10.9274 18.5556 11.9995 18.5556C13.0717 18.5556 14.2332 18.1089 14.6799 17.8855M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'video_camera'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5527 16.7764V20.7568M6.82541 11.2039C9.24353 11.2039 11.2038 9.24365 11.2038 6.82554C11.2038 4.40742 9.24353 2.44714 6.82541 2.44714C4.4073 2.44714 2.44702 4.40742 2.44702 6.82554C2.44702 9.24365 4.4073 11.2039 6.82541 11.2039ZM17.1743 11.2039C18.7131 11.2039 19.9606 9.95648 19.9606 8.41768C19.9606 6.87887 18.7131 5.63143 17.1743 5.63143C15.6355 5.63143 14.3881 6.87887 14.3881 8.41768C14.3881 9.95648 15.6355 11.2039 17.1743 11.2039ZM16.7763 14.3882H8.01952C7.14021 14.3882 6.42738 15.101 6.42738 15.9804V19.9607C6.42738 20.8401 7.14021 21.5529 8.01952 21.5529H16.7763C17.6556 21.5529 18.3684 20.8401 18.3684 19.9607V15.9804C18.3684 15.101 17.6556 14.3882 16.7763 14.3882Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'air_plane_alt'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5152 2.40795L9.15385 4.76923L5.35173 2.9587C4.71316 2.65462 3.95701 2.74209 3.40472 3.18391L2.53027 3.88347C2.27585 4.08701 2.30672 4.48296 2.5896 4.64461L6.84615 7.07692L5 8.92308L3.67294 8.71891C2.7933 8.58359 2 9.26417 2 10.1542C2 10.5091 2.2566 10.812 2.6067 10.8703L4.76923 11.2308L5.12966 13.3933C5.188 13.7434 5.49091 14 5.84584 14C6.73583 14 7.41641 13.2067 7.28109 12.327L7.07692 11L8.92308 9.15385L11.3554 13.4104C11.517 13.6933 11.913 13.7242 12.1166 13.4697L12.8161 12.5953C13.2579 12.043 13.3454 11.2868 13.0413 10.6483L11.2308 6.84615L13.5921 4.48487C13.8532 4.22366 14 3.8694 14 3.5C14 3.1306 13.8532 2.77634 13.5921 2.51513L13.4848 2.40795C13.2237 2.14674 12.8694 2 12.5 2C12.1306 2 11.7763 2.14674 11.5152 2.40795Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'cloud'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3686 11.2039C17.5075 11.205 16.6699 11.4843 15.9804 12C15.9804 10.583 15.5602 9.19774 14.7729 8.01952C13.9856 6.84129 12.8667 5.92299 11.5575 5.3807C10.2483 4.83843 8.80777 4.69654 7.41797 4.973C6.02816 5.24945 4.75155 5.93181 3.74955 6.93381C2.74756 7.93581 2.06519 9.21242 1.78874 10.6022C1.51229 11.992 1.65418 13.4326 2.19645 14.7418C2.73873 16.0509 3.65703 17.1698 4.83526 17.9571C6.01348 18.7444 7.39869 19.1646 8.81571 19.1646H18.3686C19.4242 19.1646 20.4366 18.7452 21.1832 17.9988C21.9296 17.2523 22.3489 16.2399 22.3489 15.1843C22.3489 14.1286 21.9296 13.1162 21.1832 12.3697C20.4366 11.6233 19.4242 11.2039 18.3686 11.2039Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'upward_sensor'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0002 15C15.0002 16.6569 13.6571 18 12.0002 18C10.3434 18 9.00021 16.6569 9.00021 15C9.00021 13.3431 10.3434 12 12.0002 12C13.6571 12 15.0002 13.3431 15.0002 15Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.63904 6.34015C7.30913 5.89343 9.3194 5 11.9998 5C14.6801 5 16.6904 5.89343 17.3605 6.34015M9.31897 9.11448C9.7657 8.89113 10.9272 8.44442 11.9993 8.44442C13.0715 8.44442 14.233 8.89113 14.6797 9.11448"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'waypoint'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M12 6h2V4h-2zm-7 8h2v-2H5zm12 6h2v-2h-2zm-2 0v-.5L8 16H5q-.825 0-1.412-.587T3 14v-2q0-.825.588-1.412T5 10h2.3L10 6.9V4q0-.825.588-1.412T12 2h2q.825 0 1.413.588T16 4v2q0 .825-.587 1.413T14 8h-2.3L9 11.1v3.15l6.125 3.05q.2-.575.713-.937T17 16h2q.825 0 1.413.588T21 18v2q0 .825-.587 1.413T19 22h-2q-.825 0-1.412-.587T15 20"
      />
    </svg>
    <svg
      v-else-if="name == 'downward_sensor'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.63947 16.6599C7.30955 17.1066 9.31983 18 12.0002 18C14.6806 18 16.6909 17.1066 17.361 16.6599M9.3194 13.8855C9.76613 14.1089 10.9276 14.5556 11.9998 14.5556C13.0719 14.5556 14.2334 14.1089 14.6801 13.8855"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0002 8C15.0002 9.65685 13.6571 11 12.0002 11C10.3434 11 9.00021 9.65685 9.00021 8C9.00021 6.34315 10.3434 5 12.0002 5C13.6571 5 15.0002 6.34315 15.0002 8Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'horizontal_sensor'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1213 14.1213C12.9497 15.2929 11.0503 15.2929 9.87868 14.1213C8.70711 12.9498 8.70711 11.0503 9.87868 9.87869C11.0503 8.70712 12.9497 8.70712 14.1213 9.87869C15.2929 11.0503 15.2929 12.9498 14.1213 14.1213Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.3325 2.08565C15.1222 2.24359 17.1754 3.03332 19.0707 4.92864C20.9661 6.82394 21.7558 8.87718 21.9138 9.6669M14.2657 5.94239C14.7396 6.10035 15.8767 6.60578 16.6349 7.36389C17.393 8.12201 17.8984 9.2592 18.0564 9.73302"
        :stroke="secColorOne || color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.659 14.5879C21.501 15.3776 20.7113 17.4309 18.816 19.3262C16.9207 21.2215 14.8674 22.0112 14.0777 22.1692M17.8022 14.5212C17.6443 14.995 17.1388 16.1322 16.3807 16.8903C15.6226 17.6484 14.4854 18.1538 14.0116 18.3118"
        :stroke="secColorTwo || color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.08594 14.3328C2.24388 15.1225 3.03361 17.1758 4.92893 19.0711C6.82423 20.9664 8.87747 21.7561 9.66719 21.9141M5.94268 14.2661C6.10064 14.7399 6.60607 15.8771 7.36418 16.6352C8.1223 17.3933 9.25949 17.8987 9.7333 18.0567"
        :stroke="secColorThree || color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.41209 2.34103C8.62239 2.49898 6.56916 3.28871 4.67384 5.18402C2.77854 7.07933 1.98881 9.13256 1.83084 9.92229M9.47885 6.19778C9.00503 6.35574 7.86784 6.86117 7.10973 7.61928C6.35161 8.3774 5.84618 9.51458 5.68823 9.9884"
        :stroke="secColorFour || color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_ariel_view'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.84239 8.2782L8.47011 7.35008C8.09093 7.50218 7.84239 7.86964 7.84239 8.2782H8.84239ZM15.1576 8.2782H16.1576C16.1576 7.86964 15.9091 7.50218 15.5299 7.35008L15.1576 8.2782ZM14.0301 7.82596L14.4024 6.89784L14.0301 7.82596ZM9.96986 7.82596L9.59758 6.89784H9.59758L9.96986 7.82596ZM15.0823 11.1056L16.0112 11.4761L15.0823 11.1056ZM14.1804 13.3668L13.2515 12.9963H13.2515L14.1804 13.3668ZM8.91767 11.1056L9.84651 10.7351H9.84651L8.91767 11.1056ZM9.81965 13.3668L8.89082 13.7373L9.81965 13.3668ZM8.28663 9.63727C8.74577 9.94421 9.36679 9.82083 9.67373 9.36169C9.98067 8.90256 9.85729 8.28153 9.39816 7.97459L8.28663 9.63727ZM6.24055 5.86368C5.78142 5.55673 5.16039 5.68011 4.85345 6.13925C4.54651 6.59839 4.66989 7.21941 5.12902 7.52635L6.24055 5.86368ZM10.4772 17.0071C10.9262 16.6855 11.0295 16.0608 10.7079 15.6118C10.3863 15.1628 9.76162 15.0596 9.31262 15.3812L10.4772 17.0071ZM5.62875 18.0198C5.17976 18.3414 5.07649 18.9661 5.39809 19.4151C5.71968 19.8641 6.34437 19.9673 6.79336 19.6457L5.62875 18.0198ZM14.6018 7.97459C14.1427 8.28153 14.0193 8.90256 14.3263 9.36169C14.6332 9.82083 15.2542 9.94421 15.7134 9.63727L14.6018 7.97459ZM18.871 7.52635C19.3301 7.21941 19.4535 6.59839 19.1466 6.13925C18.8396 5.68011 18.2186 5.55673 17.7594 5.86368L18.871 7.52635ZM14.6874 15.3812C14.2384 15.0596 13.6137 15.1628 13.2921 15.6118C12.9705 16.0608 13.0738 16.6855 13.5228 17.0071L14.6874 15.3812ZM17.2066 19.6457C17.6556 19.9673 18.2803 19.8641 18.6019 19.4151C18.9235 18.9661 18.8202 18.3414 18.3712 18.0198L17.2066 19.6457ZM20.7789 17.8145L21.726 17.4938L20.7789 17.8145ZM18.8044 21.8309L19.1268 22.7776L18.8044 21.8309ZM16.4512 14.888C15.9284 15.066 15.6489 15.6342 15.8269 16.157C16.005 16.6798 16.5731 16.9592 17.0959 16.7812L16.4512 14.888ZM16.0169 20.07C15.7028 19.6158 15.0799 19.5022 14.6256 19.8163C14.1714 20.1304 14.0578 20.7533 14.3719 21.2075L16.0169 20.07ZM3.01633 17.8145L2.06917 17.4938L3.01633 17.8145ZM4.9908 21.831L4.66842 22.7776L4.9908 21.831ZM6.69925 16.7812C7.22204 16.9592 7.79019 16.6798 7.96823 16.157C8.14628 15.6342 7.8668 15.066 7.344 14.888L6.69925 16.7812ZM9.42331 21.2076C9.73743 20.7533 9.62382 20.1304 9.16957 19.8163C8.71531 19.5022 8.09242 19.6158 7.7783 20.07L9.42331 21.2076ZM6.89773 11.229C7.4311 11.0857 7.7473 10.5371 7.60399 10.0037C7.46068 9.47038 6.91212 9.15418 6.37876 9.29749L6.89773 11.229ZM2.12644 7.65112L3.09254 7.39297L2.12644 7.65112ZM4.73133 3.12679L4.47184 2.16104L4.73133 3.12679ZM8.27703 5.99706C8.4196 6.53063 8.96772 6.84759 9.50129 6.70502C10.0349 6.56244 10.3518 6.01433 10.2092 5.48076L8.27703 5.99706ZM21.8736 7.65112L20.9075 7.39297L21.8736 7.65112ZM17.6212 9.29749C17.0879 9.15418 16.5393 9.47038 16.396 10.0037C16.2527 10.5371 16.5689 11.0857 17.1023 11.229L17.6212 9.29749ZM13.7908 5.48076C13.6482 6.01433 13.9651 6.56244 14.4987 6.70502C15.0323 6.84759 15.5804 6.53063 15.723 5.99706L13.7908 5.48076ZM19.2687 3.12679L19.0092 4.09254L19.2687 3.12679ZM13.0525 17.8328H10.9475V19.8328H13.0525V17.8328ZM10.8949 17.7773V13.7587H8.89493V17.7773H10.8949ZM10.7485 12.9963L9.84651 10.7351L7.98884 11.4761L8.89082 13.7373L10.7485 12.9963ZM9.84239 10.7136V8.2782H7.84239V10.7136H9.84239ZM13.1051 13.7587V17.7773H15.1051V13.7587H13.1051ZM14.1576 8.2782V10.7136H16.1576V8.2782H14.1576ZM14.1535 10.7351L13.2515 12.9963L15.1092 13.7373L16.0112 11.4761L14.1535 10.7351ZM9.21467 9.20632L10.3421 8.75408L9.59758 6.89784L8.47011 7.35008L9.21467 9.20632ZM13.6579 8.75408L14.7853 9.20632L15.5299 7.35008L14.4024 6.89784L13.6579 8.75408ZM13.6392 8.75047C13.6455 8.75047 13.6519 8.75168 13.6579 8.75408L14.4024 6.89784C14.1598 6.80051 13.9007 6.75047 13.6392 6.75047V8.75047ZM10.3421 8.75408C10.3481 8.75168 10.3545 8.75047 10.3608 8.75047V6.75047C10.0993 6.75047 9.84024 6.80051 9.59758 6.89784L10.3421 8.75408ZM14.1576 10.7136C14.1576 10.721 14.1562 10.7283 14.1535 10.7351L16.0112 11.4761C16.1079 11.2335 16.1576 10.9747 16.1576 10.7136H14.1576ZM15.1051 13.7587C15.1051 13.7513 15.1065 13.744 15.1092 13.7373L13.2515 12.9963C13.1548 13.2388 13.1051 13.4976 13.1051 13.7587H15.1051ZM9.84651 10.7351C9.84381 10.7283 9.84239 10.721 9.84239 10.7136H7.84239C7.84239 10.9747 7.89208 11.2335 7.98884 11.4761L9.84651 10.7351ZM10.8949 13.7587C10.8949 13.4976 10.8452 13.2388 10.7485 12.9963L8.89082 13.7373C8.89351 13.744 8.89493 13.7513 8.89493 13.7587H10.8949ZM10.9475 17.8328C10.9211 17.8328 10.8949 17.8106 10.8949 17.7773H8.89493C8.89493 18.9099 9.81127 19.8328 10.9475 19.8328V17.8328ZM13.0525 19.8328C14.1887 19.8328 15.1051 18.9099 15.1051 17.7773H13.1051C13.1051 17.8106 13.0789 17.8328 13.0525 17.8328V19.8328ZM9.39816 7.97459L6.24055 5.86368L5.12902 7.52635L8.28663 9.63727L9.39816 7.97459ZM9.31262 15.3812L5.62875 18.0198L6.79336 19.6457L10.4772 17.0071L9.31262 15.3812ZM15.7134 9.63727L18.871 7.52635L17.7594 5.86368L14.6018 7.97459L15.7134 9.63727ZM13.5228 17.0071L17.2066 19.6457L18.3712 18.0198L14.6874 15.3812L13.5228 17.0071ZM19.8317 18.1353C20.2162 19.2706 19.6091 20.5005 18.482 20.8843L19.1268 22.7776C21.3022 22.0367 22.4631 19.6701 21.726 17.4938L19.8317 18.1353ZM17.0959 16.7812C18.2218 16.3978 19.4476 17.0012 19.8317 18.1353L21.726 17.4938C20.9885 15.3161 18.6278 14.1467 16.4512 14.888L17.0959 16.7812ZM18.482 20.8843C17.5521 21.201 16.5526 20.8447 16.0169 20.07L14.3719 21.2075C15.4013 22.6963 17.3262 23.3907 19.1268 22.7776L18.482 20.8843ZM2.06917 17.4938C1.33209 19.6701 2.49302 22.0367 4.66842 22.7776L5.31318 20.8843C4.18604 20.5005 3.57897 19.2707 3.96348 18.1353L2.06917 17.4938ZM7.344 14.888C5.16734 14.1467 2.80667 15.3162 2.06917 17.4938L3.96348 18.1353C4.34757 17.0012 5.57337 16.3978 6.69925 16.7812L7.344 14.888ZM4.66842 22.7776C6.46894 23.3907 8.39383 22.6963 9.42331 21.2076L7.7783 20.07C7.24262 20.8447 6.24304 21.201 5.31318 20.8843L4.66842 22.7776ZM6.37876 9.29749C4.94961 9.68149 3.477 8.83175 3.09254 7.39297L1.16033 7.90927C1.82904 10.4118 4.39643 11.9011 6.89773 11.229L6.37876 9.29749ZM3.09254 7.39297C2.70781 5.95315 3.56062 4.47682 4.99082 4.09254L4.47184 2.16104C1.9716 2.83284 0.491905 5.40773 1.16033 7.90927L3.09254 7.39297ZM4.99082 4.09254C6.41996 3.70854 7.89258 4.55828 8.27703 5.99706L10.2092 5.48076C9.54053 2.97819 6.97314 1.48896 4.47184 2.16104L4.99082 4.09254ZM20.9075 7.39297C20.523 8.83175 19.0504 9.68149 17.6212 9.29749L17.1023 11.229C19.6036 11.9011 22.171 10.4118 22.8397 7.90927L20.9075 7.39297ZM15.723 5.99706C16.1074 4.55828 17.58 3.70854 19.0092 4.09254L19.5282 2.16104C17.0269 1.48896 14.4595 2.97819 13.7908 5.48076L15.723 5.99706ZM19.0092 4.09254C20.4394 4.47682 21.2922 5.95315 20.9075 7.39297L22.8397 7.90927C23.5081 5.40773 22.0284 2.83284 19.5282 2.16104L19.0092 4.09254ZM10.3608 8.75047H13.6392V6.75047H10.3608V8.75047Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_front_view'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 9.5V11.3074C7 11.4346 7.02207 11.5607 7.06502 11.6788L7.45455 12.75M7 9.5C7 9.0963 7.22067 8.73219 7.55944 8.57692L8.65035 8.07692C8.76114 8.02614 8.87998 8 9.36363 8L15 8C15.12 8 15.2389 8.02614 15.3497 8.07692L16.4406 8.57692C16.7793 8.73219 17 9.0963 17 9.5M7 9.5L2 12M17 9.5V11.3074C17 11.4346 16.9779 11.5607 16.935 11.6788L16.5455 12.75M17 9.5L22 12M2.86364 15L2.04665 12.654C2.01575 12.552 2 12.4452 2 12.3377V10.5M21.1364 15L21.9533 12.654C21.9842 12.552 22 12.4452 22 12.3377V10.5M10.4091 14H13.5909C14.093 14 14.5 13.5523 14.5 13V12C14.5 11.4477 14.093 11 13.5909 11H10.4091C9.90701 11 9.5 11.4477 9.5 12V13C9.5 13.5523 9.90701 14 10.4091 14Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_in_box'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1054 9.6669L8.21087 8.33369M10.737 14.3331L8.52663 15.9996M13.8946 9.6669L15.7891 8.33369M13.263 14.3331L15.4734 15.9996M8 10.6568C7.10811 10.5665 6.3214 9.90481 6.07586 8.93755C5.75992 7.69291 6.45967 6.41358 7.6388 6.08008C8.59839 5.80867 9.57975 6.24732 10.0822 7.09091M13.9178 7.09091C14.4202 6.24732 15.4016 5.80867 16.3612 6.08008C17.5403 6.41358 18.2401 7.69291 17.9241 8.93755C17.6786 9.90481 16.8919 10.5665 16 10.6568M9.55364 17.5892C9.06889 17.9792 8.41498 18.1157 7.79448 17.8932C6.80372 17.5381 6.27332 16.4024 6.6098 15.3566C6.83125 14.6683 7.37302 14.1904 8 14.0455M14.4462 17.6801C14.9154 17.9992 15.5131 18.0974 16.0826 17.8932C17.0734 17.5381 17.6038 16.4023 17.2673 15.3565C17.0605 14.7136 16.5742 14.2544 16 14.0785M8 2H3C2.44772 2 2 2.44772 2 3V8M16 21.9996H21C21.5523 21.9996 22 21.5519 22 20.9996V15.9996M16.0826 2H21.0826C21.6349 2 22.0826 2.44772 22.0826 3V8M8.08263 21.9996H3.08263C2.53034 21.9996 2.08263 21.5519 2.08263 20.9996V15.9996M10.1054 9.3336V10.8717C10.1054 10.9565 10.1208 11.0406 10.1506 11.1193L10.6918 12.5474C10.7216 12.6262 10.737 12.7102 10.737 12.795V15.333C10.737 15.7012 11.0197 15.9996 11.3685 15.9996H12.6315C12.9803 15.9996 13.263 15.7012 13.263 15.333V12.795C13.263 12.7102 13.2784 12.6262 13.3082 12.5474L13.8494 11.1193C13.8792 11.0406 13.8946 10.9565 13.8946 10.8717V9.3336L13.2181 9.04798C13.1435 9.01648 13.0639 9.0003 12.9835 9.0003H11.0165C10.9361 9.0003 10.8565 9.01648 10.7819 9.04798L10.1054 9.3336Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'ellipsis'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4.5" r="4" :fill="color" />
    </svg>
    <svg
      v-else-if="name === 'dock'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 100 100"
    >
      <path
        :fill="color"
        d="M19.53 28.49a3.85 3.85 0 0 0-3.533 2.343C6.706 31.364-.029 32.257 0 32.955c.027.693 6.712.997 15.928.724c.32.862.936 1.58 1.738 2.027H16.17v2.742h-1.83a.874.874 0 0 0-.875.874v1.954c0 .483.391.874.874.874h12.316c3.103.73 3.45 1.843 5.774 3.88c-.38 2.113-.94 4.42-1.378 6.414v16.973a2.092 2.092 0 1 0 4.185 0V61.21c-.048-6.9 1.066-9.69 4.905-15.031l.965-.448c0 4.146 2.866 4.395 6.908 5.32h-3.036c-.924 0-1.674.75-1.674 1.675v10c0 .924.75 1.674 1.674 1.674h10.044c.924 0 1.674-.75 1.674-1.674v-10c0-.925-.75-1.674-1.674-1.674h-3.033c4.041-.928 6.905-1.176 6.905-5.321l.965.448c4.857 5.026 4.905 8.447 4.905 15.03v8.207a2.092 2.092 0 0 0 4.185 0V52.444c-.513-2.191-1.062-4.487-1.58-6.762c2.199-2.155 3.101-2.64 5.956-3.532h12.336a.874.874 0 0 0 .874-.874v-1.954a.874.874 0 0 0-.874-.874H83.83v-2.742h-1.496a3.85 3.85 0 0 0 1.738-2.027c9.216.273 15.901-.031 15.928-.724c.029-.698-6.706-1.59-15.997-2.122a3.852 3.852 0 0 0-6.943-.302c-9.307-.283-16.103.018-16.142.716c-.029.693 6.615 1.58 15.827 2.112a3.85 3.85 0 0 0 1.839 2.347h-1.496v2.742C67.654 38.426 60.352 33.685 50 33.49c-10.003.212-18.38 4.958-27.088 4.958v-2.742h-1.496a3.85 3.85 0 0 0 1.839-2.347c9.212-.532 15.856-1.42 15.827-2.112c-.039-.698-6.835-1-16.142-.716a3.85 3.85 0 0 0-3.41-2.04M50 53.503c2.347 0 4.276 1.929 4.276 4.276S52.347 62.055 50 62.055s-4.278-1.93-4.278-4.277s1.93-4.276 4.278-4.276m0 2.51c-.99 0-1.767.776-1.767 1.766s.777 1.766 1.767 1.766s1.765-.776 1.765-1.766s-.775-1.765-1.765-1.765"
        :color="color"
      />
    </svg>
    <svg
      v-else-if="name == 'ellipsis-two'"
      :width="size"
      :height="size"
      :viewBox="`0 0 24 24`"
      class="opacity"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" :r="10" fill="none" :stroke="color" stroke-width="1" />
    </svg>

    <svg
      v-else-if="name === 'refresh'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.76923 15.8529C4.27788 19.4631 7.84268 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C7.00032 2 2.85762 5.66909 2.11761 10.4615M7.38462 15.8462H2V21.2308"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'filter'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
      <path
        :fill="color"
        d="M11 20q-.425 0-.712-.288T10 19v-6L4.2 5.6q-.375-.5-.112-1.05T5 4h14q.65 0 .913.55T19.8 5.6L14 13v6q0 .425-.288.713T13 20z"
      />
    </svg>
    <svg
      v-else-if="name == 'circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'auto'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 14L3.53312 12.5783M3.53312 12.5783L4.5 10L5.46688 12.5783M3.53312 12.5783H5.46688M5.46688 12.5783L6 14M7.5 10V12.5C7.5 12.5 7.5 14 9 14C10.5 14 10.5 12.5 10.5 12.5V10M12 10H14M14 10H16M14 10V14M7 2H2V7M17 2H22V7M22 17V22H17M7 22H2V17M19 10C17.8906 10 17 10.6736 17 12C17 13.3264 17.8534 14 19 14C20.1466 14 21 13.3264 21 12C21 10.6736 20.1094 10 19 10Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'play_triangle'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.0345 6.28194C15.3218 7.04552 15.3218 8.95448 14.0345 9.71806L3.89655 15.7313C2.6092 16.4948 1 15.5404 1 14.0132V1.9868C1 0.45964 2.6092 -0.494837 3.89655 0.268744L14.0345 6.28194Z"
        fill="white"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_in_dock'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.04665 16H22M2.04665 19H22M6.99999 6.5V8.30742C6.99999 8.43464 7.02206 8.56069 7.06501 8.67881L7.45454 9.75M6.99999 6.5C6.99999 6.0963 7.22066 5.73219 7.55943 5.57692L8.65034 5.07692C8.76113 5.02614 8.87997 5 9.36362 5H15C15.12 5 15.2389 5.02614 15.3496 5.07692L16.4406 5.57692C16.7793 5.73219 17 6.0963 17 6.5M6.99999 6.5L1.99999 9M17 6.5V8.30742C17 8.43464 16.9779 8.56069 16.935 8.67881L16.5454 9.75M17 6.5L22 9M2.86363 12L2.04664 9.65395C2.01575 9.55198 1.99999 9.4452 1.99999 9.33772V7.5M21.1363 12L21.9533 9.65395C21.9842 9.55198 22 9.4452 22 9.33772V7.5M10.4091 11H13.5909C14.093 11 14.5 10.5523 14.5 10V9C14.5 8.44772 14.093 8 13.5909 8H10.4091C9.90701 8 9.49999 8.44772 9.49999 9V10C9.49999 10.5523 9.90701 11 10.4091 11Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>

    <svg
      v-else-if="name == 'location_target_follow'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18.9231C15.8235 18.9231 18.9231 15.8235 18.9231 12M12 18.9231C8.17649 18.9231 5.07692 15.8235 5.07692 12M12 18.9231V22M18.9231 12C18.9231 8.17649 15.8235 5.07692 12 5.07692M18.9231 12H22M12 5.07692C8.17649 5.07692 5.07692 8.17649 5.07692 12M12 5.07692V2M5.07692 12H2M12 12.7692C12.4248 12.7692 12.7692 12.4248 12.7692 12C12.7692 11.5752 12.4248 11.2308 12 11.2308C11.5752 11.2308 11.2308 11.5752 11.2308 12C11.2308 12.4248 11.5752 12.7692 12 12.7692Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'location_target'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18.9231C15.8235 18.9231 18.9231 15.8235 18.9231 12M12 18.9231C8.17649 18.9231 5.07692 15.8235 5.07692 12M12 18.9231V22M18.9231 12C18.9231 8.17649 15.8235 5.07692 12 5.07692M18.9231 12H22M12 5.07692C8.17649 5.07692 5.07692 8.17649 5.07692 12M12 5.07692V2M5.07692 12H2"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'satelite_dish'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41782 13.9902C8.10241 13.6748 7.81718 13.3407 7.56212 12.9914L3.24323 22.3489H14.3882L13.1942 16.3789C11.4467 16.1307 9.76202 15.3344 8.41782 13.9902ZM8.41782 13.9902C5.12038 10.6928 5.12038 5.34654 8.41782 2.0491L8.81585 1.65106L20.757 13.5921L20.3589 13.9902C17.0614 17.2877 11.7153 17.2877 8.41782 13.9902ZM18.3686 4.03928L14.7863 7.6216"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      :width="size"
      :height="size"
      v-else-if="name == 'satelite_alt'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.95459 9.15388C5.7745 8.97102 5.61164 8.77729 5.466 8.57478L3 14H9.36358L8.68182 10.5388C7.68401 10.3948 6.7221 9.93321 5.95459 9.15388ZM5.95459 9.15388C4.07182 7.24213 4.07182 4.14253 5.95459 2.23077L6.18186 2L13 8.92308L12.7727 9.15385C10.8899 11.0656 7.83737 11.0657 5.95459 9.15388ZM11.6363 3.38462L9.59085 5.46154"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'logo'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.7">
        <path
          d="M23 19.2133L12.0193 3L10.6293 8.14496C10.144 10.8733 10.0589 14.9409 11.6789 17.9296C12.3748 19.2119 13.2442 20.2944 14.2867 20.657C14.2867 20.657 15.3006 21.3878 17.6789 20.7159L23 19.2133Z"
          fill="#95989C"
        />
        <path
          d="M1 19.2133L11.9812 3L13.3716 8.14496C13.857 10.8733 13.9421 14.9409 12.3221 17.9296C11.6261 19.2119 10.7562 20.2944 9.71425 20.657C9.71425 20.657 8.70031 21.3878 6.3221 20.7159L1 19.2133Z"
          fill="#1B92A6"
        />
      </g>
    </svg>

    <svg
      v-else-if="name == 'snow_cloud'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.84518 21.5527C2.62535 21.5527 2.44714 21.3744 2.44714 21.1547C2.44714 20.9348 2.62535 20.7566 2.84518 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.84518 21.5527C3.06501 21.5527 3.24322 21.3744 3.24322 21.1547C3.24322 20.9348 3.06501 20.7566 2.84518 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.81571 21.5527C8.59589 21.5527 8.41768 21.3744 8.41768 21.1547C8.41768 20.9348 8.59589 20.7566 8.81571 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.81571 21.5527C9.03554 21.5527 9.21375 21.3744 9.21375 21.1547C9.21375 20.9348 9.03554 20.7566 8.81571 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1843 21.5527C14.9645 21.5527 14.7863 21.3744 14.7863 21.1547C14.7863 20.9348 14.9645 20.7566 15.1843 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1843 21.5527C15.4041 21.5527 15.5823 21.3744 15.5823 21.1547C15.5823 20.9348 15.4041 20.7566 15.1843 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.1548 21.5527C20.9349 21.5527 20.7568 21.3744 20.7568 21.1547C20.7568 20.9348 20.9349 20.7566 21.1548 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.1548 21.5527C21.3747 21.5527 21.5529 21.3744 21.5529 21.1547C21.5529 20.9348 21.3747 20.7566 21.1548 20.7566"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.02946 17.5723C5.80964 17.5723 5.63143 17.394 5.63143 17.1743C5.63143 16.9544 5.80964 16.7762 6.02946 16.7762"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.02946 17.5723C6.24929 17.5723 6.4275 17.394 6.4275 17.1743C6.4275 16.9544 6.24929 16.7762 6.02946 16.7762"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.398 17.5723C12.1782 17.5723 12 17.394 12 17.1743C12 16.9544 12.1782 16.7762 12.398 16.7762"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.398 17.5723C12.6179 17.5723 12.7961 17.394 12.7961 17.1743C12.7961 16.9544 12.6179 16.7762 12.398 16.7762"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.9705 17.5723C17.7507 17.5723 17.5725 17.394 17.5725 17.1743C17.5725 16.9544 17.7507 16.7762 17.9705 16.7762"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.9705 17.5723C18.1904 17.5723 18.3686 17.394 18.3686 17.1743C18.3686 16.9544 18.1904 16.7762 17.9705 16.7762"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.24322 8.01964C3.24322 11.0973 5.7381 13.5921 8.81572 13.5921H16.7764C18.9747 13.5921 20.7568 11.8101 20.7568 9.61179C20.7568 7.4135 18.9747 5.63143 16.7764 5.63143C15.7937 5.63143 14.8942 5.98754 14.1999 6.57777C13.5645 4.19909 11.3947 2.44714 8.81572 2.44714C5.7381 2.44714 3.24322 4.94203 3.24322 8.01964Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'sun_cloud'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1843 5.63143C15.1843 6.47595 15.5198 7.28589 16.1169 7.88306C16.7141 8.48023 17.524 8.81571 18.3686 8.81571C19.2131 8.81571 20.023 8.48023 20.6202 7.88306C21.2174 7.28589 21.5529 6.47595 21.5529 5.63143C21.5529 4.7869 21.2174 3.97697 20.6202 3.3798C20.023 2.78263 19.2131 2.44714 18.3686 2.44714C17.524 2.44714 16.7141 2.78263 16.1169 3.3798C15.5198 3.97697 15.1843 4.7869 15.1843 5.63143Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.44714 15.9804C2.44714 19.058 4.94203 21.5529 8.01964 21.5529H15.9804C18.1786 21.5529 19.9607 19.7708 19.9607 17.5725C19.9607 15.3742 18.1786 13.5921 15.9804 13.5921C14.9977 13.5921 14.0981 13.9483 13.4038 14.5385C12.7684 12.1598 10.5986 10.4079 8.01964 10.4079C4.94203 10.4079 2.44714 12.9027 2.44714 15.9804Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'camera_photo'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.349 8.81573C22.349 8.39346 22.1812 7.9885 21.8826 7.68991C21.5841 7.39133 21.1791 7.22358 20.7568 7.22358H17.9706L15.5824 3.24323H8.41773L6.02952 7.22358H3.24327C2.821 7.22358 2.41604 7.39133 2.11745 7.68991C1.81887 7.9885 1.65112 8.39346 1.65112 8.81573V19.1647C1.65112 19.5869 1.81887 19.9919 2.11745 20.2905C2.41604 20.589 2.821 20.7568 3.24327 20.7568H20.7568C21.1791 20.7568 21.5841 20.589 21.8826 20.2905C22.1812 19.9919 22.349 19.5869 22.349 19.1647V8.81573Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0001 17.2241C14.1983 17.2241 15.9804 15.4422 15.9804 13.2439C15.9804 11.0456 14.1983 9.26352 12.0001 9.26352C9.80176 9.26352 8.01969 11.0456 8.01969 13.2439C8.01969 15.4422 9.80176 17.2241 12.0001 17.2241Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'camera_video'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2663 6.82553L16.7764 8.81571V6.02946C16.7764 5.60719 16.6087 5.20223 16.3101 4.90364C16.0115 4.60507 15.6066 4.43732 15.1843 4.43732H3.24321C2.82094 4.43732 2.41598 4.60507 2.1174 4.90364C1.81881 5.20223 1.65107 5.60719 1.65107 6.02946V17.9705C1.65107 18.3928 1.81881 18.7978 2.1174 19.0963C2.41598 19.3949 2.82094 19.5627 3.24321 19.5627H15.1843C15.6066 19.5627 16.0115 19.3949 16.3101 19.0963C16.6087 18.7978 16.7764 18.3928 16.7764 17.9705V15.1843L21.2663 17.1745C21.3873 17.2211 21.518 17.2377 21.6468 17.2222C21.7756 17.2069 21.8988 17.1604 22.0055 17.0866C22.1122 17.0129 22.1993 16.9141 22.2591 16.799C22.319 16.6839 22.3499 16.5559 22.3489 16.4262V7.57384C22.3499 7.44409 22.319 7.31609 22.2591 7.20097C22.1993 7.08586 22.1122 6.98712 22.0055 6.91335C21.8988 6.83957 21.7756 6.79302 21.6468 6.7777C21.518 6.7624 21.3873 6.77882 21.2663 6.82553Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'camera-width'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.83537 11.9607V5.59214C3.83537 5.16987 4.00312 4.76491 4.30169 4.46633C4.60028 4.16774 5.00524 4 5.42751 4H14.9804C15.4026 4 15.8076 4.16774 16.1062 4.46633C16.4047 4.76491 16.5725 5.16987 16.5725 5.59214V7.98036L20.2663 5.99018C20.3873 5.94347 20.518 5.92705 20.6468 5.94235C20.7756 5.95767 20.8988 6.00422 21.0055 6.078C21.1122 6.15177 21.1993 6.25051 21.2591 6.36562C21.319 6.48075 21.3499 6.60874 21.3489 6.73849V13.9987C21.3499 14.1284 21.319 14.2564 21.2591 14.3715C21.1993 14.4866 21.1122 14.5854 21.0055 14.6591C20.8988 14.7329 20.7756 14.7795 20.6468 14.7948C20.518 14.8101 20.3873 14.7937 20.2663 14.747L16.5725 12.7568V15.145C16.5725 15.5673 16.4047 15.9722 16.1062 16.2708C15.8076 16.5694 15.4026 16.7371 14.9804 16.7371H12.9902M3.90046 15.3122L10.0242 18.8477M5.23206 14.3489L2.75001 14.648L3.73206 16.947M10.4282 17.3489L11.4103 19.648L8.92823 19.947"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'camera_time'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.83536 9.61178V3.2432C4.83536 2.82094 5.00311 2.41598 5.30169 2.11739C5.60028 1.81881 6.00524 1.65106 6.42751 1.65106H15.9804C16.4026 1.65106 16.8076 1.81881 17.1062 2.11739C17.4047 2.41598 17.5725 2.82094 17.5725 3.2432V5.63142L21.2663 3.64124C21.3873 3.59453 21.518 3.57811 21.6468 3.59341C21.7756 3.60873 21.8988 3.65528 22.0055 3.72906C22.1122 3.80283 22.1993 3.90157 22.2591 4.01668C22.319 4.13181 22.3499 4.2598 22.3489 4.38955V11.6497C22.3499 11.7795 22.319 11.9075 22.2591 12.0226C22.1993 12.1377 22.1122 12.2364 22.0055 12.3102C21.8988 12.384 21.7756 12.4305 21.6468 12.4459C21.518 12.4612 21.3873 12.4447 21.2663 12.398L17.5725 10.4078V12.7961C17.5725 13.2183 17.4047 13.6233 17.1062 13.9219C16.8076 14.2205 16.4026 14.3882 15.9804 14.3882H13.9902M6.57253 15.9803V17.9705L8.16467 18.3686M6.57253 22.3489C9.21055 22.3489 11.349 20.2105 11.349 17.5725C11.349 14.9345 9.21055 12.7961 6.57253 12.7961C3.93458 12.7961 1.7961 14.9345 1.7961 17.5725C1.7961 20.2105 3.93458 22.3489 6.57253 22.3489Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name === 'clock'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 3.57692V6H7.73077M6 10.5C8.48532 10.5 10.5 8.48532 10.5 6C10.5 3.51472 8.48532 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48532 3.51472 10.5 6 10.5Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name === 'rotate_about'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.4284 6.61538C18.6513 3.83975 15.5407 2 12.0002 2C6.47726 2 2 6.47715 2 12M3.57156 17.3846C5.34863 20.1603 8.45933 22 11.9997 22C17.5228 22 22 17.5229 22 12M20.4615 2.76923V6.61538H16.6152M3.53799 21.2308V17.3846H7.38424M8.31271 12.5433C8.01235 12.2429 8.01238 11.7558 8.3128 11.4555L11.4556 8.31305C11.756 8.01269 12.243 8.01268 12.5434 8.31301L15.6866 11.4554C15.987 11.7558 15.9871 12.2429 15.6867 12.5433L12.5435 15.6867C12.243 15.9872 11.7559 15.9872 11.4555 15.6867L8.31271 12.5433Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'camera_zoom'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.83536 10.9607V4.59214C3.83536 4.16987 4.00311 3.76491 4.30168 3.46633C4.60027 3.16774 5.00523 3 5.4275 3H14.9804C15.4026 3 15.8076 3.16774 16.1062 3.46633C16.4047 3.76491 16.5725 4.16987 16.5725 4.59214V6.98036L20.2663 4.99018C20.3873 4.94347 20.518 4.92705 20.6468 4.94235C20.7756 4.95767 20.8988 5.00422 21.0055 5.078C21.1122 5.15177 21.1993 5.25051 21.2591 5.36562C21.319 5.48075 21.3499 5.60874 21.3489 5.73849V12.9987C21.3499 13.1284 21.319 13.2564 21.2591 13.3715C21.1993 13.4866 21.1122 13.5854 21.0055 13.6591C20.8988 13.7329 20.7756 13.7795 20.6468 13.7948C20.518 13.8101 20.3873 13.7937 20.2663 13.747L16.5725 11.7568V14.145C16.5725 14.5673 16.4047 14.9722 16.1062 15.2708C15.8076 15.5694 15.4026 15.7371 14.9804 15.7371H12.9902M5 16H9M7 14V18M12 21L10 19M3 16C3 16.5253 3.10346 17.0454 3.30448 17.5307C3.5055 18.016 3.80014 18.457 4.17157 18.8284C4.54301 19.1999 4.98396 19.4945 5.46927 19.6955C5.95457 19.8965 6.47471 20 7 20C7.52529 20 8.04543 19.8965 8.53073 19.6955C9.01604 19.4945 9.45699 19.1999 9.82843 18.8284C10.1999 18.457 10.4945 18.016 10.6955 17.5307C10.8965 17.0454 11 16.5253 11 16C11 15.4747 10.8965 14.9546 10.6955 14.4693C10.4945 13.984 10.1999 13.543 9.82843 13.1716C9.45699 12.8001 9.01604 12.5055 8.53073 12.3045C8.04543 12.1035 7.52529 12 7 12C6.47471 12 5.95457 12.1035 5.46927 12.3045C4.98396 12.5055 4.54301 12.8001 4.17157 13.1716C3.80014 13.543 3.5055 13.984 3.30448 14.4693C3.10346 14.9546 3 15.4747 3 16Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'settings'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.26508 2.59077L5.8688 3.61538L4.50484 4.39077L3.41736 4.22462C3.23627 4.2 3.05198 4.22985 2.88788 4.31039C2.72378 4.39093 2.58729 4.5185 2.49576 4.67692L2.12712 5.32308C2.03266 5.48402 1.98913 5.66986 2.0023 5.85608C2.01546 6.0423 2.08469 6.22015 2.20085 6.36615L2.89205 7.22462V8.77538L2.21928 9.63385C2.10313 9.77985 2.0339 9.9577 2.02074 10.1439C2.00757 10.3301 2.05109 10.516 2.14556 10.6769L2.51419 11.3231C2.60573 11.4815 2.74221 11.609 2.90631 11.6896C3.07041 11.7701 3.2547 11.8 3.43579 11.7754L4.52327 11.6092L5.8688 12.3846L6.26508 13.4092C6.33191 13.5827 6.44949 13.7319 6.60243 13.8374C6.75536 13.9428 6.93652 13.9994 7.12216 14H7.8963C8.08195 13.9994 8.2631 13.9428 8.41604 13.8374C8.56896 13.7319 8.68655 13.5827 8.75338 13.4092L9.14967 12.3846L10.4952 11.6092L11.5827 11.7754C11.7638 11.8 11.9481 11.7701 12.1121 11.6896C12.2763 11.609 12.4128 11.4815 12.5043 11.3231L12.8729 10.6769C12.9674 10.516 13.0109 10.3301 12.9977 10.1439C12.9846 9.9577 12.9153 9.77985 12.7992 9.63385L12.108 8.77538V7.22462L12.7807 6.36615C12.8969 6.22015 12.9662 6.0423 12.9793 5.85608C12.9924 5.66986 12.9489 5.48402 12.8545 5.32308L12.4858 4.67692C12.3943 4.5185 12.2578 4.39093 12.0937 4.31039C11.9297 4.22985 11.7453 4.2 11.5642 4.22462L10.4768 4.39077L9.13124 3.61538L8.73495 2.59077C8.66812 2.41729 8.55053 2.26807 8.3976 2.16266C8.24466 2.05724 8.06352 2.00055 7.87787 2H7.12216C6.93652 2.00055 6.75536 2.05724 6.60243 2.16266C6.44949 2.26807 6.33191 2.41729 6.26508 2.59077Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.96746 9.02567C5.76493 8.72207 5.65683 8.36513 5.65683 8C5.65683 7.51037 5.85102 7.04079 6.19669 6.69458C6.54235 6.34835 7.01118 6.15385 7.50002 6.15385C7.86456 6.15385 8.22092 6.26212 8.52404 6.46498C8.82715 6.66783 9.06339 6.95617 9.2029 7.2935C9.3424 7.63085 9.37891 8.00205 9.30779 8.36017C9.23667 8.71828 9.06112 9.04724 8.80334 9.30542C8.54557 9.56362 8.21715 9.73945 7.8596 9.81068C7.50206 9.88191 7.13146 9.84535 6.79466 9.70562C6.45786 9.56589 6.16999 9.32927 5.96746 9.02567Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'camera_settings'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.83536 9.61178V3.2432C4.83536 2.82094 5.00311 2.41598 5.30169 2.11739C5.60028 1.81881 6.00524 1.65106 6.42751 1.65106H15.9804C16.4026 1.65106 16.8076 1.81881 17.1062 2.11739C17.4047 2.41598 17.5725 2.82094 17.5725 3.2432V5.63142L21.2663 3.64124C21.3873 3.59453 21.518 3.57811 21.6468 3.59341C21.7756 3.60873 21.8988 3.65528 22.0055 3.72906C22.1122 3.80283 22.1993 3.90157 22.2591 4.01668C22.319 4.13181 22.3499 4.2598 22.3489 4.38955V11.6497C22.3499 11.7795 22.319 11.9075 22.2591 12.0226C22.1993 12.1377 22.1122 12.2364 22.0055 12.3102C21.8988 12.384 21.7756 12.4305 21.6468 12.4459C21.518 12.4612 21.3873 12.4447 21.2663 12.398L17.5725 10.4078V12.7961C17.5725 13.2183 17.4047 13.6233 17.1062 13.9219C16.8076 14.2205 16.4026 14.3882 15.9804 14.3882H13.9902M5.15591 13.345L5.50005 12.4566C5.55809 12.3062 5.66021 12.1768 5.79301 12.0854C5.92579 11.994 6.08309 11.9448 6.24438 11.9444H6.90066C7.06194 11.9448 7.21925 11.994 7.35203 12.0854C7.48482 12.1768 7.58687 12.3062 7.64499 12.4566L7.98921 13.345L9.15768 14.0173L10.102 13.8732C10.2593 13.8519 10.4193 13.8778 10.5618 13.9476C10.7044 14.0174 10.8229 14.128 10.9024 14.2654L11.2225 14.8256C11.3045 14.9652 11.3424 15.1263 11.331 15.2878C11.3195 15.4492 11.2595 15.6034 11.1585 15.73L10.5742 16.4743V17.8189L11.1744 18.5633C11.2754 18.6898 11.3356 18.844 11.3469 19.0056C11.3583 19.167 11.3206 19.3281 11.2386 19.4676L10.9184 20.0279C10.839 20.1653 10.7204 20.2758 10.5779 20.3457C10.4354 20.4156 10.2754 20.4414 10.1181 20.42L9.1736 20.2759L8.00513 20.9483L7.66107 21.8367C7.60295 21.987 7.5009 22.1165 7.36795 22.2078C7.23517 22.2992 7.07787 22.3484 6.91674 22.3489H6.24438C6.08309 22.3484 5.92579 22.2992 5.79301 22.2078C5.66021 22.1165 5.55809 21.987 5.50005 21.8367L5.15591 20.9483L3.98739 20.2759L3.04298 20.42C2.88572 20.4414 2.72568 20.4156 2.58317 20.3457C2.44065 20.2758 2.32213 20.1653 2.24264 20.0279L1.92249 19.4676C1.84046 19.3281 1.80267 19.167 1.8141 19.0056C1.82553 18.844 1.88565 18.6898 1.98653 18.5633L2.57078 17.8189V16.4743L1.97051 15.73C1.86965 15.6034 1.80951 15.4492 1.7981 15.2878C1.78666 15.1263 1.82445 14.9652 1.90649 14.8256L2.22662 14.2654C2.30612 14.128 2.42465 14.0174 2.56716 13.9476C2.70968 13.8778 2.86972 13.8519 3.02698 13.8732L3.97139 14.0173L5.15591 13.345ZM5.77644 17.1458C5.77644 17.3569 5.86031 17.5594 6.00961 17.7087C6.1589 17.858 6.36138 17.9419 6.57252 17.9419C6.78365 17.9419 6.98613 17.858 7.13542 17.7087C7.28471 17.5594 7.36859 17.3569 7.36859 17.1458C7.36859 16.9347 7.28471 16.7322 7.13542 16.5829C6.98613 16.4336 6.78365 16.3497 6.57252 16.3497C6.36138 16.3497 6.1589 16.4336 6.00961 16.5829C5.86031 16.7322 5.77644 16.9347 5.77644 17.1458Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'check'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 14.6466L7.46136 18.6487C8.05037 19.1772 8.94915 19.1004 9.44476 18.4793L21 4"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'delete'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z"
      />
    </svg>
    <svg
      v-else-if="name == 'file'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.34639 5.34728H7.46925M5.34639 8.53156H10.6535M5.34639 11.7158H10.6535M13.8378 13.8387C13.8378 14.1202 13.7259 14.3902 13.5269 14.5892C13.3279 14.7883 13.0579 14.9001 12.7764 14.9001H3.22354C2.94203 14.9001 2.67205 14.7883 2.47299 14.5892C2.27394 14.3902 2.16211 14.1202 2.16211 13.8387V2.16299C2.16211 1.88148 2.27394 1.6115 2.47299 1.41245C2.67205 1.21339 2.94203 1.10156 3.22354 1.10156H10.1228L13.8378 4.81656V13.8387Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'folder-open'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
      <path
        :fill="color"
        d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h6l2 2h8q.825 0 1.413.588T22 8H4v10l2.4-8h17.1l-2.575 8.575q-.2.65-.737 1.038T19 20z"
      />
    </svg>
    <svg
      v-else-if="name == 'download_tray'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.24323 19.1646C3.24323 20.0091 3.57871 20.819 4.17589 21.4162C4.77305 22.0135 5.58299 22.3489 6.42751 22.3489H17.5725C18.417 22.3489 19.2269 22.0135 19.8241 21.4162C20.4213 20.819 20.7568 20.0091 20.7568 19.1646M8.01965 12L12 15.9803M12 15.9803L15.9804 12M12 15.9803V1.65106"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'new_card'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.4588 18.9871L6.66996 20.0755C6.28284 20.1792 5.88493 19.9495 5.78121 19.5625L2.02491 5.5432C1.92118 5.15608 2.15091 4.75815 2.53803 4.65442L12.3511 2.02491C12.7382 1.92118 13.1361 2.15092 13.2399 2.53805L15.6263 11.3893M17.7694 13.5385V22M13.5388 17.7692H22"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'envelope'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.65107 7.22358L11.0937 13.7608C11.639 14.1383 12.361 14.1383 12.9063 13.7608L22.3489 7.22358M1.65107 19.1647V4.83537C1.65107 3.95606 2.3639 3.24323 3.24321 3.24323H20.7568C21.6361 3.24323 22.3489 3.95604 22.3489 4.83537V19.1647C22.3489 20.044 21.6361 20.7568 20.7568 20.7568H3.24321C2.3639 20.7568 1.65107 20.044 1.65107 19.1647Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'lightning_cloud'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_27_2235)">
        <path
          d="M13.5921 12.7961L10.4078 17.5725H15.1843L12 22.3489M18.3686 15.9803C19.4242 15.9803 20.4366 15.561 21.1832 14.8145C21.9295 14.0681 22.3489 13.0556 22.3489 12C22.3489 10.9443 21.9295 9.93192 21.1832 9.18545C20.4366 8.43899 19.4242 8.01963 18.3686 8.01963C17.5075 8.02078 16.6699 8.29999 15.9803 8.8157C15.9803 7.39868 15.5601 6.01347 14.7729 4.83525C13.9856 3.65702 12.8667 2.73872 11.5575 2.19644C10.2483 1.65417 8.80776 1.51228 7.41796 1.78873C6.02815 2.06518 4.75154 2.74754 3.74954 3.74954C2.74755 4.75154 2.06518 6.02815 1.78873 7.41796C1.51228 8.80776 1.65417 10.2483 2.19644 11.5575C2.73872 12.8667 3.65702 13.9856 4.83525 14.7729C5.56571 15.261 6.37573 15.608 7.22356 15.8012"
          :stroke="color"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_27_2235">
          <rect :width="size" :height="size" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name == 'padlock'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5725 9.61178V7.22356C17.5725 5.74564 16.9855 4.32825 15.9403 3.28322C14.8953 2.23816 13.4779 1.65106 12 1.65106C10.5221 1.65106 9.10469 2.23816 8.05965 3.28322C7.0146 4.32825 6.4275 5.74564 6.4275 7.22356V9.61178M19.1646 9.61178H4.83536C3.95605 9.61178 3.24321 10.3246 3.24321 11.2039V20.7568C3.24321 21.6361 3.95605 22.3489 4.83536 22.3489H19.1646C20.044 22.3489 20.7568 21.6361 20.7568 20.7568V11.2039C20.7568 10.3246 20.044 9.61178 19.1646 9.61178ZM12 16.7764C12.4397 16.7764 12.7961 16.42 12.7961 15.9803C12.7961 15.5407 12.4397 15.1843 12 15.1843C11.5603 15.1843 11.2039 15.5407 11.2039 15.9803C11.2039 16.42 11.5603 16.7764 12 16.7764Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'edit_pen'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.52727 12.3676L3 13L3.58787 9.43983L9.73629 3.34641C9.84556 3.23665 9.97566 3.14952 10.1189 3.09007C10.2622 3.03061 10.4158 3 10.5711 3C10.7262 3 10.88 3.03061 11.0233 3.09007C11.1665 3.14952 11.2966 3.23665 11.4059 3.34641L12.6522 4.58779C12.7624 4.69666 12.8499 4.82618 12.9095 4.96889C12.9692 5.1116 13 5.26467 13 5.41927C13 5.57387 12.9692 5.72694 12.9095 5.86965C12.8499 6.01236 12.7624 6.14188 12.6522 6.25075L6.52727 12.3676Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'padlock_open'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.2455 2.9508C9.95272 2.64804 9.60318 2.40791 9.21752 2.24461C8.83185 2.08131 8.41785 1.99815 8 2.00003C7.15613 2.00003 6.34682 2.34042 5.75012 2.9463C5.15341 3.55219 4.81818 4.37395 4.81818 5.2308V6.61541M12.0909 6.61538H3.90909C3.40702 6.61538 3 7.02866 3 7.53846V13.0769C3 13.5867 3.40702 14 3.90909 14H12.0909C12.593 14 13 13.5867 13 13.0769V7.53846C13 7.02866 12.593 6.61538 12.0909 6.61538ZM8 10.7692C8.25104 10.7692 8.45455 10.5626 8.45455 10.3077C8.45455 10.0528 8.25104 9.84615 8 9.84615C7.74896 9.84615 7.54545 10.0528 7.54545 10.3077C7.54545 10.5626 7.74896 10.7692 8 10.7692Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'rain_cloud'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.62162 18.3686L8.41769 16.7764M14.7863 18.3686L15.5823 16.7764M10.4079 21.5529L11.2039 19.9607M3.24323 21.5529L4.0393 19.9607M17.5725 21.5529L18.3686 19.9607M3.24323 8.01964C3.24323 11.0973 5.73811 13.5921 8.81573 13.5921H16.7764C18.9747 13.5921 20.7568 11.8101 20.7568 9.61179C20.7568 7.4135 18.9747 5.63143 16.7764 5.63143C15.7937 5.63143 14.8942 5.98754 14.1999 6.57777C13.5645 4.19909 11.3947 2.44714 8.81573 2.44714C5.73811 2.44714 3.24323 4.94203 3.24323 8.01964Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'stop'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        fill="#E4E4E4"
      />
    </svg>
    <svg
      v-else-if="name == 'sun_rain'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41768 18.3686L9.21375 16.7764M15.5823 18.3686L16.3784 16.7764M11.2039 21.5529L12 19.9607M4.03929 21.5529L4.83536 19.9607M18.3686 21.5529L19.1646 19.9607M12 2.44714V4.03929M21.5529 12H19.9607M4.03929 12H2.44714M6.37087 6.37165L5.24505 5.24583M18.7551 5.24572L17.6292 6.37152M12 7.22357C9.36206 7.22357 7.22357 9.36206 7.22357 12C7.22357 12.5583 7.31934 13.0942 7.49537 13.5921H16.5046C16.6807 13.0942 16.7764 12.5583 16.7764 12C16.7764 9.36206 14.6379 7.22357 12 7.22357Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'thermometer'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.3489C14.6379 22.3489 16.7764 20.2105 16.7764 17.5725C16.7764 15.8045 15.8159 14.2609 14.3882 13.4351V4.03928C14.3882 2.7203 13.319 1.65106 12 1.65106C10.681 1.65106 9.61179 2.7203 9.61179 4.03928V13.4351C8.18411 14.2609 7.22357 15.8045 7.22357 17.5725C7.22357 20.2105 9.36206 22.3489 12 22.3489Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.2039 17.5725C11.2039 17.677 11.2245 17.7805 11.2645 17.8771C11.3045 17.9737 11.3632 18.0615 11.4371 18.1354C11.511 18.2093 11.5988 18.268 11.6954 18.308C11.7919 18.348 11.8955 18.3686 12 18.3686C12.1045 18.3686 12.2081 18.348 12.3046 18.308C12.4012 18.268 12.489 18.2093 12.5629 18.1354C12.6368 18.0615 12.6955 17.9737 12.7355 17.8771C12.7755 17.7805 12.7961 17.677 12.7961 17.5725C12.7961 17.4679 12.7755 17.3644 12.7355 17.2678C12.6955 17.1713 12.6368 17.0835 12.5629 17.0096C12.489 16.9357 12.4012 16.877 12.3046 16.837C12.2081 16.797 12.1045 16.7764 12 16.7764C11.8955 16.7764 11.7919 16.797 11.6954 16.837C11.5988 16.877 11.511 16.9357 11.4371 17.0096C11.3632 17.0835 11.3045 17.1713 11.2645 17.2678C11.2245 17.3644 11.2039 17.4679 11.2039 17.5725Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'upload_tray'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.24323 19.1646C3.24323 20.0091 3.57871 20.819 4.17589 21.4162C4.77305 22.0135 5.58299 22.3489 6.42751 22.3489H17.5725C18.417 22.3489 19.2269 22.0135 19.8241 21.4162C20.4213 20.819 20.7568 20.0091 20.7568 19.1646M8.01965 5.63142L12 1.65106M12 1.65106L15.9804 5.63142M12 1.65106V15.9803"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'water_droplet'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9607 14.3882C19.9607 18.7847 16.3966 22.3489 12 22.3489C7.60345 22.3489 4.03931 18.7847 4.03931 14.3882C4.03931 9.61178 12 1.65106 12 1.65106C12 1.65106 19.9607 9.61178 19.9607 14.3882Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'monitor'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.69874 10.1903H9.05463L10.6411 7.1087L13.0449 12.7826L15.1122 10.1903H17.4199M10.4615 17.087L8.92308 21M13.5385 17.087L15.0769 21M7.38462 21H16.6154M21.2308 3H2.76923C2.34443 3 2 3.35042 2 3.78261V16.3043C2 16.7365 2.34443 17.087 2.76923 17.087H21.2308C21.6556 17.087 22 16.7365 22 16.3043V3.78261C22 3.35042 21.6556 3 21.2308 3Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'caution_circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7.22356V12.398M12 22.3489C17.7156 22.3489 22.3489 17.7156 22.3489 12C22.3489 6.28444 17.7156 1.65106 12 1.65106C6.28444 1.65106 1.65106 6.28444 1.65106 12C1.65106 17.7156 6.28444 22.3489 12 22.3489ZM12 16.7764C11.7802 16.7764 11.602 16.5982 11.602 16.3784C11.602 16.1586 11.7802 15.9803 12 15.9803C12.2198 15.9803 12.398 16.1586 12.398 16.3784C12.398 16.5982 12.2198 16.7764 12 16.7764Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'caution_triangle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8.81571V13.9902M10.6247 4.00865L2.25172 18.3624C1.63256 19.4238 2.39818 20.7568 3.62699 20.7568H20.3731C21.6019 20.7568 22.3674 19.4238 21.7482 18.3624L13.3753 4.00865C12.7609 2.95545 11.2391 2.95545 10.6247 4.00865ZM12 17.5725C11.7802 17.5725 11.602 17.3943 11.602 17.1745C11.602 16.9546 11.7802 16.7764 12 16.7764C12.2198 16.7764 12.398 16.9546 12.398 17.1745C12.398 17.3943 12.2198 17.5725 12 17.5725Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'check_circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6443 8.41767L10.2757 16.3784L7.0914 13.9902M12 22.3489C17.7156 22.3489 22.3489 17.7156 22.3489 12C22.3489 6.28444 17.7156 1.65106 12 1.65106C6.28444 1.65106 1.65106 6.28444 1.65106 12C1.65106 17.7156 6.28444 22.3489 12 22.3489Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'eye_off'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2519 14.2516C15.4954 13.0081 15.4954 10.9919 14.2519 9.74837C13.0083 8.50482 10.9921 8.50482 9.74861 9.74837M1.65106 1.65106L22.3489 22.3489M6.28133 6.28165C7.94012 5.01491 9.89881 4.03928 11.9997 4.03928C16.4502 4.03928 20.2627 8.41767 21.9377 10.6666C22.2021 11.0323 22.3486 11.5074 22.3486 12C22.3486 12.4926 22.2021 12.9677 21.9377 13.3334C21.0534 14.5207 19.5733 16.3016 17.718 17.7183M3.5749 8.8157C2.96582 9.49386 2.45508 10.1388 2.06204 10.6666C1.7975 11.0323 1.65106 11.5074 1.65106 12C1.65106 12.4926 1.7975 12.9677 2.06204 13.3334C3.73698 15.5823 7.54944 19.9607 12 19.9607C12.801 19.9607 13.5814 19.8188 14.3323 19.5732"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_take-off'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      :width="size"
      :height="size"
    >
      <path
        d="M3.33331 5.33333H6.44442M9.55553 5.33333H12.6666M4.88887 5.33333V7.66666M11.1111 5.33333V7.66666M5.27776 10H4.88887C4.47631 10 4.08065 9.83611 3.78893 9.54438C3.4972 9.25266 3.33331 8.857 3.33331 8.44444V7.66666H12.6666V8.44444C12.6666 8.857 12.5028 9.25266 12.211 9.54438C11.9193 9.83611 11.5236 10 11.1111 10H10.7222M5.27776 10C5.27776 10.6188 5.52359 11.2123 5.96117 11.6499C6.39876 12.0875 6.99225 12.3333 7.61109 12.3333H8.38887C9.00771 12.3333 9.6012 12.0875 10.0388 11.6499C10.4763 11.2123 10.7222 10.6188 10.7222 10M5.27776 10H10.7222M5.66665 11.2833C5.29924 11.6107 5.00531 12.0121 4.80422 12.4612C4.60314 12.9103 4.49945 13.3969 4.49998 13.8889V14.6667H5.27776M10.3333 11.2833C10.7007 11.6107 10.9947 12.0121 11.1957 12.4612C11.3968 12.9103 11.5005 13.3969 11.5 13.8889V14.6667H10.7222M5.99999 3.33333L7.99998 1.33333M7.99998 1.33333L9.99998 3.33333M7.99998 1.33333V5.33333"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_land'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      :width="size"
      :height="size"
    >
      <path
        d="M3.33331 1.33333H6.44442M9.55553 1.33333H12.6666M4.88887 1.33333V3.66666M11.1111 1.33333V3.66666M5.27776 6H4.88887C4.47631 6 4.08065 5.83611 3.78893 5.54438C3.4972 5.25266 3.33331 4.857 3.33331 4.44444V3.66666H12.6666V4.44444C12.6666 4.857 12.5028 5.25266 12.211 5.54438C11.9193 5.83611 11.5236 6 11.1111 6H10.7222M5.27776 6C5.27776 6.61883 5.52359 7.21233 5.96117 7.64991C6.39876 8.0875 6.99225 8.33333 7.61109 8.33333H8.38887C9.00771 8.33333 9.6012 8.0875 10.0388 7.64991C10.4763 7.21233 10.7222 6.61883 10.7222 6M5.27776 6H10.7222M5.66665 7.28334C5.29924 7.61066 5.00531 8.01207 4.80422 8.46119C4.60314 8.91028 4.49945 9.39686 4.49998 9.88888V10.6667H5.27776M10.3333 7.28334C10.7007 7.61066 10.9947 8.01207 11.1957 8.46119C11.3968 8.91028 11.5005 9.39686 11.5 9.88888V10.6667H10.7222M5.99998 12.6667L7.99997 14.6667M7.99997 14.6667L9.99998 12.6667M7.99997 14.6667V10.6667"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'roadmap'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.2039 4.83536H17.1744C18.0898 4.8356 18.9704 5.18629 19.6354 5.81541C20.3004 6.44453 20.6993 7.30435 20.7502 8.21835C20.8011 9.13235 20.5002 10.0312 19.9093 10.7303C19.3183 11.4294 18.4822 11.8758 17.5724 11.9777"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.796 12H6.8255C5.91008 12.0002 5.02949 12.3509 4.36451 12.98C3.69954 13.6092 3.30063 14.469 3.24969 15.383C3.19876 16.297 3.49966 17.1958 4.09061 17.8949C4.68157 18.594 5.51774 19.0404 6.42747 19.1424"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.5528 19.1646H11.2039"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.42745 4.83536H3.24316"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.42749 4.83536C6.42749 5.14898 6.48926 5.45954 6.60928 5.74929C6.7293 6.03904 6.90522 6.30231 7.12698 6.52408C7.34875 6.74585 7.61202 6.92176 7.90177 7.04178C8.19153 7.1618 8.50208 7.22357 8.8157 7.22357C9.12933 7.22357 9.43988 7.1618 9.72963 7.04178C10.0194 6.92176 10.2827 6.74585 10.5044 6.52408C10.7262 6.30231 10.9021 6.03904 11.0221 5.74929C11.1421 5.45954 11.2039 5.14898 11.2039 4.83536C11.2039 4.52173 11.1421 4.21118 11.0221 3.92143C10.9021 3.63168 10.7262 3.3684 10.5044 3.14664C10.2827 2.92487 10.0194 2.74895 9.72963 2.62894C9.43988 2.50892 9.12933 2.44714 8.8157 2.44714C8.50208 2.44714 8.19153 2.50892 7.90177 2.62894C7.61202 2.74895 7.34875 2.92487 7.12698 3.14664C6.90522 3.3684 6.7293 3.63168 6.60928 3.92143C6.48926 4.21118 6.42749 4.52173 6.42749 4.83536Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.42749 19.1646C6.42749 19.4783 6.48926 19.7888 6.60928 20.0786C6.7293 20.3683 6.90522 20.6316 7.12698 20.8534C7.34875 21.0751 7.61202 21.251 7.90177 21.3711C8.19153 21.4911 8.50208 21.5529 8.8157 21.5529C9.12933 21.5529 9.43988 21.4911 9.72963 21.3711C10.0194 21.251 10.2827 21.0751 10.5044 20.8534C10.7262 20.6316 10.9021 20.3683 11.0221 20.0786C11.1421 19.7888 11.2039 19.4783 11.2039 19.1646C11.2039 18.851 11.1421 18.5405 11.0221 18.2507C10.9021 17.961 10.7262 17.6977 10.5044 17.4759C10.2827 17.2542 10.0194 17.0782 9.72963 16.9582C9.43988 16.8382 9.12933 16.7764 8.8157 16.7764C8.50208 16.7764 8.19153 16.8382 7.90177 16.9582C7.61202 17.0782 7.34875 17.2542 7.12698 17.4759C6.90522 17.6977 6.7293 17.961 6.60928 18.2507C6.48926 18.5405 6.42749 18.851 6.42749 19.1646Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.796 12C12.796 12.6334 13.0476 13.2408 13.4955 13.6887C13.9434 14.1366 14.5508 14.3882 15.1842 14.3882C15.8176 14.3882 16.4251 14.1366 16.873 13.6887C17.3208 13.2408 17.5724 12.6334 17.5724 12C17.5724 11.3666 17.3208 10.7592 16.873 10.3113C16.4251 9.8634 15.8176 9.61179 15.1842 9.61179C14.5508 9.61179 13.9434 9.8634 13.4955 10.3113C13.0476 10.7592 12.796 11.3666 12.796 12Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.1646 21.5306C20.0609 21.5306 21.255 20.3365 21.5528 19.1424C21.2534 17.9482 20.0593 16.7541 19.1646 16.7541"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'lights'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 2V3.09091M8 12.9091V14M3.75636 3.75636L4.53091 4.53091M11.4691 11.4691L12.2436 12.2436M2 8H3.09091M12.9091 8H14M3.75636 12.2436L4.53091 11.4691M11.4691 4.53091L12.2436 3.75636M10.7273 8C10.7273 9.50623 9.50623 10.7273 8 10.7273C6.49377 10.7273 5.27273 9.50623 5.27273 8C5.27273 6.49377 6.49377 5.27273 8 5.27273C9.50623 5.27273 10.7273 6.49377 10.7273 8Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_power'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 1.33325H6M10 1.33325H14M4 1.33325V4.66659M12 1.33325V4.66659M4.5 7.99992H4C3.46957 7.99992 2.96086 7.7658 2.58579 7.34904C2.21071 6.9323 2 6.36706 2 5.7777V4.66659H14V5.7777C14 6.36706 13.7893 6.9323 13.4142 7.34904M4.5 7.99992C4.5 8.88397 4.81607 9.73182 5.37868 10.3569C5.94129 10.9821 6.70435 11.3333 7.5 11.3333M4.5 7.99992H8H9.75M5 9.83327C4.52762 10.3009 4.14971 10.8743 3.89117 11.5159C3.63263 12.1575 3.49932 12.8526 3.5 13.5555V14.6666H4.5M13.8859 10.0584C14.2588 10.436 14.5127 10.917 14.6155 11.4406C14.7183 11.9643 14.6655 12.507 14.4636 13.0003C14.2617 13.4935 13.9199 13.9151 13.4814 14.2117C13.0429 14.5083 12.5274 14.6666 12 14.6666C11.4726 14.6666 10.9571 14.5083 10.5186 14.2117C10.0801 13.9151 9.73826 13.4935 9.53641 13.0003C9.33455 12.507 9.28169 11.9643 9.38451 11.4406C9.48733 10.917 9.74122 10.436 10.1141 10.0584M12.0015 8.66658V11.6661"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'rc_power'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.42589 2.22669C4.87261 1.92887 6.2128 1.33325 7.99972 1.33325C9.78663 1.33325 11.1268 1.92887 11.5736 2.22669M6.21251 4.07624C6.51033 3.92734 7.28466 3.62953 7.99942 3.62953C8.71418 3.62953 9.48852 3.92734 9.78634 4.07624M5.38892 8.2777V10.8454M6.67259 9.56161H4.10486M8 12.5738H6.39225L5.99425 13.3509C5.58183 14.1561 4.72638 14.6666 3.78922 14.6666C2.3212 14.6666 1.18117 13.4421 1.34994 12.0467L1.74812 9.03231C1.95148 7.35084 3.43955 6.0822 5.20848 6.0822H10.7915C12.2841 6.0822 13.5767 6.9854 14.0663 8.2777M13.8859 10.0584C14.2588 10.436 14.5127 10.917 14.6155 11.4406C14.7183 11.9643 14.6655 12.507 14.4636 13.0003C14.2617 13.4935 13.92 13.9151 13.4814 14.2117C13.0429 14.5083 12.5274 14.6666 12 14.6666C11.4726 14.6666 10.9571 14.5083 10.5186 14.2117C10.0801 13.9151 9.73827 13.4935 9.53642 13.0003C9.33456 12.507 9.2817 11.9643 9.38452 11.4406C9.48734 10.917 9.74123 10.436 10.1141 10.0584M12.0015 8.66658V11.6661"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_streamline'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5.17163 5.20329H9.37346"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6261 5.20329H18.8279"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.27271 5.20329V8.71455"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.7272 5.20329V8.71455"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.71413 18.7968H8.32317C7.74301 18.7968 7.27271 18.3264 7.27271 17.7463C7.27199 17.0817 7.41203 16.4245 7.68362 15.818C7.89836 15.3384 8.19149 14.8991 8.55011 14.5176"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2854 18.7968H15.6767C16.2568 18.7968 16.7271 18.3264 16.7271 17.7463C16.7279 17.0817 16.5878 16.4245 16.3162 15.818C16.1012 15.3378 15.8075 14.8978 15.4483 14.516"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.48961 12.5476C8.46722 12.7849 8.45312 13.0249 8.45312 13.2672C8.45312 13.5156 8.46794 13.7616 8.49131 14.0048C8.59209 15.0531 9.49309 15.8753 10.5434 15.9526C11.0203 15.9878 11.5065 16.0135 12.0001 16.0135C12.4936 16.0135 12.9798 15.9878 13.4567 15.9526C14.507 15.8753 15.408 15.0531 15.5088 14.0048C15.5321 13.7616 15.547 13.5156 15.547 13.2672C15.547 13.0249 15.5329 12.7849 15.5105 12.5476"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.39443 8.7713C5.82139 8.81233 5.37596 9.29049 5.44477 9.86086C5.49625 10.2877 5.57157 10.7118 5.65017 11.1022C5.8033 11.8627 6.45514 12.4377 7.22935 12.4866C7.36355 12.4951 7.49825 12.5037 7.6334 12.5123C9.04237 12.6022 10.5029 12.6954 11.9999 12.6954C13.4968 12.6954 14.9574 12.6022 16.3663 12.5123C16.5015 12.5037 16.6362 12.4951 16.7704 12.4866C17.5446 12.4377 18.1965 11.8627 18.3496 11.1022C18.4324 10.6911 18.5113 10.2719 18.5628 9.84713C18.6312 9.28259 18.1859 8.81293 17.6188 8.77232L15.9096 8.64997C13.3062 8.46359 10.6929 8.46359 8.08947 8.64996L6.39443 8.7713Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 23H2C1.44772 23 1 22.5523 1 22V17.5M6.5 1H2C1.44772 1 1 1.44772 1 2V6.5M17.5 1H22C22.5523 1 23 1.44772 23 2V6.5M23 17.5V22C23 22.5523 22.5523 23 22 23H17.5"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>

    <svg
      v-else-if="name == 'dash'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M2 8H14" :stroke="color" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name == 'x'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 2L2 14M2 2L14 14"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'muster'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path
        d="M2.70453 2.70453L11.1941 11.1941"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.194 5.88811V11.1941H5.88809"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.806 5.88811V11.1941H27.1119"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.806 11.1941L30.2955 2.70453"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.2955 30.2955L21.806 21.806"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.806 27.1119V21.806H27.1119"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.194 27.1119V21.806H5.88809"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.1941 21.806L2.70453 30.2955"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3164 16.5C13.3164 17.3443 13.6518 18.1541 14.2489 18.7511C14.8459 19.3482 15.6557 19.6836 16.5 19.6836C17.3443 19.6836 18.1541 19.3482 18.7511 18.7511C19.3482 18.1541 19.6836 17.3443 19.6836 16.5C19.6836 15.6557 19.3482 14.8459 18.7511 14.2489C18.1541 13.6518 17.3443 13.3164 16.5 13.3164C15.6557 13.3164 14.8459 13.6518 14.2489 14.2489C13.6518 14.8459 13.3164 15.6557 13.3164 16.5Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'muster-marker'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M4 4L11.3846 11.3846M11.3846 11.3846V6.76923M11.3846 11.3846H6.76923M20.6154 6.76923V11.3846M20.6154 11.3846H25.2308M20.6154 11.3846L28 4M28 28L20.6154 20.6154M20.6154 20.6154V25.2308M20.6154 20.6154H25.2308M11.3846 25.2308V20.6154M11.3846 20.6154H6.76923M11.3846 20.6154L4 28M13.2308 16C13.2308 16.7344 13.5225 17.4388 14.0419 17.9581C14.5612 18.4775 15.2656 18.7692 16 18.7692C16.7344 18.7692 17.4388 18.4775 17.9581 17.9581C18.4775 17.4388 18.7692 16.7344 18.7692 16C18.7692 15.2656 18.4775 14.5612 17.9581 14.0419C17.4388 13.5225 16.7344 13.2308 16 13.2308C15.2656 13.2308 14.5612 13.5225 14.0419 14.0419C13.5225 14.5612 13.2308 15.2656 13.2308 16Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'eye_on'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.938 10.6666C22.2024 11.0323 22.3489 11.5074 22.3489 12C22.3489 12.4926 22.2024 12.9677 21.938 13.3334C20.2631 15.5823 16.4505 19.9607 12 19.9607C7.54944 19.9607 3.73698 15.5823 2.06204 13.3334C1.7975 12.9677 1.65106 12.4926 1.65106 12C1.65106 11.5074 1.7975 11.0323 2.06204 10.6666C3.73698 8.41767 7.54944 4.03928 12 4.03928C16.4505 4.03928 20.2631 8.41767 21.938 10.6666Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15.1843C13.7586 15.1843 15.1843 13.7586 15.1843 12C15.1843 10.2414 13.7586 8.8157 12 8.8157C10.2414 8.8157 8.8157 10.2414 8.8157 12C8.8157 13.7586 10.2414 15.1843 12 15.1843Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'info_circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.61179 16.7764H14.3882M12 16.7764V11.2039H10.4079M12 22.3489C17.7156 22.3489 22.3489 17.7156 22.3489 12C22.3489 6.28444 17.7156 1.65106 12 1.65106C6.28445 1.65106 1.65108 6.28444 1.65108 12C1.65108 17.7156 6.28445 22.3489 12 22.3489ZM12 7.6216C11.7802 7.6216 11.602 7.44339 11.602 7.22356C11.602 7.00373 11.7802 6.82553 12 6.82553C12.2198 6.82553 12.398 7.00373 12.398 7.22356C12.398 7.44339 12.2198 7.6216 12 7.6216Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'link_chain'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_90_26)">
        <path
          d="M8.81572 15.1843L15.1843 8.81571M5.688 10.3513L3.29979 12.7395C1.10151 14.9378 1.10151 18.502 3.29979 20.7003C5.49809 22.8985 9.06222 22.8985 11.2605 20.7003L13.6487 18.312M18.3119 13.6487L20.7001 11.2605C22.8984 9.0622 22.8984 5.49808 20.7001 3.29978C18.5017 1.10149 14.9376 1.10149 12.7393 3.29978L10.3511 5.68799"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_90_26">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="name == 'uav'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.07324 2.11907H8.18177"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8179 2.11907H21.9264"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.12769 2.11907V7.22367"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8723 2.11907V7.22367"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.2232 21.881H6.65483C5.8114 21.881 5.12769 21.1972 5.12769 20.3538C5.12664 19.3877 5.33023 18.4323 5.72506 17.5505C6.03725 16.8533 6.4634 16.2146 6.98475 15.6601"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.7765 21.881H17.3454C18.1887 21.881 18.8724 21.1972 18.8724 20.3538C18.8735 19.3877 18.6699 18.4323 18.275 17.5505C17.9625 16.8524 17.5355 16.2128 17.0132 15.6577"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.89678 12.7961C6.86424 13.1411 6.84375 13.49 6.84375 13.8422C6.84375 14.2033 6.86529 14.561 6.89927 14.9145C7.04578 16.4386 8.35563 17.6338 9.88258 17.7462C10.5759 17.7973 11.2827 17.8347 12.0002 17.8347C12.7177 17.8347 13.4245 17.7973 14.1178 17.7462C15.6448 17.6338 16.9547 16.4386 17.1011 14.9145C17.135 14.561 17.1567 14.2033 17.1567 13.8422C17.1567 13.49 17.1362 13.1411 17.1037 12.7961"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.85101 7.30617C3.01794 7.36581 2.37038 8.06096 2.47042 8.89014C2.54527 9.5106 2.65476 10.1273 2.76903 10.6948C2.99164 11.8004 3.93927 12.6363 5.0648 12.7074C5.2599 12.7198 5.45572 12.7322 5.65221 12.7448C7.70053 12.8754 9.82389 13.0109 12.0001 13.0109C14.1763 13.0109 16.2997 12.8754 18.3479 12.7448C18.5444 12.7322 18.7402 12.7198 18.9354 12.7074C20.0609 12.6363 21.0086 11.8004 21.2311 10.6948C21.3515 10.0971 21.4663 9.48769 21.5411 8.87018C21.6406 8.04946 20.9933 7.36669 20.1687 7.30765L17.684 7.12977C13.8993 6.85882 10.1 6.85882 6.31522 7.12976L3.85101 7.30617Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone_bottom_view'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size + 8"
      :height="size + 8"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M12.0312 5.03125C12.5534 4.50911 13.2616 4.21577 14 4.21577C14.7384 4.21577 15.4466 4.50911 15.9688 5.03125"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0312 22.9688C12.5534 23.4909 13.2616 23.7842 14 23.7842C14.7384 23.7842 15.4466 23.4909 15.9688 22.9688"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 3.5C11.4283 2.57174 12.6872 2.05025 14 2.05025C15.3128 2.05025 16.5717 2.57174 17.5 3.5"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 24.5C11.4283 25.4283 12.6872 25.9497 14 25.9497C15.3128 25.9497 16.5717 25.4283 17.5 24.5"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 9L10 9"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 9L24 9"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.1128 20.0002H10.7693C10.2595 20.0002 9.84619 19.5849 9.84619 19.0728C9.84556 18.4862 9.96861 17.906 10.2073 17.3706C10.396 16.9472 10.6535 16.5594 10.9687 16.2227"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8872 20.0001H17.2311C17.7408 20.0001 18.154 19.5849 18.154 19.0728C18.1547 18.4861 18.0316 17.906 17.793 17.3706C17.6041 16.9466 17.346 16.5582 17.0303 16.2212"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.9156 14.4829C10.8959 14.6924 10.8835 14.9043 10.8835 15.1182C10.8835 15.3374 10.8966 15.5546 10.9171 15.7693C11.0057 16.6947 11.7974 17.4205 12.7203 17.4888C13.1394 17.5198 13.5666 17.5425 14.0003 17.5425C14.434 17.5425 14.8612 17.5198 15.2803 17.4888C16.2032 17.4205 16.995 16.6947 17.0835 15.7693C17.104 15.5546 17.1171 15.3374 17.1171 15.1182C17.1171 14.9043 17.1047 14.6924 17.085 14.4829"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.13889 11.6073C8.63535 11.6435 8.24395 12.0656 8.30441 12.5692C8.34965 12.9459 8.35153 12.8631 8.4206 13.2077C8.55515 13.8791 9.12793 14.3867 9.80825 14.4299C9.92618 14.4374 10.0445 14.4449 10.1633 14.4526C11.4014 14.5319 12.6848 14.6141 14.0002 14.6141C15.3156 14.6141 16.599 14.5319 17.8371 14.4526C17.9558 14.4449 18.0742 14.4374 18.1922 14.4299C18.8725 14.3867 19.5448 13.8791 19.6793 13.2077C19.736 12.9249 19.8315 12.557 19.8315 12.557C19.8916 12.0587 19.5003 11.6441 19.0019 11.6082L17.5001 11.5002C15.2124 11.3357 12.916 11.3357 10.6284 11.5002L9.13889 11.6073Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8 12H6" :stroke="color" stroke-width="1.5" stroke-linecap="round" />
      <path d="M22 12H20" :stroke="color" stroke-width="1.5" stroke-linecap="round" />
    </svg>

    <svg
      v-else-if="name == 'humidity_none'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.3551 4.95581C5.92602 2.69603 8.00005 1.36606 8.00005 1.36606C8.00005 1.36606 13.3762 4.8157 13.3762 10.0411C13.3762 11.0155 13.0142 11.9591 12.3519 12.7371"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.97944 7.71765C2.74488 8.47027 2.62466 9.25385 2.6228 10.0422C2.6228 11.2596 3.18961 12.4272 4.19796 13.2891C5.20632 14.1499 6.57344 14.6339 8 14.6339C8.67613 14.6339 9.33846 14.5257 9.95621 14.3187"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.20691 1.20685C5.87401 7.18481 8.68786 9.96682 14.7932 14.7931"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'humidity'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12 9.38462C12 11.9336 10.2091 14 8 14C5.79086 14 4 11.9336 4 9.38462C4 6.61538 8 2 8 2C8 2 12 6.61538 12 9.38462Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'time'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.5409 2.10907C12.3092 2.49016 12.9714 3.05534 13.4684 3.75428"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5087 9.59214C14.5915 9.09539 14.6339 8.56361 14.6339 8C14.6339 7.43638 14.5915 6.9046 14.5087 6.40785"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.7201 11.8562C12.6597 13.6627 10.7067 14.6339 8.00002 14.6339C3.7543 14.6339 1.36609 12.2457 1.36609 8C1.36609 3.75429 3.7543 1.36607 8.00002 1.36607C8.34286 1.36926 9.13893 1.40004 9.58367 1.49875"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 5.61179V8.26536L10.1887 10.816"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'time_alt'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.07692 4.30769V7.07692H9.38461M12.1332 6.61538C11.9 4.02777 9.72525 2 7.07692 2C4.27301 2 2 4.27301 2 7.07692C2 8.09857 2.30177 9.04974 2.82105 9.84615M5.03182 10.063L5.99328 9.73959C6.05679 9.72042 6.12474 9.72187 6.18738 9.74372C6.25001 9.76557 6.30411 9.80671 6.3419 9.86123L7.01111 10.8573L10.6501 8.99073C10.9346 8.81814 11.2531 8.70959 11.5838 8.67267C11.9144 8.63575 12.2491 8.67133 12.5645 8.77694C12.88 8.88255 13.1687 9.05564 13.4104 9.28418C13.6522 9.51272 13.8412 9.7912 13.9644 10.1002C13.9921 10.1777 14.0039 10.26 13.9989 10.3421C13.9939 10.4242 13.9724 10.5045 13.9356 10.5781C13.8987 10.6517 13.8474 10.717 13.7846 10.7702C13.7219 10.8234 13.6489 10.8634 13.5704 10.8877L11.1745 11.7077L10.9879 11.8108L10.5608 13.3766C10.5452 13.4304 10.5172 13.4797 10.4791 13.5207C10.441 13.5617 10.3939 13.5933 10.3415 13.6129L9.25217 13.9778C9.19628 13.9993 9.13561 14.0053 9.07659 13.9952C9.01756 13.985 8.96237 13.9592 8.91685 13.9202C8.87134 13.8814 8.83718 13.8308 8.818 13.7741C8.79883 13.7173 8.79534 13.6565 8.8079 13.5979L8.99087 12.4964L8.83487 12.5456L6.49004 13.3425C6.33771 13.3974 6.16993 13.3904 6.02274 13.3229C5.87554 13.2555 5.76066 13.133 5.70277 12.9818L4.83859 10.4375C4.8186 10.3623 4.8273 10.2822 4.86301 10.213C4.89872 10.1438 4.95889 10.0904 5.03182 10.063Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'signal_bars'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.73027 14.4902H2.56236C2.00439 14.4902 1.54009 14.0582 1.51535 13.5009C1.46165 12.2912 1.46336 11.0954 1.52047 9.88487C1.54451 9.37554 1.93774 8.95953 2.44604 8.91914C3.28292 8.85266 4.01873 8.85266 4.85559 8.91914C5.3639 8.95953 5.75714 9.37554 5.78117 9.88487C5.8538 11.4242 5.83683 12.9398 5.73027 14.4902Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0796 14.4903H5.92074C5.80565 11.7326 5.79507 9.04207 5.88899 6.29678C5.90577 5.80643 6.25933 5.38801 6.74551 5.32221C7.61982 5.20386 8.38055 5.20386 9.25486 5.32221C9.74105 5.38801 10.0946 5.80643 10.1114 6.29678C10.2053 9.04207 10.1947 11.7326 10.0796 14.4903Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3586 14.4903H10.2177C10.1016 11.7074 10.0919 5.87319 10.1886 2.5799C10.203 2.08949 10.5563 1.67301 11.0425 1.60721C11.9169 1.48886 12.6776 1.48886 13.5519 1.60721C14.038 1.67301 14.3914 2.08949 14.4058 2.5799C14.4919 5.51275 14.4936 10.4607 14.4109 13.4742C14.3953 14.0429 13.9275 14.4903 13.3586 14.4903Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'thrust_master'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.64884 13.6072C1.79276 14.0542 2.20478 14.3731 2.67408 14.3905C4.37596 14.4538 6.16076 14.5436 8.00026 14.5436C9.83977 14.5436 11.6246 14.4538 13.3265 14.3905C13.7957 14.3731 14.2078 14.0542 14.3517 13.6072C14.4919 13.1717 14.622 12.7226 14.622 12.2635C14.622 11.8044 14.4919 11.3552 14.3517 10.9198C14.2078 10.4727 13.7957 10.1539 13.3265 10.1365C11.6246 10.0732 9.83977 9.9834 8.00026 9.9834C6.16076 9.9834 4.37596 10.0732 2.67408 10.1365C2.20478 10.1539 1.79276 10.4727 1.64883 10.9198C1.50863 11.3552 1.37854 11.8044 1.37854 12.2635C1.37854 12.7226 1.50863 13.1717 1.64884 13.6072Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.41781 6.63574C11.0752 6.63574 12.0074 5.70348 12.0074 4.04611C12.0074 2.38875 11.0752 1.45648 9.41781 1.45648C7.76045 1.45648 6.82819 2.38875 6.82819 4.04611C6.82819 5.70348 7.76045 6.63574 9.41781 6.63574Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.41846 6.63562V9.98342"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.47003 7.62598H2.93079"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'home'"
      width="28"
      height="28"
      style="opacity: 0.8"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V6.5C1.5 6.77614 1.27614 7 1 7C0.723858 7 0.5 6.77614 0.5 6.5V3C0.5 1.61929 1.61929 0.5 3 0.5H6.5C6.77614 0.5 7 0.723858 7 1C7 1.27614 6.77614 1.5 6.5 1.5H3ZM17 1C17 0.723858 17.2239 0.5 17.5 0.5H21C22.3807 0.5 23.5 1.61929 23.5 3V6.5C23.5 6.77614 23.2761 7 23 7C22.7239 7 22.5 6.77614 22.5 6.5V3C22.5 2.17157 21.8284 1.5 21 1.5H17.5C17.2239 1.5 17 1.27614 17 1ZM1 17C1.27614 17 1.5 17.2239 1.5 17.5V21C1.5 21.8284 2.17157 22.5 3 22.5H6.5C6.77614 22.5 7 22.7239 7 23C7 23.2761 6.77614 23.5 6.5 23.5H3C1.61929 23.5 0.5 22.3807 0.5 21V17.5C0.5 17.2239 0.723858 17 1 17ZM23 17C23.2761 17 23.5 17.2239 23.5 17.5V21C23.5 22.3807 22.3807 23.5 21 23.5H17.5C17.2239 23.5 17 23.2761 17 23C17 22.7239 17.2239 22.5 17.5 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V17.5C22.5 17.2239 22.7239 17 23 17Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.03934 4.87523C4.03934 4.39185 4.4231 4 4.89648 4H9.2679C9.74128 4 10.125 4.39185 10.125 4.87523C10.125 5.3586 9.74128 5.75046 9.2679 5.75046H7.93931V8.03853H16.0607V5.75046H14.7321C14.2588 5.75046 13.875 5.3586 13.875 4.87523C13.875 4.39185 14.2588 4 14.7321 4H19.1035C19.5769 4 19.9607 4.39185 19.9607 4.87523C19.9607 5.3586 19.5769 5.75046 19.1035 5.75046H17.775V8.03853H19.4286C19.7441 8.03853 20 8.29977 20 8.62202V9.78899C20 10.5627 19.699 11.3048 19.1632 11.8519C18.6434 12.3826 17.9442 12.6877 17.2112 12.7056C17.1887 12.7034 17.1659 12.7023 17.1429 12.7023H6.85714C6.83408 12.7023 6.81128 12.7034 6.78878 12.7056C6.05579 12.6877 5.35653 12.3826 4.83684 11.8519C4.30102 11.3048 4 10.5627 4 9.78899V8.62202C4 8.29977 4.25584 8.03853 4.57143 8.03853H6.22503V5.75046H4.89648C4.4231 5.75046 4.03934 5.3586 4.03934 4.87523ZM7.69294 14.161H16.4037C17.032 14.8428 17.311 15.7716 17.4326 16.5685C17.5877 17.5836 17.5239 18.6132 17.4169 19.2687C17.348 19.6906 16.9904 20 16.5714 20H15.4286C14.9552 20 14.5714 19.6081 14.5714 19.1248C14.5714 18.6414 14.9552 18.2495 15.4286 18.2495H15.8007C15.8226 17.8181 15.8123 17.32 15.7389 16.8381C15.6867 16.4974 15.609 16.2008 15.5088 15.9515C15.4738 15.994 15.4376 16.0347 15.3999 16.0733C14.6497 16.8393 13.6323 17.2695 12.5714 17.2695H11.4286C10.3677 17.2695 9.35029 16.8393 8.60015 16.0733C8.58591 16.0587 8.57189 16.0438 8.55807 16.0288C8.47209 16.2614 8.40456 16.532 8.35781 16.8381C8.28422 17.32 8.27395 17.8181 8.29593 18.2495H8.66803C9.14143 18.2495 9.52518 18.6414 9.52518 19.1248C9.52518 19.6081 9.14143 20 8.66803 20H7.52518C7.10617 20 6.74858 19.6906 6.6797 19.2687C6.57271 18.6132 6.50899 17.5836 6.66399 16.5685C6.78567 15.7716 7.06464 14.8428 7.69294 14.161Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'h-home'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="18.5"
        height="18.5"
        rx="9.25"
        :stroke="color"
        stroke-width="1.5"
      />
      <path
        d="M6.81019 14V6.72727H8.568V9.64631H11.4338V6.72727H13.188V14H11.4338V11.0774H8.568V14H6.81019Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'e_stop'"
      :width="size"
      :height="size"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="48" height="48" rx="24" fill="#AA2222" />
      <rect x="2" y="2" width="48" height="48" rx="24" stroke="#F4B309" stroke-width="4" />
      <path
        d="M23.5368 36L22.6624 35.4C21.7581 34.7796 20.971 33.995 20.3392 33.0846L18.3441 30.2094C17.8761 29.5352 17.8864 28.6265 18.3695 27.9636C19.0941 26.9692 20.5354 26.946 21.2898 27.9166L22.7895 29.8462M22.7895 29.8462C23.5368 29.8462 25.3305 30.1538 26.5262 31.3846M22.7895 29.8462L22.7899 20.2308C22.7899 19.1688 23.6264 18.3077 24.6583 18.3077C25.6901 18.3077 26.5267 19.1688 26.5267 20.2308M26.5267 20.2308V26M26.5267 20.2308V17.9231C26.5267 16.8611 27.3631 16 28.395 16C29.4268 16 30.2634 16.8611 30.2634 17.9231V21.7692M30.2634 21.7692V26.7692M30.2634 21.7692C30.2634 20.7072 31.0998 19.8462 32.1316 19.8462C33.1636 19.8462 34 20.7071 34 21.7692V33.1871C34 34.0031 33.685 34.7857 33.1245 35.3628L32.5053 36"
        stroke="#E4E4E4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'emergency_stop'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path
        d="M13.421 28.5L12.328 27.78C11.1977 27.0355 10.2137 26.094 9.42406 25.0015L6.93017 21.5513C6.34506 20.7422 6.35803 19.6518 6.96182 18.8563C7.86759 17.6631 9.66924 17.6352 10.6122 18.8L12.4869 21.1154M12.4869 21.1154C13.421 21.1154 15.6631 21.4846 17.1578 22.9615M12.4869 21.1154L12.4874 9.57692C12.4874 8.30251 13.5329 7.26923 14.8229 7.26923C16.1126 7.26923 17.1583 8.30251 17.1583 9.57692M17.1583 9.57692V16.5M17.1583 9.57692V6.80769C17.1583 5.53328 18.2039 4.5 19.4938 4.5C20.7836 4.5 21.8293 5.53328 21.8293 6.80769V11.4231M21.8293 11.4231V17.4231M21.8293 11.4231C21.8293 10.1487 22.8748 9.11538 24.1645 9.11538C25.4545 9.11538 26.5 10.1485 26.5 11.4231V25.1246C26.5 26.1038 26.1063 27.0429 25.4057 27.7354L24.6316 28.5"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'pause'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1 2C1 0.895431 1.89543 0 3 0H4C5.10457 0 6 0.895431 6 2V14C6 15.1046 5.10457 16 4 16H3C1.89543 16 1 15.1046 1 14V2Z"
        :fill="color"
      />
      <path
        d="M10 2C10 0.895431 10.8954 0 12 0H13C14.1046 0 15 0.895431 15 2V14C15 15.1046 14.1046 16 13 16H12C10.8954 16 10 15.1046 10 14V2Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'rectangle'"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="3" :fill="color" />
    </svg>

    <svg
      v-else-if="name == 'safe_location'"
      :width="size"
      :height="size"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="18.5"
        height="18.5"
        rx="9.25"
        :stroke="color"
        stroke-width="1.5"
      />
      <path
        d="M11.1808 8.90767C11.1571 8.64725 11.0517 8.44484 10.8647 8.30043C10.68 8.15365 10.4161 8.08026 10.0728 8.08026C9.84553 8.08026 9.65613 8.10985 9.50462 8.16903C9.3531 8.22822 9.23946 8.3099 9.16371 8.41406C9.08795 8.51586 9.04889 8.63305 9.04652 8.76562C9.04179 8.87453 9.06309 8.97041 9.11044 9.05327C9.16016 9.13613 9.23118 9.20952 9.32351 9.27344C9.41821 9.33499 9.53184 9.38944 9.66442 9.43679C9.79699 9.48414 9.94614 9.52557 10.1119 9.56108L10.7369 9.70312C11.0967 9.78125 11.4139 9.88542 11.6886 10.0156C11.9656 10.1458 12.1976 10.3009 12.3846 10.4808C12.574 10.6607 12.7172 10.8679 12.8143 11.1023C12.9113 11.3366 12.9611 11.5994 12.9634 11.8906C12.9611 12.3499 12.8451 12.7441 12.6154 13.0732C12.3858 13.4022 12.0555 13.6544 11.6246 13.8295C11.1961 14.0047 10.6789 14.0923 10.0728 14.0923C9.46437 14.0923 8.93407 14.0012 8.48189 13.8189C8.02971 13.6366 7.67815 13.3596 7.4272 12.9879C7.17625 12.6162 7.04723 12.1463 7.04013 11.5781H8.72337C8.73757 11.8125 8.80031 12.0078 8.91158 12.1641C9.02285 12.3203 9.17554 12.4387 9.36967 12.5192C9.56617 12.5997 9.79344 12.6399 10.0515 12.6399C10.2882 12.6399 10.4895 12.608 10.6552 12.544C10.8233 12.4801 10.9523 12.3913 11.0423 12.2777C11.1322 12.1641 11.1784 12.0339 11.1808 11.8871C11.1784 11.7498 11.1358 11.6326 11.0529 11.5355C10.9701 11.4361 10.8422 11.3509 10.6694 11.2798C10.4989 11.2064 10.2811 11.139 10.016 11.0774L9.25604 10.8999C8.6263 10.7554 8.13033 10.5223 7.76811 10.2003C7.40589 9.87595 7.22597 9.43797 7.22834 8.88636C7.22597 8.43655 7.34671 8.04238 7.59055 7.70384C7.8344 7.36529 8.17176 7.10133 8.60263 6.91193C9.0335 6.72254 9.52474 6.62784 10.0763 6.62784C10.6398 6.62784 11.1287 6.72372 11.543 6.91548C11.9596 7.10488 12.2828 7.37121 12.5124 7.71449C12.7421 8.05777 12.8593 8.45549 12.864 8.90767H11.1808Z"
        :fill="color"
      />
    </svg>

    <svg
      v-else-if="name == 'arrow_ne'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.5 3H11.5C12.0523 3 12.5 3.44772 12.5 4V10C12.5 10.5523 12.0523 11 11.5 11C10.9477 11 10.5 10.5523 10.5 10V6.41421L4.20711 12.7071C3.81658 13.0976 3.18342 13.0976 2.79289 12.7071C2.40237 12.3166 2.40237 11.6834 2.79289 11.2929L9.08579 5H5.5C4.94772 5 4.5 4.55228 4.5 4C4.5 3.44772 4.94772 3 5.5 3Z"
        :fill="color"
      />
    </svg>
    <svg
      v-else-if="name == 'flight-direction'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      height="size"
      viewBox="0 0 49 48"
      fill="none"
    >
      <path
        d="M31.3957 37.6371C37.471 32.0051 38.0651 11.0003 38.0651 11.0003C38.0651 11.0003 17.0756 10.0045 11.0003 15.6365C4.925 21.2685 4.56567 30.7592 10.1977 36.8345C15.8298 42.9098 25.3204 43.2691 31.3957 37.6371Z"
        :fill="color"
      />
      <path
        d="M16.1831 31.895C15.3793 32.0764 14.7133 31.2623 15.0505 30.5104L21.2135 16.7656C21.6091 15.8831 22.9024 16.0204 23.104 16.9663L24.4685 23.3701C24.5359 23.6862 24.7519 23.9503 25.0484 24.079L31.0547 26.6857C31.9419 27.0707 31.8201 28.3656 30.8767 28.5785L16.1831 31.895Z"
        :fill="color1"
        fill-opacity="0.85"
      />
    </svg>
    <svg
      v-else-if="name == 'drone_bottom'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size + 8"
      :height="size + 8"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M17.6087 18.5C17.8309 18.7222 18.1912 18.7222 18.4134 18.5L18.5 18.4133C18.7222 18.1911 18.7222 17.8309 18.5 17.6087L17.6735 16.7821C16.9356 16.0442 16.5211 15.0435 16.5211 14C16.5211 12.9565 16.9356 11.9558 17.6735 11.218L18.5001 10.3914C18.7223 10.1692 18.7223 9.80891 18.5001 9.58671L18.4134 9.50001C18.1912 9.27782 17.8309 9.27782 17.6087 9.50001L16.7823 10.3265C16.0444 11.0644 15.0436 11.4789 14.0001 11.4789C12.9565 11.4789 11.9557 11.0644 11.2178 10.3265L10.3914 9.49999C10.1692 9.2778 9.80891 9.2778 9.58672 9.49999L9.50002 9.58668C9.27783 9.80888 9.27783 10.1691 9.50002 10.3913L10.3265 11.2178C11.0644 11.9557 11.4789 12.9565 11.4789 14C11.4789 15.0436 11.0644 16.0443 10.3265 16.7822L9.50003 17.6087C9.27784 17.8309 9.27784 18.1911 9.50004 18.4133L9.58672 18.5C9.80892 18.7222 10.1692 18.7222 10.3914 18.5L11.218 17.6734C11.9559 16.9356 12.9566 16.521 14.0001 16.521C15.0435 16.521 16.0443 16.9356 16.7821 17.6734L17.6087 18.5Z"
        :fill="color"
      />
      <path
        d="M12.3333 9.91667C12.3333 11.2514 11.2514 12.3333 9.91667 12.3333C8.58198 12.3333 7.5 11.2514 7.5 9.91667C7.5 8.58198 8.58198 7.5 9.91667 7.5C11.2514 7.5 12.3333 8.58198 12.3333 9.91667Z"
        :stroke="color"
      />
      <path
        d="M12.3333 18.0833C12.3333 19.418 11.2514 20.5 9.91667 20.5C8.58198 20.5 7.5 19.418 7.5 18.0833C7.5 16.7486 8.58198 15.6667 9.91667 15.6667C11.2514 15.6667 12.3333 16.7486 12.3333 18.0833Z"
        :stroke="color"
      />
      <path
        d="M20.5 9.91667C20.5 11.2514 19.418 12.3333 18.0833 12.3333C16.7486 12.3333 15.6666 11.2514 15.6666 9.91667C15.6666 8.58198 16.7486 7.5 18.0833 7.5C19.418 7.5 20.5 8.58198 20.5 9.91667Z"
        :stroke="color"
      />
      <path
        d="M20.5 18.0833C20.5 19.418 19.418 20.5 18.0833 20.5C16.7486 20.5 15.6666 19.418 15.6666 18.0833C15.6666 16.7486 16.7486 15.6667 18.0833 15.6667C19.418 15.6667 20.5 16.7486 20.5 18.0833Z"
        :stroke="color"
      />
      <path
        d="M12.0312 5.03125C12.5534 4.50911 13.2616 4.21577 14 4.21577C14.7384 4.21577 15.4466 4.50911 15.9688 5.03125"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.9688 12.0312C23.4909 12.5534 23.7842 13.2616 23.7842 14C23.7842 14.7384 23.4909 15.4466 22.9687 15.9688"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0312 22.9688C12.5534 23.4909 13.2616 23.7842 14 23.7842C14.7384 23.7842 15.4466 23.4909 15.9688 22.9688"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.03125 12.0312C4.50911 12.5534 4.21577 13.2616 4.21577 14C4.21577 14.7384 4.5091 15.4466 5.03125 15.9688"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 3.5C11.4283 2.57174 12.6872 2.05025 14 2.05025C15.3128 2.05025 16.5717 2.57174 17.5 3.5"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.5 10.5C25.4283 11.4283 25.9497 12.6872 25.9497 14C25.9497 15.3128 25.4283 16.5717 24.5 17.5"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 24.5C11.4283 25.4283 12.6872 25.9497 14 25.9497C15.3128 25.9497 16.5717 25.4283 17.5 24.5"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 10.5C2.57174 11.4283 2.05025 12.6872 2.05025 14C2.05025 15.3128 2.57174 16.5717 3.5 17.5"
        :stroke="secColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'drone'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5.17163 5.20329H9.37346"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6261 5.20329H18.8279"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.27271 5.20329V8.71455"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.7272 5.20329V8.71455"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.71413 18.7968H8.32317C7.74301 18.7968 7.27271 18.3264 7.27271 17.7463C7.27199 17.0817 7.41203 16.4245 7.68362 15.818C7.89836 15.3384 8.19149 14.8991 8.55011 14.5176"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2854 18.7968H15.6767C16.2568 18.7968 16.7271 18.3264 16.7271 17.7463C16.7279 17.0817 16.5878 16.4245 16.3162 15.818C16.1012 15.3378 15.8075 14.8978 15.4483 14.516"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.48961 12.5476C8.46722 12.7849 8.45312 13.0249 8.45312 13.2672C8.45312 13.5156 8.46794 13.7616 8.49131 14.0048C8.59209 15.0531 9.49309 15.8753 10.5434 15.9526C11.0203 15.9878 11.5065 16.0135 12.0001 16.0135C12.4936 16.0135 12.9798 15.9878 13.4567 15.9526C14.507 15.8753 15.408 15.0531 15.5088 14.0048C15.5321 13.7616 15.547 13.5156 15.547 13.2672C15.547 13.0249 15.5329 12.7849 15.5105 12.5476"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.39443 8.7713C5.82139 8.81232 5.37596 9.29049 5.44477 9.86085C5.49625 10.2876 5.57157 10.7118 5.65017 11.1022C5.8033 11.8627 6.45514 12.4377 7.22935 12.4866C7.36355 12.4951 7.49825 12.5037 7.6334 12.5123C9.04237 12.6022 10.5029 12.6954 11.9999 12.6954C13.4968 12.6954 14.9574 12.6022 16.3663 12.5123C16.5015 12.5037 16.6362 12.4951 16.7704 12.4866C17.5446 12.4377 18.1965 11.8627 18.3496 11.1022C18.4324 10.6911 18.5113 10.2719 18.5628 9.84712C18.6312 9.28258 18.1859 8.81292 17.6188 8.77231L15.9096 8.64996C13.3062 8.46358 10.6929 8.46358 8.08947 8.64995L6.39443 8.7713Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 23H2C1.44772 23 1 22.5523 1 22V17.5M6.5 1H2C1.44772 1 1 1.44772 1 2V6.5M17.5 1H22C22.5523 1 23 1.44772 23 2V6.5M23 17.5V22C23 22.5523 22.5523 23 22 23H17.5"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>

    <svg
      v-else-if="name == 'inbox_tray'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.8993 9.06142H11.1843C10.9028 9.06142 10.6328 9.17325 10.4337 9.3723C10.2347 9.57136 10.1229 9.84133 10.1229 10.1228C10.1229 10.6859 9.8992 11.2258 9.50108 11.6239C9.10297 12.0221 8.56301 12.2457 7.99999 12.2457C7.43698 12.2457 6.89702 12.0221 6.49891 11.6239C6.10079 11.2258 5.87714 10.6859 5.87714 10.1228C5.87714 9.84133 5.7653 9.57136 5.56625 9.3723C5.36719 9.17325 5.09722 9.06142 4.81571 9.06142H1.10071V13.8378C1.10071 14.1193 1.21254 14.3894 1.41159 14.5884C1.61065 14.7874 1.88062 14.8993 2.16214 14.8993H13.8379C14.1193 14.8993 14.3894 14.7874 14.5884 14.5884C14.7874 14.3894 14.8993 14.1193 14.8993 13.8378V9.06142Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.34644 4.8157L8.00001 7.46928L10.6536 4.8157"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8 1.10071V7.46928" :stroke="color" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg
      v-else-if="name == 'location_pin'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.07706 1.99988H7.95224C5.35594 1.99988 3.20105 4.00634 3.01607 6.59605C2.92594 7.85782 3.21068 9.13808 3.9771 10.1445C4.93505 11.4024 5.90769 12.2729 7.44493 13.3028C7.78924 13.5335 8.24007 13.5335 8.58438 13.3028C10.1216 12.2729 11.0943 11.4024 12.0523 10.1445C12.8186 9.13808 13.1034 7.85782 13.0133 6.59605C12.8283 4.00634 10.6734 1.99988 8.07706 1.99988Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.01499 8.36844C9.03397 8.36844 9.60714 7.79527 9.60714 6.7763C9.60714 5.75733 9.03397 5.18416 8.01499 5.18416C6.99602 5.18416 6.42285 5.75733 6.42285 6.7763C6.42285 7.79527 6.99602 8.36844 8.01499 8.36844Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'phone_shield'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_86_914)">
        <path
          d="M8.01964 18.3686H9.61178M8.81571 1.65106H3.24321C2.3639 1.65106 1.65107 2.36389 1.65107 3.2432V20.7568C1.65107 21.6361 2.3639 22.3489 3.24321 22.3489H14.3882C15.2675 22.3489 15.9804 21.6361 15.9804 20.7568V15.1843M17.4658 11.9486C17.2764 12.0171 17.0689 12.0171 16.8794 11.9486C15.4409 11.3787 14.2065 10.3901 13.3362 9.11082C12.4659 7.83151 11.9997 6.32039 11.998 4.7731V2.51351C11.991 2.40421 12.0062 2.29462 12.0427 2.19137C12.0792 2.08811 12.1362 1.99332 12.2104 1.91272C12.2845 1.83212 12.3742 1.76738 12.4741 1.72241C12.574 1.67744 12.6819 1.65317 12.7914 1.65106H21.5538C21.6634 1.65317 21.7713 1.67744 21.8711 1.72241C21.971 1.76738 22.0608 1.83212 22.1348 1.91272C22.209 1.99332 22.266 2.08811 22.3026 2.19137C22.3391 2.29462 22.3543 2.40421 22.3473 2.51351V4.7731C22.3456 6.32039 21.8792 7.83151 21.009 9.11082C20.1387 10.3901 18.9043 11.3787 17.4658 11.9486Z"
          :stroke="color"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_86_914">
          <rect :width="size" :height="size" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="name == 'plus'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.44714V21.5529M2.44714 11.9363H21.5529"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'question_circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.21375 9.61178C9.21375 8.07297 10.4612 6.82553 12 6.82553C13.5388 6.82553 14.7862 8.07297 14.7862 9.61178C14.7862 11.1506 13.5388 12.398 12 12.398V13.9902M12 22.3489C17.7156 22.3489 22.3489 17.7156 22.3489 12C22.3489 6.28444 17.7156 1.65106 12 1.65106C6.28444 1.65106 1.65107 6.28444 1.65107 12C1.65107 17.7156 6.28444 22.3489 12 22.3489ZM12 17.1745C11.7802 17.1745 11.602 16.9963 11.602 16.7764C11.602 16.5566 11.7802 16.3784 12 16.3784C12.2198 16.3784 12.398 16.5566 12.398 16.7764C12.398 16.9963 12.2198 17.1745 12 17.1745Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'x_circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9803 8.01963L8.01963 15.9803M8.01963 8.01963L15.9803 15.9803M12 22.3489C17.7156 22.3489 22.3489 17.7156 22.3489 12C22.3489 6.28444 17.7156 1.65106 12 1.65106C6.28444 1.65106 1.65106 6.28444 1.65106 12C1.65106 17.7156 6.28444 22.3489 12 22.3489Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'yellow_exclamation'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00002 5.8773V9.32695M7.08318 2.6726L1.50117 12.2417C1.0884 12.9494 1.59881 13.838 2.41801 13.838H13.5821C14.4013 13.838 14.9116 12.9494 14.4988 12.2417L8.91686 2.6726C8.50728 1.97046 7.49276 1.97046 7.08318 2.6726ZM8.00002 11.7152C7.85347 11.7152 7.73466 11.5964 7.73466 11.4498C7.73466 11.3032 7.85347 11.1844 8.00002 11.1844C8.14657 11.1844 8.26538 11.3032 8.26538 11.4498C8.26538 11.5964 8.14657 11.7152 8.00002 11.7152Z"
        stroke="#F6A60C"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'arrow_head_down'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7L11.4561 16.7672C11.7565 17.0776 12.2435 17.0776 12.5439 16.7672L22 7"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'back-arrow'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path :fill="color" d="m10 18l-6-6l6-6l1.4 1.45L7.85 11H20v2H7.85l3.55 3.55z" />
    </svg>
    <svg
      v-else-if="name == 'qr_code'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        :fill="color"
        d="M13 21v-2h2v2zm-2-2v-5h2v5zm8-3v-4h2v4zm-2-4v-2h2v2zM5 14v-2h2v2zm-2-2v-2h2v2zm9-7V3h2v2zM4.5 7.5h3v-3h-3zM3 9V3h6v6zm1.5 10.5h3v-3h-3zM3 21v-6h6v6zM16.5 7.5h3v-3h-3zM15 9V3h6v6zm2 12v-3h-2v-2h4v3h2v2zm-4-7v-2h4v2zm-4 0v-2H7v-2h6v2h-2v2zm1-5V5h2v2h2v2zM5.25 6.75v-1.5h1.5v1.5zm0 12v-1.5h1.5v1.5zm12-12v-1.5h1.5v1.5z"
      />
    </svg>
    <svg
      v-else-if="name == 'profile_image'"
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M14.482 52.1025C16.3127 49.0974 18.8857 46.6137 21.9536 44.8906C25.0215 43.167 28.4811 42.2618 31.9999 42.2618C35.5187 42.2618 38.9783 43.167 42.0462 44.8906C45.1143 46.6137 47.687 49.0974 49.518 52.1025M32 36.1025C37.6645 36.1025 42.2564 31.5105 42.2564 25.8461C42.2564 20.1816 37.6645 15.5897 32 15.5897C26.3356 15.5897 21.7436 20.1816 21.7436 25.8461C21.7436 31.5105 26.3356 36.1025 32 36.1025ZM32 58.6666C46.7278 58.6666 58.6667 46.7277 58.6667 31.9999C58.6667 17.2723 46.7278 5.33325 32 5.33325C17.2724 5.33325 5.33334 17.2723 5.33334 31.9999C5.33334 46.7277 17.2724 58.6666 32 58.6666Z"
        stroke="#C2C3C4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'thin_back_arrow'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.8993 7.99999H1.10072M1.10072 7.99999L5.34643 12.2457M1.10072 7.99999L5.34643 3.75427"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'arrow_head_left'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2L7.23271 11.4561C6.92243 11.7565 6.92243 12.2435 7.23271 12.5439L17 22"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'arrow_head_right'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2L16.7672 11.4561C17.0776 11.7565 17.0776 12.2435 16.7672 12.5439L7 22"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'launch'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.63075 5.14465C4.59281 3.75418 2.69285 4.81561 1.10071 6.45021L4.62465 8.57307"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8553 9.36929C12.2457 11.4072 11.1843 13.3071 9.54971 14.8993L7.42685 11.3753"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.62466 8.56266L7.43745 11.3754C9.68768 10.0274 12.2457 8.72187 13.4133 7.51184C15.9395 4.98564 14.4747 1.52539 14.4747 1.52539C14.4747 1.52539 11.0145 0.0606154 8.48826 2.58681C7.27824 3.75438 5.96206 6.32305 4.62466 8.56266Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.17438 5.89839L10.1017 9.82568"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.715 4.81572C12.008 4.81572 12.2457 4.5781 12.2457 4.285C12.2457 3.9919 12.008 3.75429 11.715 3.75429C11.4219 3.75429 11.1843 3.9919 11.1843 4.285C11.1843 4.5781 11.4219 4.81572 11.715 4.81572Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.47605 13.7741C3.86042 14.3685 1.10071 14.8992 1.10071 14.8992C1.10071 14.8992 1.63142 12.1395 2.22582 11.5238C2.37158 11.3675 2.54735 11.242 2.74265 11.155C2.93796 11.068 3.14879 11.0212 3.36256 11.0174C3.57634 11.0136 3.78869 11.0529 3.98694 11.133C4.18519 11.2131 4.36528 11.3322 4.51647 11.4835C4.66765 11.6347 4.78684 11.8148 4.86692 12.013C4.947 12.2112 4.98632 12.4236 4.98254 12.6374C4.97878 12.8512 4.93199 13.062 4.84496 13.2573C4.75795 13.4526 4.63247 13.6283 4.47605 13.7741Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'split_screen'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9 6.85584L12.4337 3.42212"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.85596 9.00024L3.42224 12.434"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4338 6.42388C12.9964 5.86133 12.9964 4.3594 12.4338 3.42216C11.4966 2.8596 9.99469 2.8596 9.43213 3.42216"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.42211 9.4322C2.85955 9.99475 2.85955 11.4967 3.42211 12.4339C4.35935 12.9965 5.86127 12.9965 6.42383 12.4339"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'arrow_head_up'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 17L11.4561 7.23271C11.7565 6.92243 12.2435 6.92243 12.5439 7.23271L22 17"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'zoom_in'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2306 7.38453V15.0767M7.38453 11.2306H15.0767M17.7539 17.7539L22 22M11.2306 20.4613C16.3286 20.4613 20.4613 16.3286 20.4613 11.2306C20.4613 6.13269 16.3286 2 11.2306 2C6.13269 2 2 6.13269 2 11.2306C2 16.3286 6.13269 20.4613 11.2306 20.4613Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'zoom_out'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38453 11.2306H15.0767M17.7539 17.7539L22 22M11.2306 20.4613C16.3286 20.4613 20.4613 16.3286 20.4613 11.2306C20.4613 6.13269 16.3286 2 11.2306 2C6.13269 2 2 6.13269 2 11.2306C2 16.3286 6.13269 20.4613 11.2306 20.4613Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'boxes'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 13.7391V19.5217L7 22L12 19.5217M2 13.7391L7 11.2609M2 13.7391L7 16.2174L12 13.7391M7 11.2609L12 13.7391M7 11.2609V5.47826M12 13.7391V19.5217M12 13.7391L17 11.2609M12 13.7391L17 16.2174L22 13.7391M12 19.5217L17 22L22 19.5217V13.7391M17 11.2609L22 13.7391M17 11.2609V5.47826M7 5.47826L12 3L17 5.47826M7 5.47826L12 7.95652L17 5.47826"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'calendar_marked'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.16667 2V7M17.8333 2V7M7 11.5833C6.76988 11.5833 6.58333 11.3968 6.58333 11.1667C6.58333 10.9366 6.76988 10.75 7 10.75C7.23012 10.75 7.41667 10.9366 7.41667 11.1667C7.41667 11.3968 7.23012 11.5833 7 11.5833ZM12 11.5833C11.7699 11.5833 11.5833 11.3968 11.5833 11.1667C11.5833 10.9366 11.7699 10.75 12 10.75C12.2301 10.75 12.4167 10.9366 12.4167 11.1667C12.4167 11.3968 12.2301 11.5833 12 11.5833ZM7 17.4167C6.76988 17.4167 6.58333 17.2302 6.58333 17C6.58333 16.7699 6.76988 16.5833 7 16.5833C7.23012 16.5833 7.41667 16.7699 7.41667 17C7.41667 17.2302 7.23012 17.4167 7 17.4167ZM12 17.4167C11.7699 17.4167 11.5833 17.2302 11.5833 17C11.5833 16.7699 11.7699 16.5833 12 16.5833C12.2301 16.5833 12.4167 16.7699 12.4167 17C12.4167 17.2302 12.2301 17.4167 12 17.4167ZM17 11.5833C16.7699 11.5833 16.5833 11.3968 16.5833 11.1667C16.5833 10.9366 16.7699 10.75 17 10.75C17.2302 10.75 17.4167 10.9366 17.4167 11.1667C17.4167 11.3968 17.2302 11.5833 17 11.5833ZM3.66667 4.5C3.22463 4.5 2.80072 4.6756 2.48815 4.98815C2.1756 5.30072 2 5.72463 2 6.16667V20.3333C2 20.7753 2.1756 21.1993 2.48815 21.5118C2.80072 21.8243 3.22463 22 3.66667 22H20.3333C20.7753 22 21.1993 21.8243 21.5118 21.5118C21.8243 21.1993 22 20.7753 22 20.3333V6.16667C22 5.72463 21.8243 5.30072 21.5118 4.98815C21.1993 4.6756 20.7753 4.5 20.3333 4.5H3.66667Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'user_circle'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.43074 19.5385C6.11726 18.4115 7.08214 17.4802 8.2326 16.834C9.38306 16.1877 10.6804 15.8482 12 15.8482C13.3195 15.8482 14.6169 16.1877 15.7673 16.834C16.9178 17.4802 17.8826 18.4115 18.5692 19.5385M12 13.5385C14.1242 13.5385 15.8462 11.8165 15.8462 9.69231C15.8462 7.56814 14.1242 5.84615 12 5.84615C9.87583 5.84615 8.15385 7.56814 8.15385 9.69231C8.15385 11.8165 9.87583 13.5385 12 13.5385ZM12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'idi_fly'"
      :width="size"
      :height="size"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M34.5 28.8199L18.0289 4.5L15.944 12.2174C15.216 16.31 15.0883 22.4113 17.5183 26.8944C18.5622 28.8178 19.8664 30.4417 21.4301 30.9855C21.4301 30.9855 22.951 32.0818 26.5183 31.0738L34.5 28.8199Z"
          fill="#95989C"
        />
        <path
          d="M1.5 28.8199L17.9718 4.5L20.0575 12.2174C20.7855 16.31 20.9131 22.4113 18.4831 26.8944C17.4392 28.8178 16.1343 30.4417 14.5714 30.9855C14.5714 30.9855 13.0505 32.0818 9.48315 31.0738L1.5 28.8199Z"
          fill="#1B92A6"
        />
      </g>
    </svg>

    <svg
      v-else-if="name == 'analytics'"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 14.8269H15.8155V33H3V14.8269Z" fill="#20A4F3" />
      <path d="M12.0291 8.76923H24.5534V33H12.0291V8.76923Z" fill="#606366" />
      <path d="M20.767 3H33V33H20.767V3Z" fill="#20A4F3" />
    </svg>

    <svg v-else-if="name == 'device_home'" width="62" height="62" viewBox="0 0 62 62" fill="none">
      <path
        d="M22.8432 20.9547L14.686 15.2145M25.5622 41.0454L16.0456 48.2206M39.1575 20.9547L47.3146 15.2145M36.4384 41.0454L45.9551 48.2206M13.7781 25.2167C9.93803 24.8278 6.5508 21.979 5.49363 17.8144C4.1333 12.4555 7.14611 6.94731 12.2229 5.51141C16.3545 4.34285 20.5798 6.23149 22.7432 9.86359M39.2575 9.86359C41.4208 6.23149 45.6461 4.34285 49.7777 5.51141C54.8545 6.94731 57.8674 12.4555 56.507 17.8144C55.4498 21.979 52.0626 24.8278 48.2225 25.2167M20.4674 55.0647C18.3803 56.7437 15.5648 57.3313 12.8932 56.3736C8.62745 54.8444 6.34378 49.9545 7.7925 45.4518C8.74599 42.4883 11.0786 40.431 13.7781 39.8068M41.5325 55.4559C43.5526 56.8298 46.1261 57.2527 48.5783 56.3736C52.8441 54.8444 55.1278 49.9545 53.679 45.4517C52.7884 42.6837 50.6947 40.7063 48.2225 39.9489M22.8432 19.5196V26.1421C22.8432 26.5073 22.9092 26.8691 23.0377 27.2081L25.3678 33.3569C25.4962 33.6959 25.5622 34.0577 25.5622 34.4229V45.3505C25.5622 46.9356 26.7796 48.2206 28.2813 48.2206H33.7194C35.2211 48.2206 36.4384 46.9356 36.4384 45.3505V34.4229C36.4384 34.0577 36.5044 33.6959 36.6329 33.3569L38.963 27.2081C39.0915 26.8691 39.1575 26.5073 39.1575 26.1421V19.5196L36.2448 18.2899C35.9237 18.1542 35.5809 18.0846 35.235 18.0846H26.7656C26.4197 18.0846 26.077 18.1542 25.7558 18.2899L22.8432 19.5196Z"
        stroke="#C2C3C4"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'user_home'"
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
    >
      <path
        d="M14.0297 50.4743C15.8033 47.5631 18.2958 45.157 21.2679 43.4878C24.2399 41.8181 27.5914 40.9412 31.0002 40.9412C34.4091 40.9412 37.7606 41.8181 40.7326 43.4878C43.7048 45.157 46.1971 47.5631 47.9708 50.4743M31.0003 34.9743C36.4878 34.9743 40.9362 30.5259 40.9362 25.0384C40.9362 19.551 36.4878 15.1025 31.0003 15.1025C25.5129 15.1025 21.0644 19.551 21.0644 25.0384C21.0644 30.5259 25.5129 34.9743 31.0003 34.9743ZM31.0003 56.8333C45.2679 56.8333 56.8337 45.2675 56.8337 31C56.8337 16.7326 45.2679 5.16663 31.0003 5.16663C16.733 5.16663 5.16699 16.7326 5.16699 31C5.16699 45.2675 16.733 56.8333 31.0003 56.8333Z"
        stroke="#C2C3C4"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'roadmap_home'"
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
    >
      <path
        d="M28.944 10.4348H45.9102C51.3053 10.4348 55.6787 14.8083 55.6787 20.2033C55.6787 25.5983 51.3053 29.9717 45.9102 29.9717H41.2831M28.944 10.4348C28.944 11.245 28.7844 12.0473 28.4743 12.7958C28.1643 13.5443 27.7098 14.2244 27.1369 14.7973C26.564 15.3702 25.8839 15.8247 25.1354 16.1347C24.3869 16.4448 23.5846 16.6044 22.7744 16.6044C21.9642 16.6044 21.1619 16.4448 20.4134 16.1347C19.6649 15.8247 18.9848 15.3702 18.4119 14.7973C17.839 14.2244 17.3845 13.5443 17.0745 12.7958C16.7644 12.0473 16.6049 11.245 16.6049 10.4348M28.944 10.4348C28.944 9.62462 28.7844 8.82235 28.4743 8.07383C28.1643 7.3253 27.7098 6.64518 27.1369 6.07228C26.564 5.49938 25.8839 5.04494 25.1354 4.73489C24.3869 4.42484 23.5846 4.26526 22.7744 4.26526C21.9642 4.26526 21.1619 4.42484 20.4134 4.73489C19.6649 5.04494 18.9848 5.49938 18.4119 6.07228C17.839 6.64518 17.3845 7.3253 17.0745 8.07383C16.7644 8.82235 16.6049 9.62462 16.6049 10.4348M41.2831 29.9717C41.2831 31.608 40.6331 33.1773 39.476 34.3343C38.319 35.4913 36.7498 36.1413 35.1135 36.1413C33.4772 36.1413 31.908 35.4913 30.751 34.3343C29.594 33.1773 28.944 31.608 28.944 29.9717M41.2831 29.9717C41.2831 28.3355 40.6331 26.7662 39.476 25.6092C38.319 24.4522 36.7498 23.8022 35.1135 23.8022C33.4772 23.8022 31.908 24.4522 30.751 25.6092C29.594 26.7662 28.944 28.3355 28.944 29.9717M28.944 29.9717H16.0907C10.6957 29.9717 6.32227 34.3452 6.32227 39.7402C6.32227 45.1353 10.6957 49.5087 16.0907 49.5087H16.6049M16.6049 49.5087C16.6049 50.3189 16.7644 51.1211 17.0745 51.8696C17.3845 52.6182 17.839 53.2983 18.4119 53.8712C18.9848 54.4441 19.6649 54.8985 20.4134 55.2086C21.1619 55.5186 21.9642 55.6782 22.7744 55.6782C23.5846 55.6782 24.3869 55.5186 25.1354 55.2086C25.8839 54.8985 26.564 54.4441 27.1369 53.8712C27.7098 53.2983 28.1643 52.6182 28.4743 51.8696C28.7844 51.1211 28.944 50.3189 28.944 49.5087M16.6049 49.5087C16.6049 48.6985 16.7644 47.8962 17.0745 47.1477C17.3845 46.3991 17.839 45.719 18.4119 45.1461C18.9848 44.5732 19.6649 44.1188 20.4134 43.8087C21.1619 43.4987 21.9642 43.3391 22.7744 43.3391C23.5846 43.3391 24.3869 43.4987 25.1354 43.8087C25.8839 44.1188 26.564 44.5732 27.1369 45.1461C27.7098 45.719 28.1643 46.3991 28.4743 47.1477C28.7844 47.8962 28.944 48.6985 28.944 49.5087M6.32227 10.4348H16.6049M28.944 49.5087H47.4526M55.6787 49.5087L47.4526 57.7347V41.2826L55.6787 49.5087Z"
        stroke="#C2C3C4"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name == 'file_home'"
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
    >
      <path
        d="M20.717 20.7174H28.9431M20.717 33.0565H41.2822M20.717 45.3956H41.2822M53.6213 53.6217C53.6213 54.7125 53.1878 55.7588 52.4166 56.53C51.6454 57.3012 50.5991 57.7347 49.5083 57.7347H12.491C11.4001 57.7347 10.354 57.3012 9.5826 56.53C8.81128 55.7588 8.37793 54.7125 8.37793 53.6217V8.37829C8.37793 7.28744 8.81128 6.24128 9.5826 5.46994C10.354 4.6986 11.4001 4.26526 12.491 4.26526H39.2257L53.6213 18.6609V53.6217Z"
        stroke="#C2C3C4"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'folder'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
      <path
        :fill="color"
        d="M14 16h2v-2h2v-2h-2v-2h-2v2h-2v2h2zM4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h6l2 2h8q.825 0 1.413.588T22 8v10q0 .825-.587 1.413T20 20zm0-2h16V8h-8.825l-2-2H4zm0 0V6z"
      />
    </svg>
    <svg
      v-else-if="name == 'cog_home'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 62 62"
      fill="none"
    >
      <path
        d="M25.7797 7.71022L24.1045 12.1218L18.3386 15.4602L13.7415 14.7448C12.9761 14.6388 12.197 14.7674 11.5033 15.1141C10.8096 15.4609 10.2327 16.0102 9.84572 16.6923L8.28739 19.4743C7.88807 20.1672 7.70407 20.9674 7.75974 21.7692C7.81537 22.571 8.10802 23.3367 8.59905 23.9653L11.5209 27.6615V34.3384L8.67697 38.0346C8.18594 38.6632 7.89329 39.4289 7.83765 40.2307C7.78198 41.0325 7.96598 41.8327 8.3653 42.5256L9.92364 45.3076C10.3106 45.9896 10.8875 46.5389 11.5812 46.8859C12.2749 47.2324 13.054 47.3612 13.8195 47.2551L18.4165 46.5397L24.1045 49.8782L25.7797 54.2897C26.0621 55.0365 26.5592 55.6791 27.2057 56.133C27.8522 56.5869 28.618 56.8309 29.4028 56.8333H32.6753C33.4601 56.8309 34.2258 56.5869 34.8723 56.133C35.5188 55.6791 36.0159 55.0365 36.2984 54.2897L37.9736 49.8782L43.6615 46.5397L48.2586 47.2551C49.0241 47.3612 49.8033 47.2324 50.4967 46.8859C51.1906 46.5389 51.7676 45.9896 52.1544 45.3076L53.7128 42.5256C54.1121 41.8327 54.296 41.0325 54.2402 40.2307C54.1849 39.4289 53.892 38.6632 53.4011 38.0346L50.4792 34.3384V27.6615L53.3232 23.9653C53.814 23.3367 54.107 22.571 54.1623 21.7692C54.218 20.9674 54.0342 20.1672 53.6348 19.4743L52.0765 16.6923C51.6897 16.0102 51.1127 15.4609 50.4188 15.1141C49.7254 14.7674 48.9462 14.6388 48.1807 14.7448L43.5836 15.4602L37.8957 12.1218L36.2205 7.71022C35.938 6.96329 35.4409 6.32082 34.7944 5.86696C34.1479 5.41309 33.3821 5.16899 32.5974 5.16663H29.4028C28.618 5.16899 27.8522 5.41309 27.2057 5.86696C26.5592 6.32082 26.0621 6.96329 25.7797 7.71022Z"
        :stroke="color"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.5215 35.416C23.6654 34.1089 23.2084 32.5721 23.2084 31C23.2084 28.8918 24.0293 26.87 25.4905 25.3794C26.9518 23.8887 28.9336 23.0512 31.0001 23.0512C32.5411 23.0512 34.0475 23.5174 35.3289 24.3908C36.6102 25.2642 37.6089 26.5057 38.1986 27.9581C38.7883 29.4106 38.9427 31.0088 38.642 32.5507C38.3414 34.0926 37.5993 35.5089 36.5096 36.6205C35.4199 37.7322 34.0316 38.4892 32.5201 38.7959C31.0087 39.1026 29.4421 38.9452 28.0183 38.3436C26.5946 37.742 25.3777 36.7232 24.5215 35.416Z"
        :stroke="color"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="name === 'power'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.23517 4C3.88792 4.87948 3 6.38339 3 8.09091C3 10.8021 5.23858 13 8 13C10.7614 13 13 10.8021 13 8.09091C13 6.38339 12.1121 4.87948 10.7648 4"
        :stroke="color"
        stroke-linecap="round"
      />
      <path d="M8 3L8 6" :stroke="color" stroke-linecap="round" />
    </svg>

    <svg
      v-else-if="name === 'repeat'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.38462 9.92646C4.13894 11.7315 5.92134 13 8 13C10.7615 13 13 10.7615 13 8C13 5.23858 10.7615 3 8 3C5.50016 3 3.42881 4.83455 3.05881 7.23077M5.69231 9.92308H3V12.6154"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name == 'arrow-up'"
      :height="size"
      version="1.1"
      viewBox="0 0 48 48"
      :width="size"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title />
      <g fill="none" fill-rule="evenodd" id="arrow-up" stroke="none" stroke-width="1">
        <path
          d="M16.0839749,20.2226499 L16.0434343,20.2953753 C15.8973068,20.6162383 16.1291771,21 16.5,21 L22,21 L22,39.5 C22,39.7761424 22.2238576,40 22.5,40 L26.5,40 L26.5898756,39.9919443 C26.8231248,39.9496084 27,39.7454599 27,39.5 L27,21 L32.5,21 C32.8993477,21 33.1375434,20.5549273 32.9160251,20.2226499 L24.9160251,8.2226499 C24.7181141,7.92578337 24.2818859,7.92578337 24.0839749,8.2226499 L16.0839749,20.2226499 Z"
          :fill="color"
          fill-rule="nonzero"
          id="Path"
        />
      </g>
    </svg>
    <svg
      v-else-if="name === 'copy1'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M6.38897 1.66675H5.83342M3.88897 1.66675H4.44453M1.66675 2.50008V2.2223C1.66675 1.91548 1.91548 1.66675 2.2223 1.66675H2.50008M1.66675 3.88897V4.44453M1.66675 6.38897V5.83342M8.33341 7.77786V3.61119C8.33341 3.30437 8.08469 3.05564 7.77786 3.05564H3.61119C3.30437 3.05564 3.05564 3.30437 3.05564 3.61119V7.77786C3.05564 8.08469 3.30437 8.33341 3.61119 8.33341H7.77786C8.08469 8.33341 8.33341 8.08469 8.33341 7.77786Z"
        :stroke="color"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'pencil'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M4.89545 9.2757L2.25 9.75L2.6909 7.07988L7.30222 2.50981C7.38417 2.42749 7.48175 2.36214 7.5892 2.31755C7.69665 2.27296 7.81187 2.25 7.92832 2.25C8.04469 2.25 8.15999 2.27296 8.26744 2.31755C8.3749 2.36214 8.47247 2.42749 8.55443 2.50981L9.48913 3.44084C9.57179 3.52249 9.63743 3.61963 9.68216 3.72667C9.72689 3.8337 9.75 3.9485 9.75 4.06445C9.75 4.1804 9.72689 4.29521 9.68216 4.40224C9.63743 4.50927 9.57179 4.60641 9.48913 4.68806L4.89545 9.2757Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'sync'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M6 12q0 1.35.538 2.488T8 16.45V15q0-.425.288-.712T9 14t.713.288T10 15v4q0 .425-.288.713T9 20H5q-.425 0-.712-.288T4 19t.288-.712T5 18h1.725q-1.275-1.1-2-2.65T4 12q0-2.375 1.237-4.275t3.213-2.9q.35-.2.725-.012t.5.587t-.038.775t-.512.575q-1.4.775-2.262 2.163T6 12m9 8q-1.25 0-2.125-.875T12 17q0-1.2.825-2.062t2.025-.913q.425-.9 1.263-1.463T18 12q1.325 0 2.288.863T21.45 15q1.05 0 1.8.725t.75 1.75q0 1.05-.725 1.788T21.5 20zm1-12.45V9q0 .425-.288.713T15 10t-.712-.288T14 9V5q0-.425.288-.712T15 4h4q.425 0 .713.288T20 5t-.288.713T19 6h-1.725q.825.725 1.438 1.663T19.65 9.7q.125.4-.1.725t-.65.4t-.762-.162t-.488-.638q-.25-.725-.675-1.35T16 7.55"
      />
    </svg>
    <svg
      v-else-if="name === 'reload'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
      <path
        :fill="color"
        d="M6 12.05q0 1.125.425 2.188T7.75 16.2l.25.25V15q0-.425.288-.712T9 14t.713.288T10 15v4q0 .425-.288.713T9 20H5q-.425 0-.712-.288T4 19t.288-.712T5 18h1.75l-.4-.35q-1.3-1.15-1.825-2.625T4 12.05Q4 9.7 5.2 7.787T8.425 4.85q.35-.2.738-.025t.512.575q.125.375-.012.75t-.488.575q-1.45.8-2.312 2.213T6 12.05m12-.1q0-1.125-.425-2.187T16.25 7.8L16 7.55V9q0 .425-.288.713T15 10t-.712-.288T14 9V5q0-.425.288-.712T15 4h4q.425 0 .713.288T20 5t-.288.713T19 6h-1.75l.4.35q1.225 1.225 1.788 2.663T20 11.95q0 2.35-1.2 4.263t-3.225 2.937q-.35.2-.737.025t-.513-.575q-.125-.375.013-.75t.487-.575q1.45-.8 2.313-2.212T18 11.95"
      />
    </svg>
    <svg
      v-else-if="name === 'ruler'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M2 15.616c0 .847.682 1.529 2.045 2.892l1.447 1.447C6.855 21.318 7.537 22 8.384 22s1.53-.682 2.893-2.045l8.678-8.678C21.318 9.913 22 9.23 22 8.384s-.682-1.529-2.045-2.892l-1.447-1.447C17.145 2.682 16.463 2 15.616 2c-.754 0-1.376.54-2.464 1.618q.045.033.085.073l1.415 1.415a.75.75 0 1 1-1.061 1.06l-1.414-1.414a1 1 0 0 1-.074-.086L11.03 5.739q.045.033.086.074l2.121 2.121a.75.75 0 1 1-1.06 1.06l-2.122-2.12a1 1 0 0 1-.074-.087L8.91 7.86q.044.033.086.074l1.414 1.414a.75.75 0 0 1-1.06 1.06L7.933 8.996a1 1 0 0 1-.074-.086L6.787 9.98q.046.033.086.074l2.122 2.122a.75.75 0 0 1-1.061 1.06l-2.121-2.121a1 1 0 0 1-.074-.086l-1.073 1.073q.045.032.086.074l1.414 1.414a.75.75 0 0 1-1.06 1.06L3.69 13.238a1 1 0 0 1-.073-.085C2.539 14.24 2 14.862 2 15.616"
      />
    </svg>
    <svg
      v-else-if="name === 'ruler_square'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 16 16"
    >
      <path
        :fill="color"
        d="M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v-1H2v-1h4v-1H4v-1h2v-1H2v-1h4V9H4V8h2V7H2V6h4V2h1v4h1V4h1v2h1V2h1v4h1V4h1v2h1V2h1v4h1V1a1 1 0 0 0-1-1z"
      />
    </svg>
    <svg
      v-else-if="name === 'circle-ruler'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 26 26"
    >
      <g :fill="color" fill-rule="evenodd" clip-rule="evenodd">
        <path
          d="M4.25 18.392a2 2 0 0 1 0-2.828L15.564 4.25a2 2 0 0 1 2.828 0l3.536 3.536a2 2 0 0 1 0 2.828L10.614 21.928a2 2 0 0 1-2.828 0zm2.121-2.121l-.707.707L9.2 20.513L20.514 9.2l-3.536-3.536l-.707.707l1.355 1.356a1 1 0 0 1-1.414 1.414l-1.355-1.355l-.707.707l.53.53a1 1 0 0 1-1.414 1.414l-.53-.53l-.708.707l1.355 1.355a1 1 0 1 1-1.414 1.414l-1.355-1.355l-.707.707l.53.53a1 1 0 1 1-1.414 1.415l-.53-.53l-.707.707l1.355 1.355a1 1 0 1 1-1.414 1.414z"
        />
        <path
          d="M13 24c6.075 0 11-4.925 11-11S19.075 2 13 2S2 6.925 2 13s4.925 11 11 11m0 2c7.18 0 13-5.82 13-13S20.18 0 13 0S0 5.82 0 13s5.82 13 13 13"
        />
      </g>
    </svg>
    <svg
      v-else-if="name === 'not_allowed'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M19.775 22.625L17.5 20.35q-1.225.8-2.612 1.225T12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12q0-1.5.425-2.887T3.65 6.5L1.375 4.225L2.8 2.8l18.4 18.4zM7 13h3.15l-2-2H7zm13.35 4.5l-4.5-4.5H17v-2h-3.15L6.5 3.65q1.225-.8 2.613-1.225T12 2q2.075 0 3.9.788t3.175 2.137T21.213 8.1T22 12q0 1.5-.425 2.888T20.35 17.5"
      />
    </svg>
    <svg
      v-else-if="name === 'polygon'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 14 14"
    >
      <path
        :fill="color"
        fill-rule="evenodd"
        d="M4.914 0a1.5 1.5 0 0 0-1.06.44L.439 3.853A1.5 1.5 0 0 0 0 4.914v4.172c0 .398.158.78.44 1.06l3.414 3.415a1.5 1.5 0 0 0 1.06.439h4.172a1.5 1.5 0 0 0 1.06-.44l3.415-3.414A1.5 1.5 0 0 0 14 9.086V4.914a1.5 1.5 0 0 0-.44-1.06L10.147.439A1.5 1.5 0 0 0 9.086 0z"
        clip-rule="evenodd"
      />
    </svg>
    <svg
      v-else-if="name === 'geofence'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 256 256"
    >
      <path
        :fill="color"
        d="M230.64 49.36a32 32 0 0 0-45.26 0a32 32 0 0 0-5.16 6.76L152 48.42a32 32 0 0 0-54.63-23.06a32.06 32.06 0 0 0-5.76 37.41L57.67 93.32a32.05 32.05 0 0 0-40.31 4.05a32 32 0 0 0 42.89 47.41l70 51.36a32 32 0 1 0 47.57-14.69l27.39-77.59q1.38.12 2.76.12a32 32 0 0 0 22.63-54.62Zm-122-12.69a16 16 0 1 1 0 22.64a16 16 0 0 1 .04-22.64Zm-80 94.65a16 16 0 0 1 0-22.64a16 16 0 1 1 0 22.64m142.65 88a16 16 0 0 1-22.63-22.63a16 16 0 1 1 22.63 22.63m-8.55-43.18a32 32 0 0 0-23 7.08l-70-51.36a32.17 32.17 0 0 0-1.34-26.65l33.95-30.55a32 32 0 0 0 45.47-10.81L176 71.56a32 32 0 0 0 14.12 27ZM219.3 83.3a16 16 0 1 1-22.6-22.62a16 16 0 0 1 22.63 22.63Z"
      />
    </svg>
    <svg
      v-else-if="name === 'geofence-circle'"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        :fill="color"
        d="M20 14.185v-2.369A3 3 0 0 0 22 9c0-1.654-1.346-3-3-3a3 3 0 0 0-2.116.876L12.969 5.31c.01-.103.031-.204.031-.31c0-1.654-1.346-3-3-3S7 3.346 7 5c0 .762.295 1.451.765 1.981L6.091 9.212A3 3 0 0 0 5 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.159 0 .313-.023.465-.047L7.4 17.532c-.248.436-.4.932-.4 1.468c0 1.654 1.346 3 3 3a2.99 2.99 0 0 0 2.863-2.153l3.962-.792A3 3 0 0 0 19 20c1.654 0 3-1.346 3-3a2.995 2.995 0 0 0-2-2.815M19 8a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1m-9-4a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1m-6 8a1.001 1.001 0 1 1 1 1c-.552 0-1-.449-1-1m6 8a1 1 0 1 1 0-2a1 1 0 0 1 0 2m2.761-2.172A3 3 0 0 0 10 16c-.386 0-.752.079-1.091.213l-1.674-2.231C7.705 13.451 8 12.762 8 12c0-.536-.152-1.032-.399-1.467l1.935-2.58c.152.024.305.047.464.047a3 3 0 0 0 2.116-.876l3.915 1.566c-.01.103-.031.204-.031.31c0 1.302.839 2.401 2 2.815v2.369a3 3 0 0 0-2 2.815c0 .061.015.117.018.177zM19 18a1 1 0 1 1 0-2a1 1 0 0 1 0 2"
      />
    </svg>
    <svg
      v-else-if="name === 'curved_line'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 15 15"
    >
      <path
        :fill="color"
        fill-rule="evenodd"
        d="M9.877 12H11.5a.5.5 0 0 0 0-1H9.9c-1.128 0-1.945 0-2.586-.053c-.637-.052-1.057-.152-1.403-.328a3.5 3.5 0 0 1-1.53-1.53c-.176-.346-.276-.766-.328-1.403C4 7.045 4 6.228 4 5.1V3.5a.5.5 0 0 0-1 0v1.623c0 1.1 0 1.958.056 2.645c.057.698.175 1.265.434 1.775a4.5 4.5 0 0 0 1.967 1.967c.51.26 1.077.377 1.775.434C7.92 12 8.776 12 9.877 12"
        clip-rule="evenodd"
      />
    </svg>
    <svg
      v-else-if="name === 'orbit'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 512 512"
    >
      <path
        :fill="color"
        d="M255.6 62.21c-25.1 0-50.7 5.02-75.3 15.48C81.74 119.5 35.86 233.1 77.69 331.7c4.76 11.1 10.45 21.7 16.93 31.5c-12.6.3-23.45-.5-31.98-2.4c-13.22-2.9-19.93-7.8-22.27-13.3c-2.33-5.6-1.25-13.8 5.87-25.4c1.65-2.6 3.62-5.4 5.86-8.4c-2.1-7.4-3.76-14.7-5.05-22.2c-6.62 7.1-12.1 14.2-16.37 21.1c-8.74 14.1-12.66 28.9-7.11 42c5.54 13.1 18.9 20.5 35.17 24c13.66 3 30.13 3.6 48.96 2.2c53.2 63.4 143.6 87.6 223.9 53.4c80.3-34.1 125.6-115.7 117.1-198.1c14.1-12.6 25.2-24.9 32.5-36.8c8.9-14.2 12.7-29 7.2-42c-5.6-13.1-18.9-20.5-35.2-24.1c-7.9-1.7-16.9-2.7-26.5-2.8c4.5 6.1 8.6 12.4 12.4 19.1c3.7.4 7.1.9 10.1 1.6c13.3 2.8 20 7.8 22.3 13.3c2.4 5.5 1.3 13.8-5.9 25.3c-4.5 7.4-11.4 15.8-20.4 24.7c1.5 7.3 2.7 14.5 3.4 21.7c-2.6 2.3-5.5 4.7-8.2 7.1c-4.7 3.8-9.5 7.7-14.7 11.5c11.2 32-4.4 67.8-35.9 81.2c-26.3 11.2-56 3.6-74-16.8c-9.1 4.3-18.3 8.4-27.8 12.5c-62.5 26.4-122.4 43-169.2 48.1c-3.8.4-7.5.7-11 1.1c-4.7-5.6-8.95-11.4-13.12-17.6c6.82-.2 14.22-.7 22.02-1.6c44.4-4.9 103-20.9 164.2-46.9c8.4-3.5 16.7-7.3 24.8-11c-.4-.7-.7-1.4-1-2.1c-14-32.9 1.5-71.2 34.4-85.1c28.3-12.1 60.7-2.1 78 21.8c4-3.1 7.9-6.1 11.5-9.1c6.1-5 11.6-10 16.6-14.8c-2.6-11.5-6.2-22.9-11-34.1c-31.4-73.9-103.1-118.22-178.6-118.09M364.3 229.6c-5.9 0-12.1 1.2-18.1 3.7c-23.7 10.1-34.8 37.3-24.6 61.2c10 23.8 37.3 34.7 61.1 24.6c23.7-10 34.8-37.3 24.6-61.1c-7.5-17.9-24.7-28.5-43-28.4"
      />
    </svg>
    <!-- ── Onboarding icons (FLY3D-590) ──────────────────────────────── -->
    <svg
      v-else-if="name === 'arrR'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 12h14M13 5l7 7-7 7"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'arrL'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 12H5M12 19l-7-7 7-7"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'users'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'bolt'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'radio'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 12m-2 0a2 2 0 104 0 2 2 0 10-4 0M8.5 8.5a5 5 0 000 7M15.5 8.5a5 5 0 010 7M5 5a10 10 0 000 14M19 5a10 10 0 010 14"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- ── Access & Sharing settings icons (FLY3D-914) ────────────────── -->
    <svg
      v-else-if="name === 'code'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 18l6-6-6-6M8 6l-6 6 6 6"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'resource'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M3 9h18"
        :stroke="color"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'access_revoked'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="9" :stroke="color" stroke-width="1.8" />
      <path
        d="M5.6 5.6l12.8 12.8"
        :stroke="color"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'pin_off'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7z M9 9l6 6M15 9l-6 6"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="name === 'user_plus'"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="9" cy="8" r="3.6" :stroke="color" stroke-width="1.8" />
      <path
        d="M16 11h6M19 8v6M3.5 19a5.5 5.5 0 0 1 11 0"
        :stroke="color"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<style scoped>
.icon-component {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
  height: fit-content;
  line-height: 1;
  cursor: pointer;
}
.rounded {
  border-width: 1.5px;
  border-style: solid;
  border-color: v-bind(color);
  border-radius: 50%;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  cursor: pointer;
  aspect-ratio: 1 / 1;
}
#badge {
  width: 0.75em;
  height: 0.75em;
  position: absolute;
  border-radius: 50%;
  right: 0;
  top: 0;
}

.opacity {
  opacity: 0.5;
}
</style>
